import * as h from "react";
import Ke, { Children as sa, isValidElement as dn, cloneElement as fn } from "react";
import { P as o, _ as b, g as xe, w as aa, s as la, x as wn, y as Or, i as Nr, z as co, A as $r, B as Ci, D as Oi, E as Ni, k as $i, h as ki, b as q, F as ua, G as Mi, H as Ii, d as fe, c as _i, j as Qt, a as yn, f as kr, I as ji, J as ca, K as qt, n as da, u as fa } from "./createTheme-6e68f5ca.js";
import { jsx as B, jsxs as ze } from "react/jsx-runtime";
import * as Ai from "react-dom";
import on from "react-dom";
function ot(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...r) {
    return e(...r) || t(...r);
  };
}
function pa(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function Di(e, t, n, r, i) {
  const s = e[t], a = i || t;
  if (s == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let l;
  const u = s.type;
  return typeof u == "function" && !pa(u) && (l = "Did you accidentally use a plain function component for an element instead?"), l !== void 0 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an element that can hold a ref. ${l} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Fi = ot(o.element, Di);
Fi.isRequired = ot(o.element.isRequired, Di);
const Cn = Fi;
function ha(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function ma(e, t, n, r, i) {
  const s = e[t], a = i || t;
  if (s == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let l;
  return typeof s == "function" && !ha(s) && (l = "Did you accidentally provide a plain function component instead?"), l !== void 0 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an element type that can hold a ref. ${l} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Mr = ot(o.elementType, ma);
var or = { exports: {} }, re = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fo;
function va() {
  if (fo)
    return re;
  fo = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), g;
  g = Symbol.for("react.module.reference");
  function E(v) {
    if (typeof v == "object" && v !== null) {
      var P = v.$$typeof;
      switch (P) {
        case e:
          switch (v = v.type, v) {
            case n:
            case i:
            case r:
            case c:
            case d:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case l:
                case a:
                case u:
                case x:
                case f:
                case s:
                  return v;
                default:
                  return P;
              }
          }
        case t:
          return P;
      }
    }
  }
  return re.ContextConsumer = a, re.ContextProvider = s, re.Element = e, re.ForwardRef = u, re.Fragment = n, re.Lazy = x, re.Memo = f, re.Portal = t, re.Profiler = i, re.StrictMode = r, re.Suspense = c, re.SuspenseList = d, re.isAsyncMode = function() {
    return !1;
  }, re.isConcurrentMode = function() {
    return !1;
  }, re.isContextConsumer = function(v) {
    return E(v) === a;
  }, re.isContextProvider = function(v) {
    return E(v) === s;
  }, re.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === e;
  }, re.isForwardRef = function(v) {
    return E(v) === u;
  }, re.isFragment = function(v) {
    return E(v) === n;
  }, re.isLazy = function(v) {
    return E(v) === x;
  }, re.isMemo = function(v) {
    return E(v) === f;
  }, re.isPortal = function(v) {
    return E(v) === t;
  }, re.isProfiler = function(v) {
    return E(v) === i;
  }, re.isStrictMode = function(v) {
    return E(v) === r;
  }, re.isSuspense = function(v) {
    return E(v) === c;
  }, re.isSuspenseList = function(v) {
    return E(v) === d;
  }, re.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === n || v === i || v === r || v === c || v === d || v === y || typeof v == "object" && v !== null && (v.$$typeof === x || v.$$typeof === f || v.$$typeof === s || v.$$typeof === a || v.$$typeof === u || v.$$typeof === g || v.getModuleId !== void 0);
  }, re.typeOf = E, re;
}
var oe = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var po;
function ya() {
  return po || (po = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), g = !1, E = !1, v = !1, P = !1, C = !1, R;
    R = Symbol.for("react.module.reference");
    function m(O) {
      return !!(typeof O == "string" || typeof O == "function" || O === n || O === i || C || O === r || O === c || O === d || P || O === y || g || E || v || typeof O == "object" && O !== null && (O.$$typeof === x || O.$$typeof === f || O.$$typeof === s || O.$$typeof === a || O.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      O.$$typeof === R || O.getModuleId !== void 0));
    }
    function p(O) {
      if (typeof O == "object" && O !== null) {
        var Z = O.$$typeof;
        switch (Z) {
          case e:
            var ve = O.type;
            switch (ve) {
              case n:
              case i:
              case r:
              case c:
              case d:
                return ve;
              default:
                var Re = ve && ve.$$typeof;
                switch (Re) {
                  case l:
                  case a:
                  case u:
                  case x:
                  case f:
                  case s:
                    return Re;
                  default:
                    return Z;
                }
            }
          case t:
            return Z;
        }
      }
    }
    var S = a, w = s, N = e, M = u, $ = n, _ = x, D = f, j = t, V = i, F = r, k = c, L = d, A = !1, U = !1;
    function J(O) {
      return A || (A = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function be(O) {
      return U || (U = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function le(O) {
      return p(O) === a;
    }
    function he(O) {
      return p(O) === s;
    }
    function X(O) {
      return typeof O == "object" && O !== null && O.$$typeof === e;
    }
    function Q(O) {
      return p(O) === u;
    }
    function ne(O) {
      return p(O) === n;
    }
    function me(O) {
      return p(O) === x;
    }
    function pe(O) {
      return p(O) === f;
    }
    function ue(O) {
      return p(O) === t;
    }
    function ye(O) {
      return p(O) === i;
    }
    function K(O) {
      return p(O) === r;
    }
    function I(O) {
      return p(O) === c;
    }
    function H(O) {
      return p(O) === d;
    }
    oe.ContextConsumer = S, oe.ContextProvider = w, oe.Element = N, oe.ForwardRef = M, oe.Fragment = $, oe.Lazy = _, oe.Memo = D, oe.Portal = j, oe.Profiler = V, oe.StrictMode = F, oe.Suspense = k, oe.SuspenseList = L, oe.isAsyncMode = J, oe.isConcurrentMode = be, oe.isContextConsumer = le, oe.isContextProvider = he, oe.isElement = X, oe.isForwardRef = Q, oe.isFragment = ne, oe.isLazy = me, oe.isMemo = pe, oe.isPortal = ue, oe.isProfiler = ye, oe.isStrictMode = K, oe.isSuspense = I, oe.isSuspenseList = H, oe.isValidElementType = m, oe.typeOf = p;
  }()), oe;
}
process.env.NODE_ENV === "production" ? or.exports = va() : or.exports = ya();
var Yt = or.exports;
const ga = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function ba(e) {
  const t = `${e}`.match(ga);
  return t && t[1] || "";
}
function Vi(e, t = "") {
  return e.displayName || e.name || ba(e) || t;
}
function ho(e, t, n) {
  const r = Vi(t);
  return e.displayName || (r !== "" ? `${n}(${r})` : n);
}
function pn(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return Vi(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case Yt.ForwardRef:
          return ho(e, e.render, "ForwardRef");
        case Yt.Memo:
          return ho(e, e.type, "memo");
        default:
          return;
      }
  }
}
function Ge(e, t, n, r, i) {
  if (process.env.NODE_ENV === "production")
    return null;
  const s = e[t], a = i || t;
  return s == null ? null : s && s.nodeType !== 1 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an HTMLElement.`) : null;
}
const xa = o.oneOfType([o.func, o.object]), Ye = xa;
function mo(...e) {
  return e.reduce((t, n) => n == null ? t : function(...i) {
    t.apply(this, i), n.apply(this, i);
  }, () => {
  });
}
function Li(e, t = 166) {
  let n;
  function r(...i) {
    const s = () => {
      e.apply(this, i);
    };
    clearTimeout(n), n = setTimeout(s, t);
  }
  return r.clear = () => {
    clearTimeout(n);
  }, r;
}
function hm(e, t) {
  var n, r;
  return /* @__PURE__ */ h.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (n = e.type.muiName) != null ? n : (r = e.type) == null || (r = r._payload) == null || (r = r.value) == null ? void 0 : r.muiName
  ) !== -1;
}
function $e(e) {
  return e && e.ownerDocument || document;
}
function pt(e) {
  return $e(e).defaultView || window;
}
function ir(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const Ea = typeof window < "u" ? h.useLayoutEffect : h.useEffect, Xe = Ea;
let vo = 0;
function Ra(e) {
  const [t, n] = h.useState(e), r = e || t;
  return h.useEffect(() => {
    t == null && (vo += 1, n(`mui-${vo}`));
  }, [t]), r;
}
const yo = h["useId".toString()];
function Sa(e) {
  if (yo !== void 0) {
    const t = yo();
    return e ?? t;
  }
  return Ra(e);
}
function go({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: i
  } = h.useRef(e !== void 0), [s, a] = h.useState(t), l = i ? e : s;
  if (process.env.NODE_ENV !== "production") {
    h.useEffect(() => {
      i !== (e !== void 0) && console.error([`MUI: A component is changing the ${i ? "" : "un"}controlled ${r} state of ${n} to be ${i ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: c
    } = h.useRef(t);
    h.useEffect(() => {
      !i && c !== t && console.error([`MUI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const u = h.useCallback((c) => {
    i || a(c);
  }, []);
  return [l, u];
}
function St(e) {
  const t = h.useRef(e);
  return Xe(() => {
    t.current = e;
  }), h.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function Ce(...e) {
  return h.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      ir(n, t);
    });
  }, e);
}
class Ir {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new Ir();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
}
let On = !0, sr = !1;
const Pa = new Ir(), Ta = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function wa(e) {
  const {
    type: t,
    tagName: n
  } = e;
  return !!(n === "INPUT" && Ta[t] && !e.readOnly || n === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function Ca(e) {
  e.metaKey || e.altKey || e.ctrlKey || (On = !0);
}
function Un() {
  On = !1;
}
function Oa() {
  this.visibilityState === "hidden" && sr && (On = !0);
}
function Na(e) {
  e.addEventListener("keydown", Ca, !0), e.addEventListener("mousedown", Un, !0), e.addEventListener("pointerdown", Un, !0), e.addEventListener("touchstart", Un, !0), e.addEventListener("visibilitychange", Oa, !0);
}
function $a(e) {
  const {
    target: t
  } = e;
  try {
    return t.matches(":focus-visible");
  } catch {
  }
  return On || wa(t);
}
function ka() {
  const e = h.useCallback((i) => {
    i != null && Na(i.ownerDocument);
  }, []), t = h.useRef(!1);
  function n() {
    return t.current ? (sr = !0, Pa.start(100, () => {
      sr = !1;
    }), t.current = !1, !0) : !1;
  }
  function r(i) {
    return $a(i) ? (t.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: t,
    onFocus: r,
    onBlur: n,
    ref: e
  };
}
function Bi(e) {
  const t = e.documentElement.clientWidth;
  return Math.abs(window.innerWidth - t);
}
const Ma = (e) => {
  const t = h.useRef({});
  return h.useEffect(() => {
    t.current = e;
  }), t.current;
}, mm = Ma;
function Ia(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function _a(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
const ja = Number.isInteger || _a;
function zi(e, t, n, r) {
  const i = e[t];
  if (i == null || !ja(i)) {
    const s = Ia(i);
    return new RangeError(`Invalid ${r} \`${t}\` of type \`${s}\` supplied to \`${n}\`, expected \`integer\`.`);
  }
  return null;
}
function Ui(e, t, ...n) {
  return e[t] === void 0 ? null : zi(e, t, ...n);
}
function ar() {
  return null;
}
Ui.isRequired = zi;
ar.isRequired = ar;
const Wi = process.env.NODE_ENV === "production" ? ar : Ui;
function Hi(e, t) {
  const n = b({}, t);
  return Object.keys(e).forEach((r) => {
    if (r.toString().match(/^(components|slots)$/))
      n[r] = b({}, e[r], n[r]);
    else if (r.toString().match(/^(componentsProps|slotProps)$/)) {
      const i = e[r] || {}, s = t[r];
      n[r] = {}, !s || !Object.keys(s) ? n[r] = i : !i || !Object.keys(i) ? n[r] = s : (n[r] = b({}, s), Object.keys(i).forEach((a) => {
        n[r][a] = Hi(i[a], s[a]);
      }));
    } else
      n[r] === void 0 && (n[r] = e[r]);
  }), n;
}
function Se(e, t, n = void 0) {
  const r = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (i) => {
      r[i] = e[i].reduce((s, a) => {
        if (a) {
          const l = t(a);
          l !== "" && s.push(l), n && n[a] && s.push(n[a]);
        }
        return s;
      }, []).join(" ");
    }
  ), r;
}
function Ee(e, t, n = "Mui") {
  const r = {};
  return t.forEach((i) => {
    r[i] = xe(e, i, n);
  }), r;
}
var Aa = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Da = /* @__PURE__ */ aa(
  function(e) {
    return Aa.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), lr = { exports: {} }, ie = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bo;
function Fa() {
  if (bo)
    return ie;
  bo = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, x = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, P = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
  function R(p) {
    if (typeof p == "object" && p !== null) {
      var S = p.$$typeof;
      switch (S) {
        case t:
          switch (p = p.type, p) {
            case u:
            case c:
            case r:
            case s:
            case i:
            case f:
              return p;
            default:
              switch (p = p && p.$$typeof, p) {
                case l:
                case d:
                case g:
                case y:
                case a:
                  return p;
                default:
                  return S;
              }
          }
        case n:
          return S;
      }
    }
  }
  function m(p) {
    return R(p) === c;
  }
  return ie.AsyncMode = u, ie.ConcurrentMode = c, ie.ContextConsumer = l, ie.ContextProvider = a, ie.Element = t, ie.ForwardRef = d, ie.Fragment = r, ie.Lazy = g, ie.Memo = y, ie.Portal = n, ie.Profiler = s, ie.StrictMode = i, ie.Suspense = f, ie.isAsyncMode = function(p) {
    return m(p) || R(p) === u;
  }, ie.isConcurrentMode = m, ie.isContextConsumer = function(p) {
    return R(p) === l;
  }, ie.isContextProvider = function(p) {
    return R(p) === a;
  }, ie.isElement = function(p) {
    return typeof p == "object" && p !== null && p.$$typeof === t;
  }, ie.isForwardRef = function(p) {
    return R(p) === d;
  }, ie.isFragment = function(p) {
    return R(p) === r;
  }, ie.isLazy = function(p) {
    return R(p) === g;
  }, ie.isMemo = function(p) {
    return R(p) === y;
  }, ie.isPortal = function(p) {
    return R(p) === n;
  }, ie.isProfiler = function(p) {
    return R(p) === s;
  }, ie.isStrictMode = function(p) {
    return R(p) === i;
  }, ie.isSuspense = function(p) {
    return R(p) === f;
  }, ie.isValidElementType = function(p) {
    return typeof p == "string" || typeof p == "function" || p === r || p === c || p === s || p === i || p === f || p === x || typeof p == "object" && p !== null && (p.$$typeof === g || p.$$typeof === y || p.$$typeof === a || p.$$typeof === l || p.$$typeof === d || p.$$typeof === v || p.$$typeof === P || p.$$typeof === C || p.$$typeof === E);
  }, ie.typeOf = R, ie;
}
var se = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xo;
function Va() {
  return xo || (xo = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, x = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, P = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
    function R(I) {
      return typeof I == "string" || typeof I == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      I === r || I === c || I === s || I === i || I === f || I === x || typeof I == "object" && I !== null && (I.$$typeof === g || I.$$typeof === y || I.$$typeof === a || I.$$typeof === l || I.$$typeof === d || I.$$typeof === v || I.$$typeof === P || I.$$typeof === C || I.$$typeof === E);
    }
    function m(I) {
      if (typeof I == "object" && I !== null) {
        var H = I.$$typeof;
        switch (H) {
          case t:
            var O = I.type;
            switch (O) {
              case u:
              case c:
              case r:
              case s:
              case i:
              case f:
                return O;
              default:
                var Z = O && O.$$typeof;
                switch (Z) {
                  case l:
                  case d:
                  case g:
                  case y:
                  case a:
                    return Z;
                  default:
                    return H;
                }
            }
          case n:
            return H;
        }
      }
    }
    var p = u, S = c, w = l, N = a, M = t, $ = d, _ = r, D = g, j = y, V = n, F = s, k = i, L = f, A = !1;
    function U(I) {
      return A || (A = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), J(I) || m(I) === u;
    }
    function J(I) {
      return m(I) === c;
    }
    function be(I) {
      return m(I) === l;
    }
    function le(I) {
      return m(I) === a;
    }
    function he(I) {
      return typeof I == "object" && I !== null && I.$$typeof === t;
    }
    function X(I) {
      return m(I) === d;
    }
    function Q(I) {
      return m(I) === r;
    }
    function ne(I) {
      return m(I) === g;
    }
    function me(I) {
      return m(I) === y;
    }
    function pe(I) {
      return m(I) === n;
    }
    function ue(I) {
      return m(I) === s;
    }
    function ye(I) {
      return m(I) === i;
    }
    function K(I) {
      return m(I) === f;
    }
    se.AsyncMode = p, se.ConcurrentMode = S, se.ContextConsumer = w, se.ContextProvider = N, se.Element = M, se.ForwardRef = $, se.Fragment = _, se.Lazy = D, se.Memo = j, se.Portal = V, se.Profiler = F, se.StrictMode = k, se.Suspense = L, se.isAsyncMode = U, se.isConcurrentMode = J, se.isContextConsumer = be, se.isContextProvider = le, se.isElement = he, se.isForwardRef = X, se.isFragment = Q, se.isLazy = ne, se.isMemo = me, se.isPortal = pe, se.isProfiler = ue, se.isStrictMode = ye, se.isSuspense = K, se.isValidElementType = R, se.typeOf = m;
  }()), se;
}
process.env.NODE_ENV === "production" ? lr.exports = Fa() : lr.exports = Va();
var La = lr.exports, _r = La, Ba = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, za = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, Ua = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, qi = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, jr = {};
jr[_r.ForwardRef] = Ua;
jr[_r.Memo] = qi;
function Eo(e) {
  return _r.isMemo(e) ? qi : jr[e.$$typeof] || Ba;
}
var Wa = Object.defineProperty, Ha = Object.getOwnPropertyNames, Ro = Object.getOwnPropertySymbols, qa = Object.getOwnPropertyDescriptor, Ya = Object.getPrototypeOf, So = Object.prototype;
function Yi(e, t, n) {
  if (typeof t != "string") {
    if (So) {
      var r = Ya(t);
      r && r !== So && Yi(e, r, n);
    }
    var i = Ha(t);
    Ro && (i = i.concat(Ro(t)));
    for (var s = Eo(e), a = Eo(t), l = 0; l < i.length; ++l) {
      var u = i[l];
      if (!za[u] && !(n && n[u]) && !(a && a[u]) && !(s && s[u])) {
        var c = qa(t, u);
        try {
          Wa(e, u, c);
        } catch {
        }
      }
    }
  }
  return e;
}
var Ka = Yi;
const vm = /* @__PURE__ */ la(Ka);
var Ga = {
  name: "@emotion/react",
  version: "11.11.1",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  exports: {
    ".": {
      module: {
        worker: "./dist/emotion-react.worker.esm.js",
        browser: "./dist/emotion-react.browser.esm.js",
        default: "./dist/emotion-react.esm.js"
      },
      import: "./dist/emotion-react.cjs.mjs",
      default: "./dist/emotion-react.cjs.js"
    },
    "./jsx-runtime": {
      module: {
        worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
        browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
        default: "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
      },
      import: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
      default: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
    },
    "./_isolated-hnrs": {
      module: {
        worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
        browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
        default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
      },
      import: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
      default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
    },
    "./jsx-dev-runtime": {
      module: {
        worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
        browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
        default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
      },
      import: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
      default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
    },
    "./package.json": "./package.json",
    "./types/css-prop": "./types/css-prop.d.ts",
    "./macro": {
      types: {
        import: "./macro.d.mts",
        default: "./macro.d.ts"
      },
      default: "./macro.js"
    }
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "_isolated-hnrs",
    "types/*.d.ts",
    "macro.*"
  ],
  sideEffects: !1,
  author: "Emotion Contributors",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.18.3",
    "@emotion/babel-plugin": "^11.11.0",
    "@emotion/cache": "^11.11.0",
    "@emotion/serialize": "^1.1.2",
    "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
    "@emotion/utils": "^1.2.1",
    "@emotion/weak-memoize": "^0.3.1",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@types/react": {
      optional: !0
    }
  },
  devDependencies: {
    "@definitelytyped/dtslint": "0.0.112",
    "@emotion/css": "11.11.0",
    "@emotion/css-prettifier": "1.1.3",
    "@emotion/server": "11.11.0",
    "@emotion/styled": "11.11.0",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1",
    typescript: "^4.5.5"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./_isolated-hnrs.js"
    ],
    umdName: "emotionReact",
    exports: {
      envConditions: [
        "browser",
        "worker"
      ],
      extra: {
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
          types: {
            import: "./macro.d.mts",
            default: "./macro.d.ts"
          },
          default: "./macro.js"
        }
      }
    }
  }
}, Po = !1, Ki = /* @__PURE__ */ Or(function(e, t) {
  process.env.NODE_ENV !== "production" && !Po && // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  (e.className || e.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), Po = !0);
  var n = e.styles, r = wn([n], void 0, h.useContext(Nr)), i = h.useRef();
  return co(function() {
    var s = t.key + "-global", a = new t.sheet.constructor({
      key: s,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), l = !1, u = document.querySelector('style[data-emotion="' + s + " " + r.name + '"]');
    return t.sheet.tags.length && (a.before = t.sheet.tags[0]), u !== null && (l = !0, u.setAttribute("data-emotion", s), a.hydrate([u])), i.current = [a, l], function() {
      a.flush();
    };
  }, [t]), co(function() {
    var s = i.current, a = s[0], l = s[1];
    if (l) {
      s[1] = !1;
      return;
    }
    if (r.next !== void 0 && $r(t, r.next, !0), a.tags.length) {
      var u = a.tags[a.tags.length - 1].nextElementSibling;
      a.before = u, a.flush();
    }
    t.insert("", r, a, !1);
  }, [t, r.name]), null;
});
process.env.NODE_ENV !== "production" && (Ki.displayName = "EmotionGlobal");
function Ar() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return wn(t);
}
var en = function() {
  var t = Ar.apply(void 0, arguments), n = "animation-" + t.name;
  return {
    name: n,
    styles: "@keyframes " + n + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, Xa = function e(t) {
  for (var n = t.length, r = 0, i = ""; r < n; r++) {
    var s = t[r];
    if (s != null) {
      var a = void 0;
      switch (typeof s) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(s))
            a = e(s);
          else {
            process.env.NODE_ENV !== "production" && s.styles !== void 0 && s.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), a = "";
            for (var l in s)
              s[l] && l && (a && (a += " "), a += l);
          }
          break;
        }
        default:
          a = s;
      }
      a && (i && (i += " "), i += a);
    }
  }
  return i;
};
function Ja(e, t, n) {
  var r = [], i = Ni(e, r, n);
  return r.length < 2 ? n : i + t(r);
}
var Za = function(t) {
  var n = t.cache, r = t.serializedArr;
  return Ci(function() {
    for (var i = 0; i < r.length; i++)
      $r(n, r[i], !1);
  }), null;
}, Qa = /* @__PURE__ */ Or(function(e, t) {
  var n = !1, r = [], i = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("css can only be used during render");
    for (var c = arguments.length, d = new Array(c), f = 0; f < c; f++)
      d[f] = arguments[f];
    var x = wn(d, t.registered);
    return r.push(x), Oi(t, x, !1), t.key + "-" + x.name;
  }, s = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("cx can only be used during render");
    for (var c = arguments.length, d = new Array(c), f = 0; f < c; f++)
      d[f] = arguments[f];
    return Ja(t.registered, i, Xa(d));
  }, a = {
    css: i,
    cx: s,
    theme: h.useContext(Nr)
  }, l = e.children(a);
  return n = !0, /* @__PURE__ */ h.createElement(h.Fragment, null, /* @__PURE__ */ h.createElement(Za, {
    cache: t,
    serializedArr: r
  }), l);
});
process.env.NODE_ENV !== "production" && (Qa.displayName = "EmotionClassNames");
if (process.env.NODE_ENV !== "production") {
  var To = !0, el = typeof jest < "u" || typeof vi < "u";
  if (To && !el) {
    var wo = (
      // $FlowIgnore
      typeof globalThis < "u" ? globalThis : To ? window : global
    ), Co = "__EMOTION_REACT_" + Ga.version.split(".")[0] + "__";
    wo[Co] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), wo[Co] = !0;
  }
}
var tl = Da, nl = function(t) {
  return t !== "theme";
}, Oo = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? tl : nl;
}, No = function(t, n, r) {
  var i;
  if (n) {
    var s = n.shouldForwardProp;
    i = t.__emotion_forwardProp && s ? function(a) {
      return t.__emotion_forwardProp(a) && s(a);
    } : s;
  }
  return typeof i != "function" && r && (i = t.__emotion_forwardProp), i;
}, $o = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, rl = function(t) {
  var n = t.cache, r = t.serialized, i = t.isStringTag;
  return Oi(n, r, i), Ci(function() {
    return $r(n, r, i);
  }), null;
}, ol = function e(t, n) {
  if (process.env.NODE_ENV !== "production" && t === void 0)
    throw new Error(`You are trying to create a styled element with an undefined component.
You may have forgotten to import it.`);
  var r = t.__emotion_real === t, i = r && t.__emotion_base || t, s, a;
  n !== void 0 && (s = n.label, a = n.target);
  var l = No(t, n, r), u = l || Oo(i), c = !u("as");
  return function() {
    var d = arguments, f = r && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (s !== void 0 && f.push("label:" + s + ";"), d[0] == null || d[0].raw === void 0)
      f.push.apply(f, d);
    else {
      process.env.NODE_ENV !== "production" && d[0][0] === void 0 && console.error($o), f.push(d[0][0]);
      for (var x = d.length, y = 1; y < x; y++)
        process.env.NODE_ENV !== "production" && d[0][y] === void 0 && console.error($o), f.push(d[y], d[0][y]);
    }
    var g = Or(function(E, v, P) {
      var C = c && E.as || i, R = "", m = [], p = E;
      if (E.theme == null) {
        p = {};
        for (var S in E)
          p[S] = E[S];
        p.theme = h.useContext(Nr);
      }
      typeof E.className == "string" ? R = Ni(v.registered, m, E.className) : E.className != null && (R = E.className + " ");
      var w = wn(f.concat(m), v.registered, p);
      R += v.key + "-" + w.name, a !== void 0 && (R += " " + a);
      var N = c && l === void 0 ? Oo(C) : u, M = {};
      for (var $ in E)
        c && $ === "as" || // $FlowFixMe
        N($) && (M[$] = E[$]);
      return M.className = R, M.ref = P, /* @__PURE__ */ h.createElement(h.Fragment, null, /* @__PURE__ */ h.createElement(rl, {
        cache: v,
        serialized: w,
        isStringTag: typeof C == "string"
      }), /* @__PURE__ */ h.createElement(C, M));
    });
    return g.displayName = s !== void 0 ? s : "Styled(" + (typeof i == "string" ? i : i.displayName || i.name || "Component") + ")", g.defaultProps = t.defaultProps, g.__emotion_real = g, g.__emotion_base = i, g.__emotion_styles = f, g.__emotion_forwardProp = l, Object.defineProperty(g, "toString", {
      value: function() {
        return a === void 0 && process.env.NODE_ENV !== "production" ? "NO_COMPONENT_SELECTOR" : "." + a;
      }
    }), g.withComponent = function(E, v) {
      return e(E, b({}, n, v, {
        shouldForwardProp: No(g, v, !0)
      })).apply(void 0, f);
    }, g;
  };
}, il = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], ur = ol.bind();
il.forEach(function(e) {
  ur[e] = ur(e);
});
function sl(e) {
  return e == null || Object.keys(e).length === 0;
}
function Gi(e) {
  const {
    styles: t,
    defaultTheme: n = {}
  } = e;
  return /* @__PURE__ */ B(Ki, {
    styles: typeof t == "function" ? (i) => t(sl(i) ? n : i) : t
  });
}
process.env.NODE_ENV !== "production" && (Gi.propTypes = {
  defaultTheme: o.object,
  styles: o.oneOfType([o.array, o.string, o.object, o.func])
});
/**
 * @mui/styled-engine v5.15.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function Xi(e, t) {
  const n = ur(e, t);
  return process.env.NODE_ENV !== "production" ? (...r) => {
    const i = typeof e == "string" ? `"${e}"` : "component";
    return r.length === 0 ? console.error([`MUI: Seems like you called \`styled(${i})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : r.some((s) => s === void 0) && console.error(`MUI: the styled(${i})(...args) API requires all its args to be defined.`), n(...r);
  } : n;
}
const al = (e, t) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}, ll = $i();
function Nn(e = ll) {
  return ki(e);
}
function Ji({
  styles: e,
  themeId: t,
  defaultTheme: n = {}
}) {
  const r = Nn(n), i = typeof e == "function" ? e(t && r[t] || r) : e;
  return /* @__PURE__ */ B(Gi, {
    styles: i
  });
}
process.env.NODE_ENV !== "production" && (Ji.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: o.object,
  /**
   * @ignore
   */
  styles: o.oneOfType([o.array, o.func, o.number, o.object, o.string, o.bool]),
  /**
   * @ignore
   */
  themeId: o.string
});
const ul = ["sx"], cl = (e) => {
  var t, n;
  const r = {
    systemProps: {},
    otherProps: {}
  }, i = (t = e == null || (n = e.theme) == null ? void 0 : n.unstable_sxConfig) != null ? t : ua;
  return Object.keys(e).forEach((s) => {
    i[s] ? r.systemProps[s] = e[s] : r.otherProps[s] = e[s];
  }), r;
};
function Zi(e) {
  const {
    sx: t
  } = e, n = q(e, ul), {
    systemProps: r,
    otherProps: i
  } = cl(n);
  let s;
  return Array.isArray(t) ? s = [r, ...t] : typeof t == "function" ? s = (...a) => {
    const l = t(...a);
    return Mi(l) ? b({}, r, l) : r;
  } : s = b({}, r, t), b({}, i, {
    sx: s
  });
}
function Qi(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var i = e.length;
      for (t = 0; t < i; t++)
        e[t] && (n = Qi(e[t])) && (r && (r += " "), r += n);
    } else
      for (n in e)
        e[n] && (r && (r += " "), r += n);
  return r;
}
function ae() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++)
    (e = arguments[n]) && (t = Qi(e)) && (r && (r += " "), r += t);
  return r;
}
const dl = ["className", "component"];
function fl(e = {}) {
  const {
    themeId: t,
    defaultTheme: n,
    defaultClassName: r = "MuiBox-root",
    generateClassName: i
  } = e, s = Xi("div", {
    shouldForwardProp: (l) => l !== "theme" && l !== "sx" && l !== "as"
  })(Ii);
  return /* @__PURE__ */ h.forwardRef(function(u, c) {
    const d = Nn(n), f = Zi(u), {
      className: x,
      component: y = "div"
    } = f, g = q(f, dl);
    return /* @__PURE__ */ B(s, b({
      as: y,
      ref: c,
      className: ae(x, i ? i(r) : r),
      theme: t && d[t] || d
    }, g));
  });
}
const pl = ["ownerState"], hl = ["variants"], ml = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function vl(e) {
  return Object.keys(e).length === 0;
}
function yl(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function Lt(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const gl = $i(), ko = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function sn({
  defaultTheme: e,
  theme: t,
  themeId: n
}) {
  return vl(t) ? e : t[n] || t;
}
function bl(e) {
  return e ? (t, n) => n[e] : null;
}
function hn(e, t) {
  let {
    ownerState: n
  } = t, r = q(t, pl);
  const i = typeof e == "function" ? e(b({
    ownerState: n
  }, r)) : e;
  if (Array.isArray(i))
    return i.flatMap((s) => hn(s, b({
      ownerState: n
    }, r)));
  if (i && typeof i == "object" && Array.isArray(i.variants)) {
    const {
      variants: s = []
    } = i;
    let l = q(i, hl);
    return s.forEach((u) => {
      let c = !0;
      typeof u.props == "function" ? c = u.props(b({
        ownerState: n
      }, r, n)) : Object.keys(u.props).forEach((d) => {
        (n == null ? void 0 : n[d]) !== u.props[d] && r[d] !== u.props[d] && (c = !1);
      }), c && (Array.isArray(l) || (l = [l]), l.push(typeof u.style == "function" ? u.style(b({
        ownerState: n
      }, r, n)) : u.style));
    }), l;
  }
  return i;
}
function xl(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = gl,
    rootShouldForwardProp: r = Lt,
    slotShouldForwardProp: i = Lt
  } = e, s = (a) => Ii(b({}, a, {
    theme: sn(b({}, a, {
      defaultTheme: n,
      themeId: t
    }))
  }));
  return s.__mui_systemSx = !0, (a, l = {}) => {
    al(a, (p) => p.filter((S) => !(S != null && S.__mui_systemSx)));
    const {
      name: u,
      slot: c,
      skipVariantsResolver: d,
      skipSx: f,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: x = bl(ko(c))
    } = l, y = q(l, ml), g = d !== void 0 ? d : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      c && c !== "Root" && c !== "root" || !1
    ), E = f || !1;
    let v;
    process.env.NODE_ENV !== "production" && u && (v = `${u}-${ko(c || "Root")}`);
    let P = Lt;
    c === "Root" || c === "root" ? P = r : c ? P = i : yl(a) && (P = void 0);
    const C = Xi(a, b({
      shouldForwardProp: P,
      label: v
    }, y)), R = (p) => typeof p == "function" && p.__emotion_real !== p || Mi(p) ? (S) => hn(p, b({}, S, {
      theme: sn({
        theme: S.theme,
        defaultTheme: n,
        themeId: t
      })
    })) : p, m = (p, ...S) => {
      let w = R(p);
      const N = S ? S.map(R) : [];
      u && x && N.push((_) => {
        const D = sn(b({}, _, {
          defaultTheme: n,
          themeId: t
        }));
        if (!D.components || !D.components[u] || !D.components[u].styleOverrides)
          return null;
        const j = D.components[u].styleOverrides, V = {};
        return Object.entries(j).forEach(([F, k]) => {
          V[F] = hn(k, b({}, _, {
            theme: D
          }));
        }), x(_, V);
      }), u && !g && N.push((_) => {
        var D;
        const j = sn(b({}, _, {
          defaultTheme: n,
          themeId: t
        })), V = j == null || (D = j.components) == null || (D = D[u]) == null ? void 0 : D.variants;
        return hn({
          variants: V
        }, b({}, _, {
          theme: j
        }));
      }), E || N.push(s);
      const M = N.length - S.length;
      if (Array.isArray(p) && M > 0) {
        const _ = new Array(M).fill("");
        w = [...p, ..._], w.raw = [...p.raw, ..._];
      }
      const $ = C(w, ...N);
      if (process.env.NODE_ENV !== "production") {
        let _;
        u && (_ = `${u}${fe(c || "")}`), _ === void 0 && (_ = `Styled(${pn(a)})`), $.displayName = _;
      }
      return a.muiName && ($.muiName = a.muiName), $;
    };
    return C.withConfig && (m.withConfig = C.withConfig), m;
  };
}
function El(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  return !t || !t.components || !t.components[n] || !t.components[n].defaultProps ? r : Hi(t.components[n].defaultProps, r);
}
function Rl({
  props: e,
  name: t,
  defaultTheme: n,
  themeId: r
}) {
  let i = Nn(n);
  return r && (i = i[r] || i), El({
    theme: i,
    name: t,
    props: e
  });
}
function Kt(e) {
  "@babel/helpers - typeof";
  return Kt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Kt(e);
}
function Sl(e, t) {
  if (Kt(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Kt(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Pl(e) {
  var t = Sl(e, "string");
  return Kt(t) == "symbol" ? t : t + "";
}
const Tl = _i(), $n = Tl;
function kn() {
  const e = Nn($n);
  return process.env.NODE_ENV !== "production" && h.useDebugValue(e), e[Qt] || e;
}
function Pe({
  props: e,
  name: t
}) {
  return Rl({
    props: e,
    name: t,
    defaultTheme: $n,
    themeId: Qt
  });
}
const vt = (e) => Lt(e) && e !== "classes", wl = Lt, Cl = xl({
  themeId: Qt,
  defaultTheme: $n,
  rootShouldForwardProp: vt
}), G = Cl, Ol = (e) => {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, (t / 100).toFixed(2);
}, Mo = Ol;
function Nl(e) {
  return xe("MuiSvgIcon", e);
}
Ee("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const $l = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], kl = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: r
  } = e, i = {
    root: ["root", t !== "inherit" && `color${fe(t)}`, `fontSize${fe(n)}`]
  };
  return Se(i, Nl, r);
}, Ml = G("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${fe(n.color)}`], t[`fontSize${fe(n.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n, r, i, s, a, l, u, c, d, f, x, y, g;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // e.g. heroicons uses fill="none" and stroke="currentColor"
    fill: t.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    transition: (n = e.transitions) == null || (r = n.create) == null ? void 0 : r.call(n, "fill", {
      duration: (i = e.transitions) == null || (i = i.duration) == null ? void 0 : i.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((s = e.typography) == null || (a = s.pxToRem) == null ? void 0 : a.call(s, 20)) || "1.25rem",
      medium: ((l = e.typography) == null || (u = l.pxToRem) == null ? void 0 : u.call(l, 24)) || "1.5rem",
      large: ((c = e.typography) == null || (d = c.pxToRem) == null ? void 0 : d.call(c, 35)) || "2.1875rem"
    }[t.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (f = (x = (e.vars || e).palette) == null || (x = x[t.color]) == null ? void 0 : x.main) != null ? f : {
      action: (y = (e.vars || e).palette) == null || (y = y.action) == null ? void 0 : y.active,
      disabled: (g = (e.vars || e).palette) == null || (g = g.action) == null ? void 0 : g.disabled,
      inherit: void 0
    }[t.color]
  };
}), Dr = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const r = Pe({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: i,
    className: s,
    color: a = "inherit",
    component: l = "svg",
    fontSize: u = "medium",
    htmlColor: c,
    inheritViewBox: d = !1,
    titleAccess: f,
    viewBox: x = "0 0 24 24"
  } = r, y = q(r, $l), g = /* @__PURE__ */ h.isValidElement(i) && i.type === "svg", E = b({}, r, {
    color: a,
    component: l,
    fontSize: u,
    instanceFontSize: t.fontSize,
    inheritViewBox: d,
    viewBox: x,
    hasSvgAsChild: g
  }), v = {};
  d || (v.viewBox = x);
  const P = kl(E);
  return /* @__PURE__ */ ze(Ml, b({
    as: l,
    className: ae(P.root, s),
    focusable: "false",
    color: c,
    "aria-hidden": f ? void 0 : !0,
    role: f ? "img" : void 0,
    ref: n
  }, v, y, g && i.props, {
    ownerState: E,
    children: [g ? i.props.children : i, f ? /* @__PURE__ */ B("title", {
      children: f
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (Dr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Node passed into the SVG element.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: o.oneOfType([o.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: o.oneOfType([o.oneOf(["inherit", "large", "medium", "small"]), o.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: o.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: o.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: o.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: o.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: o.string
});
Dr.muiName = "SvgIcon";
const Io = Dr;
function Fr(e, t) {
  function n(r, i) {
    return /* @__PURE__ */ B(Io, b({
      "data-testid": `${t}Icon`,
      ref: i
    }, r, {
      children: e
    }));
  }
  return process.env.NODE_ENV !== "production" && (n.displayName = `${t}Icon`), n.muiName = Io.muiName, /* @__PURE__ */ h.memo(/* @__PURE__ */ h.forwardRef(n));
}
function cr(e, t) {
  return cr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, cr(e, t);
}
function Mn(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, cr(e, t);
}
const _o = {
  disabled: !1
};
var Il = process.env.NODE_ENV !== "production" ? o.oneOfType([o.number, o.shape({
  enter: o.number,
  exit: o.number,
  appear: o.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && o.oneOfType([o.string, o.shape({
  enter: o.string,
  exit: o.string,
  active: o.string
}), o.shape({
  enter: o.string,
  enterDone: o.string,
  enterActive: o.string,
  exit: o.string,
  exitDone: o.string,
  exitActive: o.string
})]);
const gn = Ke.createContext(null);
var _l = function(t) {
  return t.scrollTop;
}, Dt = "unmounted", at = "exited", lt = "entering", Rt = "entered", dr = "exiting", Ze = /* @__PURE__ */ function(e) {
  Mn(t, e);
  function t(r, i) {
    var s;
    s = e.call(this, r, i) || this;
    var a = i, l = a && !a.isMounting ? r.enter : r.appear, u;
    return s.appearStatus = null, r.in ? l ? (u = at, s.appearStatus = lt) : u = Rt : r.unmountOnExit || r.mountOnEnter ? u = Dt : u = at, s.state = {
      status: u
    }, s.nextCallback = null, s;
  }
  t.getDerivedStateFromProps = function(i, s) {
    var a = i.in;
    return a && s.status === Dt ? {
      status: at
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(i) {
    var s = null;
    if (i !== this.props) {
      var a = this.state.status;
      this.props.in ? a !== lt && a !== Rt && (s = lt) : (a === lt || a === Rt) && (s = dr);
    }
    this.updateStatus(!1, s);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var i = this.props.timeout, s, a, l;
    return s = a = l = i, i != null && typeof i != "number" && (s = i.exit, a = i.enter, l = i.appear !== void 0 ? i.appear : a), {
      exit: s,
      enter: a,
      appear: l
    };
  }, n.updateStatus = function(i, s) {
    if (i === void 0 && (i = !1), s !== null)
      if (this.cancelNextCallback(), s === lt) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var a = this.props.nodeRef ? this.props.nodeRef.current : on.findDOMNode(this);
          a && _l(a);
        }
        this.performEnter(i);
      } else
        this.performExit();
    else
      this.props.unmountOnExit && this.state.status === at && this.setState({
        status: Dt
      });
  }, n.performEnter = function(i) {
    var s = this, a = this.props.enter, l = this.context ? this.context.isMounting : i, u = this.props.nodeRef ? [l] : [on.findDOMNode(this), l], c = u[0], d = u[1], f = this.getTimeouts(), x = l ? f.appear : f.enter;
    if (!i && !a || _o.disabled) {
      this.safeSetState({
        status: Rt
      }, function() {
        s.props.onEntered(c);
      });
      return;
    }
    this.props.onEnter(c, d), this.safeSetState({
      status: lt
    }, function() {
      s.props.onEntering(c, d), s.onTransitionEnd(x, function() {
        s.safeSetState({
          status: Rt
        }, function() {
          s.props.onEntered(c, d);
        });
      });
    });
  }, n.performExit = function() {
    var i = this, s = this.props.exit, a = this.getTimeouts(), l = this.props.nodeRef ? void 0 : on.findDOMNode(this);
    if (!s || _o.disabled) {
      this.safeSetState({
        status: at
      }, function() {
        i.props.onExited(l);
      });
      return;
    }
    this.props.onExit(l), this.safeSetState({
      status: dr
    }, function() {
      i.props.onExiting(l), i.onTransitionEnd(a.exit, function() {
        i.safeSetState({
          status: at
        }, function() {
          i.props.onExited(l);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(i, s) {
    s = this.setNextCallback(s), this.setState(i, s);
  }, n.setNextCallback = function(i) {
    var s = this, a = !0;
    return this.nextCallback = function(l) {
      a && (a = !1, s.nextCallback = null, i(l));
    }, this.nextCallback.cancel = function() {
      a = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(i, s) {
    this.setNextCallback(s);
    var a = this.props.nodeRef ? this.props.nodeRef.current : on.findDOMNode(this), l = i == null && !this.props.addEndListener;
    if (!a || l) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var u = this.props.nodeRef ? [this.nextCallback] : [a, this.nextCallback], c = u[0], d = u[1];
      this.props.addEndListener(c, d);
    }
    i != null && setTimeout(this.nextCallback, i);
  }, n.render = function() {
    var i = this.state.status;
    if (i === Dt)
      return null;
    var s = this.props, a = s.children;
    s.in, s.mountOnEnter, s.unmountOnExit, s.appear, s.enter, s.exit, s.timeout, s.addEndListener, s.onEnter, s.onEntering, s.onEntered, s.onExit, s.onExiting, s.onExited, s.nodeRef;
    var l = q(s, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ Ke.createElement(gn.Provider, {
        value: null
      }, typeof a == "function" ? a(i, l) : Ke.cloneElement(Ke.Children.only(a), l))
    );
  }, t;
}(Ke.Component);
Ze.contextType = gn;
Ze.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: o.shape({
    current: typeof Element > "u" ? o.any : function(e, t, n, r, i, s) {
      var a = e[t];
      return o.instanceOf(a && "ownerDocument" in a ? a.ownerDocument.defaultView.Element : Element)(e, t, n, r, i, s);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: o.oneOfType([o.func.isRequired, o.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: o.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: o.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: o.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: o.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: o.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: o.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var n = Il;
    t.addEndListener || (n = n.isRequired);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++)
      i[s - 1] = arguments[s];
    return n.apply(void 0, [t].concat(i));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: o.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: o.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: o.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: o.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: o.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: o.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: o.func
} : {};
function bt() {
}
Ze.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: bt,
  onEntering: bt,
  onEntered: bt,
  onExit: bt,
  onExiting: bt,
  onExited: bt
};
Ze.UNMOUNTED = Dt;
Ze.EXITED = at;
Ze.ENTERING = lt;
Ze.ENTERED = Rt;
Ze.EXITING = dr;
const es = Ze;
function fr(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Vr(e, t) {
  var n = function(s) {
    return t && dn(s) ? t(s) : s;
  }, r = /* @__PURE__ */ Object.create(null);
  return e && sa.map(e, function(i) {
    return i;
  }).forEach(function(i) {
    r[i.key] = n(i);
  }), r;
}
function jl(e, t) {
  e = e || {}, t = t || {};
  function n(d) {
    return d in t ? t[d] : e[d];
  }
  var r = /* @__PURE__ */ Object.create(null), i = [];
  for (var s in e)
    s in t ? i.length && (r[s] = i, i = []) : i.push(s);
  var a, l = {};
  for (var u in t) {
    if (r[u])
      for (a = 0; a < r[u].length; a++) {
        var c = r[u][a];
        l[r[u][a]] = n(c);
      }
    l[u] = n(u);
  }
  for (a = 0; a < i.length; a++)
    l[i[a]] = n(i[a]);
  return l;
}
function ct(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function Al(e, t) {
  return Vr(e.children, function(n) {
    return fn(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: ct(n, "appear", e),
      enter: ct(n, "enter", e),
      exit: ct(n, "exit", e)
    });
  });
}
function Dl(e, t, n) {
  var r = Vr(e.children), i = jl(t, r);
  return Object.keys(i).forEach(function(s) {
    var a = i[s];
    if (dn(a)) {
      var l = s in t, u = s in r, c = t[s], d = dn(c) && !c.props.in;
      u && (!l || d) ? i[s] = fn(a, {
        onExited: n.bind(null, a),
        in: !0,
        exit: ct(a, "exit", e),
        enter: ct(a, "enter", e)
      }) : !u && l && !d ? i[s] = fn(a, {
        in: !1
      }) : u && l && dn(c) && (i[s] = fn(a, {
        onExited: n.bind(null, a),
        in: c.props.in,
        exit: ct(a, "exit", e),
        enter: ct(a, "enter", e)
      }));
    }
  }), i;
}
var Fl = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, Vl = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, Lr = /* @__PURE__ */ function(e) {
  Mn(t, e);
  function t(r, i) {
    var s;
    s = e.call(this, r, i) || this;
    var a = s.handleExited.bind(fr(s));
    return s.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: a,
      firstRender: !0
    }, s;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(i, s) {
    var a = s.children, l = s.handleExited, u = s.firstRender;
    return {
      children: u ? Al(i, l) : Dl(i, a, l),
      firstRender: !1
    };
  }, n.handleExited = function(i, s) {
    var a = Vr(this.props.children);
    i.key in a || (i.props.onExited && i.props.onExited(s), this.mounted && this.setState(function(l) {
      var u = b({}, l.children);
      return delete u[i.key], {
        children: u
      };
    }));
  }, n.render = function() {
    var i = this.props, s = i.component, a = i.childFactory, l = q(i, ["component", "childFactory"]), u = this.state.contextValue, c = Fl(this.state.children).map(a);
    return delete l.appear, delete l.enter, delete l.exit, s === null ? /* @__PURE__ */ Ke.createElement(gn.Provider, {
      value: u
    }, c) : /* @__PURE__ */ Ke.createElement(gn.Provider, {
      value: u
    }, /* @__PURE__ */ Ke.createElement(s, l, c));
  }, t;
}(Ke.Component);
Lr.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: o.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: o.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: o.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: o.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: o.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: o.func
} : {};
Lr.defaultProps = Vl;
const Ll = Lr, ts = (e) => e.scrollTop;
function bn(e, t) {
  var n, r;
  const {
    timeout: i,
    easing: s,
    style: a = {}
  } = e;
  return {
    duration: (n = a.transitionDuration) != null ? n : typeof i == "number" ? i : i[t.mode] || 0,
    easing: (r = a.transitionTimingFunction) != null ? r : typeof s == "object" ? s[t.mode] : s,
    delay: a.transitionDelay
  };
}
function Bl(e) {
  return xe("MuiPaper", e);
}
Ee("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const zl = ["className", "component", "elevation", "square", "variant"], Ul = (e) => {
  const {
    square: t,
    elevation: n,
    variant: r,
    classes: i
  } = e, s = {
    root: ["root", r, !t && "rounded", r === "elevation" && `elevation${n}`]
  };
  return Se(s, Bl, i);
}, Wl = G("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], !n.square && t.rounded, n.variant === "elevation" && t[`elevation${n.elevation}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n;
  return b({
    backgroundColor: (e.vars || e).palette.background.paper,
    color: (e.vars || e).palette.text.primary,
    transition: e.transitions.create("box-shadow")
  }, !t.square && {
    borderRadius: e.shape.borderRadius
  }, t.variant === "outlined" && {
    border: `1px solid ${(e.vars || e).palette.divider}`
  }, t.variant === "elevation" && b({
    boxShadow: (e.vars || e).shadows[t.elevation]
  }, !e.vars && e.palette.mode === "dark" && {
    backgroundImage: `linear-gradient(${yn("#fff", Mo(t.elevation))}, ${yn("#fff", Mo(t.elevation))})`
  }, e.vars && {
    backgroundImage: (n = e.vars.overlays) == null ? void 0 : n[t.elevation]
  }));
}), ns = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const r = Pe({
    props: t,
    name: "MuiPaper"
  }), {
    className: i,
    component: s = "div",
    elevation: a = 1,
    square: l = !1,
    variant: u = "elevation"
  } = r, c = q(r, zl), d = b({}, r, {
    component: s,
    elevation: a,
    square: l,
    variant: u
  }), f = Ul(d);
  return process.env.NODE_ENV !== "production" && kn().shadows[a] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${a}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${a}]\` is defined.`].join(`
`)), /* @__PURE__ */ B(Wl, b({
    as: s,
    ownerState: d,
    className: ae(f.root, i),
    ref: n
  }, c));
});
process.env.NODE_ENV !== "production" && (ns.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: ot(Wi, (e) => {
    const {
      elevation: t,
      variant: n
    } = e;
    return t > 0 && n === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${n}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: o.oneOfType([o.oneOf(["elevation", "outlined"]), o.string])
});
const Hl = ns;
function rs(e) {
  const {
    className: t,
    classes: n,
    pulsate: r = !1,
    rippleX: i,
    rippleY: s,
    rippleSize: a,
    in: l,
    onExited: u,
    timeout: c
  } = e, [d, f] = h.useState(!1), x = ae(t, n.ripple, n.rippleVisible, r && n.ripplePulsate), y = {
    width: a,
    height: a,
    top: -(a / 2) + s,
    left: -(a / 2) + i
  }, g = ae(n.child, d && n.childLeaving, r && n.childPulsate);
  return !l && !d && f(!0), h.useEffect(() => {
    if (!l && u != null) {
      const E = setTimeout(u, c);
      return () => {
        clearTimeout(E);
      };
    }
  }, [u, l, c]), /* @__PURE__ */ B("span", {
    className: x,
    style: y,
    children: /* @__PURE__ */ B("span", {
      className: g
    })
  });
}
process.env.NODE_ENV !== "production" && (rs.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: o.object.isRequired,
  className: o.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: o.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: o.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: o.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: o.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: o.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: o.number,
  /**
   * exit delay
   */
  timeout: o.number.isRequired
});
const ql = Ee("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), Ae = ql, Yl = ["center", "classes", "className"];
let In = (e) => e, jo, Ao, Do, Fo;
const pr = 550, Kl = 80, Gl = en(jo || (jo = In`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), Xl = en(Ao || (Ao = In`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), Jl = en(Do || (Do = In`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), Zl = G("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), Ql = G(rs, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(Fo || (Fo = In`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), Ae.rippleVisible, Gl, pr, ({
  theme: e
}) => e.transitions.easing.easeInOut, Ae.ripplePulsate, ({
  theme: e
}) => e.transitions.duration.shorter, Ae.child, Ae.childLeaving, Xl, pr, ({
  theme: e
}) => e.transitions.easing.easeInOut, Ae.childPulsate, Jl, ({
  theme: e
}) => e.transitions.easing.easeInOut), os = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const r = Pe({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: i = !1,
    classes: s = {},
    className: a
  } = r, l = q(r, Yl), [u, c] = h.useState([]), d = h.useRef(0), f = h.useRef(null);
  h.useEffect(() => {
    f.current && (f.current(), f.current = null);
  }, [u]);
  const x = h.useRef(!1), y = h.useRef(0), g = h.useRef(null), E = h.useRef(null);
  h.useEffect(() => () => {
    y.current && clearTimeout(y.current);
  }, []);
  const v = h.useCallback((m) => {
    const {
      pulsate: p,
      rippleX: S,
      rippleY: w,
      rippleSize: N,
      cb: M
    } = m;
    c(($) => [...$, /* @__PURE__ */ B(Ql, {
      classes: {
        ripple: ae(s.ripple, Ae.ripple),
        rippleVisible: ae(s.rippleVisible, Ae.rippleVisible),
        ripplePulsate: ae(s.ripplePulsate, Ae.ripplePulsate),
        child: ae(s.child, Ae.child),
        childLeaving: ae(s.childLeaving, Ae.childLeaving),
        childPulsate: ae(s.childPulsate, Ae.childPulsate)
      },
      timeout: pr,
      pulsate: p,
      rippleX: S,
      rippleY: w,
      rippleSize: N
    }, d.current)]), d.current += 1, f.current = M;
  }, [s]), P = h.useCallback((m = {}, p = {}, S = () => {
  }) => {
    const {
      pulsate: w = !1,
      center: N = i || p.pulsate,
      fakeElement: M = !1
      // For test purposes
    } = p;
    if ((m == null ? void 0 : m.type) === "mousedown" && x.current) {
      x.current = !1;
      return;
    }
    (m == null ? void 0 : m.type) === "touchstart" && (x.current = !0);
    const $ = M ? null : E.current, _ = $ ? $.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let D, j, V;
    if (N || m === void 0 || m.clientX === 0 && m.clientY === 0 || !m.clientX && !m.touches)
      D = Math.round(_.width / 2), j = Math.round(_.height / 2);
    else {
      const {
        clientX: F,
        clientY: k
      } = m.touches && m.touches.length > 0 ? m.touches[0] : m;
      D = Math.round(F - _.left), j = Math.round(k - _.top);
    }
    if (N)
      V = Math.sqrt((2 * _.width ** 2 + _.height ** 2) / 3), V % 2 === 0 && (V += 1);
    else {
      const F = Math.max(Math.abs(($ ? $.clientWidth : 0) - D), D) * 2 + 2, k = Math.max(Math.abs(($ ? $.clientHeight : 0) - j), j) * 2 + 2;
      V = Math.sqrt(F ** 2 + k ** 2);
    }
    m != null && m.touches ? g.current === null && (g.current = () => {
      v({
        pulsate: w,
        rippleX: D,
        rippleY: j,
        rippleSize: V,
        cb: S
      });
    }, y.current = setTimeout(() => {
      g.current && (g.current(), g.current = null);
    }, Kl)) : v({
      pulsate: w,
      rippleX: D,
      rippleY: j,
      rippleSize: V,
      cb: S
    });
  }, [i, v]), C = h.useCallback(() => {
    P({}, {
      pulsate: !0
    });
  }, [P]), R = h.useCallback((m, p) => {
    if (clearTimeout(y.current), (m == null ? void 0 : m.type) === "touchend" && g.current) {
      g.current(), g.current = null, y.current = setTimeout(() => {
        R(m, p);
      });
      return;
    }
    g.current = null, c((S) => S.length > 0 ? S.slice(1) : S), f.current = p;
  }, []);
  return h.useImperativeHandle(n, () => ({
    pulsate: C,
    start: P,
    stop: R
  }), [C, P, R]), /* @__PURE__ */ B(Zl, b({
    className: ae(Ae.root, s.root, a),
    ref: E
  }, l, {
    children: /* @__PURE__ */ B(Ll, {
      component: null,
      exit: !0,
      children: u
    })
  }));
});
process.env.NODE_ENV !== "production" && (os.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: o.bool,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string
});
const eu = os;
function tu(e) {
  return xe("MuiButtonBase", e);
}
const nu = Ee("MuiButtonBase", ["root", "disabled", "focusVisible"]), ru = nu, ou = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], iu = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: r,
    classes: i
  } = e, a = Se({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, tu, i);
  return n && r && (a.root += ` ${r}`), a;
}, su = G("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${ru.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), is = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const r = Pe({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: i,
    centerRipple: s = !1,
    children: a,
    className: l,
    component: u = "button",
    disabled: c = !1,
    disableRipple: d = !1,
    disableTouchRipple: f = !1,
    focusRipple: x = !1,
    LinkComponent: y = "a",
    onBlur: g,
    onClick: E,
    onContextMenu: v,
    onDragLeave: P,
    onFocus: C,
    onFocusVisible: R,
    onKeyDown: m,
    onKeyUp: p,
    onMouseDown: S,
    onMouseLeave: w,
    onMouseUp: N,
    onTouchEnd: M,
    onTouchMove: $,
    onTouchStart: _,
    tabIndex: D = 0,
    TouchRippleProps: j,
    touchRippleRef: V,
    type: F
  } = r, k = q(r, ou), L = h.useRef(null), A = h.useRef(null), U = Ce(A, V), {
    isFocusVisibleRef: J,
    onFocus: be,
    onBlur: le,
    ref: he
  } = ka(), [X, Q] = h.useState(!1);
  c && X && Q(!1), h.useImperativeHandle(i, () => ({
    focusVisible: () => {
      Q(!0), L.current.focus();
    }
  }), []);
  const [ne, me] = h.useState(!1);
  h.useEffect(() => {
    me(!0);
  }, []);
  const pe = ne && !d && !c;
  h.useEffect(() => {
    X && x && !d && ne && A.current.pulsate();
  }, [d, x, X, ne]);
  function ue(W, We, kt = f) {
    return St((yt) => (We && We(yt), !kt && A.current && A.current[W](yt), !0));
  }
  const ye = ue("start", S), K = ue("stop", v), I = ue("stop", P), H = ue("stop", N), O = ue("stop", (W) => {
    X && W.preventDefault(), w && w(W);
  }), Z = ue("start", _), ve = ue("stop", M), Re = ue("stop", $), ke = ue("stop", (W) => {
    le(W), J.current === !1 && Q(!1), g && g(W);
  }, !1), _e = St((W) => {
    L.current || (L.current = W.currentTarget), be(W), J.current === !0 && (Q(!0), R && R(W)), C && C(W);
  }), ge = () => {
    const W = L.current;
    return u && u !== "button" && !(W.tagName === "A" && W.href);
  }, ce = h.useRef(!1), Oe = St((W) => {
    x && !ce.current && X && A.current && W.key === " " && (ce.current = !0, A.current.stop(W, () => {
      A.current.start(W);
    })), W.target === W.currentTarget && ge() && W.key === " " && W.preventDefault(), m && m(W), W.target === W.currentTarget && ge() && W.key === "Enter" && !c && (W.preventDefault(), E && E(W));
  }), Te = St((W) => {
    x && W.key === " " && A.current && X && !W.defaultPrevented && (ce.current = !1, A.current.stop(W, () => {
      A.current.pulsate(W);
    })), p && p(W), E && W.target === W.currentTarget && ge() && W.key === " " && !W.defaultPrevented && E(W);
  });
  let de = u;
  de === "button" && (k.href || k.to) && (de = y);
  const Ne = {};
  de === "button" ? (Ne.type = F === void 0 ? "button" : F, Ne.disabled = c) : (!k.href && !k.to && (Ne.role = "button"), c && (Ne["aria-disabled"] = c));
  const Ue = Ce(n, he, L);
  process.env.NODE_ENV !== "production" && h.useEffect(() => {
    pe && !A.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [pe]);
  const Be = b({}, r, {
    centerRipple: s,
    component: u,
    disabled: c,
    disableRipple: d,
    disableTouchRipple: f,
    focusRipple: x,
    tabIndex: D,
    focusVisible: X
  }), ee = iu(Be);
  return /* @__PURE__ */ ze(su, b({
    as: de,
    className: ae(ee.root, l),
    ownerState: Be,
    onBlur: ke,
    onClick: E,
    onContextMenu: K,
    onFocus: _e,
    onKeyDown: Oe,
    onKeyUp: Te,
    onMouseDown: ye,
    onMouseLeave: O,
    onMouseUp: H,
    onDragLeave: I,
    onTouchEnd: ve,
    onTouchMove: Re,
    onTouchStart: Z,
    ref: Ue,
    tabIndex: c ? -1 : D,
    type: F
  }, Ne, k, {
    children: [a, pe ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ B(eu, b({
        ref: U,
        center: s
      }, j))
    ) : null]
  }));
});
process.env.NODE_ENV !== "production" && (is.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: Ye,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: o.bool,
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Mr,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: o.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: o.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: o.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: o.string,
  /**
   * @ignore
   */
  href: o.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: o.elementType,
  /**
   * @ignore
   */
  onBlur: o.func,
  /**
   * @ignore
   */
  onClick: o.func,
  /**
   * @ignore
   */
  onContextMenu: o.func,
  /**
   * @ignore
   */
  onDragLeave: o.func,
  /**
   * @ignore
   */
  onFocus: o.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: o.func,
  /**
   * @ignore
   */
  onKeyDown: o.func,
  /**
   * @ignore
   */
  onKeyUp: o.func,
  /**
   * @ignore
   */
  onMouseDown: o.func,
  /**
   * @ignore
   */
  onMouseLeave: o.func,
  /**
   * @ignore
   */
  onMouseUp: o.func,
  /**
   * @ignore
   */
  onTouchEnd: o.func,
  /**
   * @ignore
   */
  onTouchMove: o.func,
  /**
   * @ignore
   */
  onTouchStart: o.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * @default 0
   */
  tabIndex: o.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: o.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: o.oneOfType([o.func, o.shape({
    current: o.shape({
      pulsate: o.func.isRequired,
      start: o.func.isRequired,
      stop: o.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: o.oneOfType([o.oneOf(["button", "reset", "submit"]), o.string])
});
const au = is;
function lu(e) {
  return xe("MuiIconButton", e);
}
const uu = Ee("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), cu = uu, du = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"], fu = (e) => {
  const {
    classes: t,
    disabled: n,
    color: r,
    edge: i,
    size: s
  } = e, a = {
    root: ["root", n && "disabled", r !== "default" && `color${fe(r)}`, i && `edge${fe(i)}`, `size${fe(s)}`]
  };
  return Se(a, lu, t);
}, pu = G(au, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${fe(n.color)}`], n.edge && t[`edge${fe(n.edge)}`], t[`size${fe(n.size)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => b({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  overflow: "visible",
  // Explicitly set the default value to solve a bug on IE11.
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  })
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : yn(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.edge === "start" && {
  marginLeft: t.size === "small" ? -3 : -12
}, t.edge === "end" && {
  marginRight: t.size === "small" ? -3 : -12
}), ({
  theme: e,
  ownerState: t
}) => {
  var n;
  const r = (n = (e.vars || e).palette) == null ? void 0 : n[t.color];
  return b({}, t.color === "inherit" && {
    color: "inherit"
  }, t.color !== "inherit" && t.color !== "default" && b({
    color: r == null ? void 0 : r.main
  }, !t.disableRipple && {
    "&:hover": b({}, r && {
      backgroundColor: e.vars ? `rgba(${r.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : yn(r.main, e.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    })
  }), t.size === "small" && {
    padding: 5,
    fontSize: e.typography.pxToRem(18)
  }, t.size === "large" && {
    padding: 12,
    fontSize: e.typography.pxToRem(28)
  }, {
    [`&.${cu.disabled}`]: {
      backgroundColor: "transparent",
      color: (e.vars || e).palette.action.disabled
    }
  });
}), ss = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const r = Pe({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: i = !1,
    children: s,
    className: a,
    color: l = "default",
    disabled: u = !1,
    disableFocusRipple: c = !1,
    size: d = "medium"
  } = r, f = q(r, du), x = b({}, r, {
    edge: i,
    color: l,
    disabled: u,
    disableFocusRipple: c,
    size: d
  }), y = fu(x);
  return /* @__PURE__ */ B(pu, b({
    className: ae(y.root, a),
    centerRipple: !0,
    focusRipple: !c,
    disabled: u,
    ref: n,
    ownerState: x
  }, f, {
    children: s
  }));
});
process.env.NODE_ENV !== "production" && (ss.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The icon to display.
   */
  children: ot(o.node, (e) => h.Children.toArray(e.children).some((n) => /* @__PURE__ */ h.isValidElement(n) && n.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: o.oneOfType([o.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: o.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: o.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: o.oneOf(["end", "start", !1]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["small", "medium", "large"]), o.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
const ym = ss, gm = Fr(/* @__PURE__ */ B("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
function hu(e) {
  return xe("MuiTypography", e);
}
Ee("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const mu = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"], vu = (e) => {
  const {
    align: t,
    gutterBottom: n,
    noWrap: r,
    paragraph: i,
    variant: s,
    classes: a
  } = e, l = {
    root: ["root", s, e.align !== "inherit" && `align${fe(t)}`, n && "gutterBottom", r && "noWrap", i && "paragraph"]
  };
  return Se(l, hu, a);
}, yu = G("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.variant && t[n.variant], n.align !== "inherit" && t[`align${fe(n.align)}`], n.noWrap && t.noWrap, n.gutterBottom && t.gutterBottom, n.paragraph && t.paragraph];
  }
})(({
  theme: e,
  ownerState: t
}) => b({
  margin: 0
}, t.variant === "inherit" && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: "inherit"
}, t.variant !== "inherit" && e.typography[t.variant], t.align !== "inherit" && {
  textAlign: t.align
}, t.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, t.gutterBottom && {
  marginBottom: "0.35em"
}, t.paragraph && {
  marginBottom: 16
})), Vo = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, gu = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, bu = (e) => gu[e] || e, as = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const r = Pe({
    props: t,
    name: "MuiTypography"
  }), i = bu(r.color), s = Zi(b({}, r, {
    color: i
  })), {
    align: a = "inherit",
    className: l,
    component: u,
    gutterBottom: c = !1,
    noWrap: d = !1,
    paragraph: f = !1,
    variant: x = "body1",
    variantMapping: y = Vo
  } = s, g = q(s, mu), E = b({}, s, {
    align: a,
    color: i,
    className: l,
    component: u,
    gutterBottom: c,
    noWrap: d,
    paragraph: f,
    variant: x,
    variantMapping: y
  }), v = u || (f ? "p" : y[x] || Vo[x]) || "span", P = vu(E);
  return /* @__PURE__ */ B(yu, b({
    as: v,
    ref: n,
    ownerState: E,
    className: ae(P.root, l)
  }, g));
});
process.env.NODE_ENV !== "production" && (as.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: o.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: o.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: o.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: o.oneOfType([o.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), o.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: o.object
});
const bm = as;
function xn(e) {
  return typeof e == "string";
}
function xu(e, t, n) {
  return e === void 0 || xn(e) ? t : b({}, t, {
    ownerState: b({}, t.ownerState, n)
  });
}
const Eu = {
  disableDefaultClasses: !1
}, Ru = /* @__PURE__ */ h.createContext(Eu);
function Su(e) {
  const {
    disableDefaultClasses: t
  } = h.useContext(Ru);
  return (n) => t ? "" : e(n);
}
function ls(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function Pu(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function Lo(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function Tu(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: i,
    className: s
  } = e;
  if (!t) {
    const y = ae(i == null ? void 0 : i.className, r == null ? void 0 : r.className, s, n == null ? void 0 : n.className), g = b({}, n == null ? void 0 : n.style, i == null ? void 0 : i.style, r == null ? void 0 : r.style), E = b({}, n, i, r);
    return y.length > 0 && (E.className = y), Object.keys(g).length > 0 && (E.style = g), {
      props: E,
      internalRef: void 0
    };
  }
  const a = ls(b({}, i, r)), l = Lo(r), u = Lo(i), c = t(a), d = ae(c == null ? void 0 : c.className, n == null ? void 0 : n.className, s, i == null ? void 0 : i.className, r == null ? void 0 : r.className), f = b({}, c == null ? void 0 : c.style, n == null ? void 0 : n.style, i == null ? void 0 : i.style, r == null ? void 0 : r.style), x = b({}, c, n, u, l);
  return d.length > 0 && (x.className = d), Object.keys(f).length > 0 && (x.style = f), {
    props: x,
    internalRef: c.ref
  };
}
const wu = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function ht(e) {
  var t;
  const {
    elementType: n,
    externalSlotProps: r,
    ownerState: i,
    skipResolvingSlotProps: s = !1
  } = e, a = q(e, wu), l = s ? {} : Pu(r, i), {
    props: u,
    internalRef: c
  } = Tu(b({}, a, {
    externalSlotProps: l
  })), d = Ce(c, l == null ? void 0 : l.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return xu(n, b({}, u, {
    ref: d
  }), i);
}
const Cu = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function Ou(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function Nu(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (r) => e.ownerDocument.querySelector(`input[type="radio"]${r}`);
  let n = t(`[name="${e.name}"]:checked`);
  return n || (n = t(`[name="${e.name}"]`)), n !== e;
}
function $u(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || Nu(e));
}
function ku(e) {
  const t = [], n = [];
  return Array.from(e.querySelectorAll(Cu)).forEach((r, i) => {
    const s = Ou(r);
    s === -1 || !$u(r) || (s === 0 ? t.push(r) : n.push({
      documentOrder: i,
      tabIndex: s,
      node: r
    }));
  }), n.sort((r, i) => r.tabIndex === i.tabIndex ? r.documentOrder - i.documentOrder : r.tabIndex - i.tabIndex).map((r) => r.node).concat(t);
}
function Mu() {
  return !0;
}
function En(e) {
  const {
    children: t,
    disableAutoFocus: n = !1,
    disableEnforceFocus: r = !1,
    disableRestoreFocus: i = !1,
    getTabbable: s = ku,
    isEnabled: a = Mu,
    open: l
  } = e, u = h.useRef(!1), c = h.useRef(null), d = h.useRef(null), f = h.useRef(null), x = h.useRef(null), y = h.useRef(!1), g = h.useRef(null), E = Ce(t.ref, g), v = h.useRef(null);
  h.useEffect(() => {
    !l || !g.current || (y.current = !n);
  }, [n, l]), h.useEffect(() => {
    if (!l || !g.current)
      return;
    const R = $e(g.current);
    return g.current.contains(R.activeElement) || (g.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), g.current.setAttribute("tabIndex", "-1")), y.current && g.current.focus()), () => {
      i || (f.current && f.current.focus && (u.current = !0, f.current.focus()), f.current = null);
    };
  }, [l]), h.useEffect(() => {
    if (!l || !g.current)
      return;
    const R = $e(g.current), m = (w) => {
      v.current = w, !(r || !a() || w.key !== "Tab") && R.activeElement === g.current && w.shiftKey && (u.current = !0, d.current && d.current.focus());
    }, p = () => {
      const w = g.current;
      if (w === null)
        return;
      if (!R.hasFocus() || !a() || u.current) {
        u.current = !1;
        return;
      }
      if (w.contains(R.activeElement) || r && R.activeElement !== c.current && R.activeElement !== d.current)
        return;
      if (R.activeElement !== x.current)
        x.current = null;
      else if (x.current !== null)
        return;
      if (!y.current)
        return;
      let N = [];
      if ((R.activeElement === c.current || R.activeElement === d.current) && (N = s(g.current)), N.length > 0) {
        var M, $;
        const _ = !!((M = v.current) != null && M.shiftKey && (($ = v.current) == null ? void 0 : $.key) === "Tab"), D = N[0], j = N[N.length - 1];
        typeof D != "string" && typeof j != "string" && (_ ? j.focus() : D.focus());
      } else
        w.focus();
    };
    R.addEventListener("focusin", p), R.addEventListener("keydown", m, !0);
    const S = setInterval(() => {
      R.activeElement && R.activeElement.tagName === "BODY" && p();
    }, 50);
    return () => {
      clearInterval(S), R.removeEventListener("focusin", p), R.removeEventListener("keydown", m, !0);
    };
  }, [n, r, i, a, l, s]);
  const P = (R) => {
    f.current === null && (f.current = R.relatedTarget), y.current = !0, x.current = R.target;
    const m = t.props.onFocus;
    m && m(R);
  }, C = (R) => {
    f.current === null && (f.current = R.relatedTarget), y.current = !0;
  };
  return /* @__PURE__ */ ze(h.Fragment, {
    children: [/* @__PURE__ */ B("div", {
      tabIndex: l ? 0 : -1,
      onFocus: C,
      ref: c,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ h.cloneElement(t, {
      ref: E,
      onFocus: P
    }), /* @__PURE__ */ B("div", {
      tabIndex: l ? 0 : -1,
      onFocus: C,
      ref: d,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (En.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * A single child content element.
   */
  children: Cn,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: o.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: o.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: o.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: o.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: o.func,
  /**
   * If `true`, focus is locked.
   */
  open: o.bool.isRequired
});
process.env.NODE_ENV !== "production" && (En["propTypes"] = kr(En.propTypes));
var Me = "top", Fe = "bottom", Ve = "right", Ie = "left", Br = "auto", tn = [Me, Fe, Ve, Ie], Tt = "start", Gt = "end", Iu = "clippingParents", us = "viewport", Mt = "popper", _u = "reference", Bo = /* @__PURE__ */ tn.reduce(function(e, t) {
  return e.concat([t + "-" + Tt, t + "-" + Gt]);
}, []), cs = /* @__PURE__ */ [].concat(tn, [Br]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Tt, t + "-" + Gt]);
}, []), ju = "beforeRead", Au = "read", Du = "afterRead", Fu = "beforeMain", Vu = "main", Lu = "afterMain", Bu = "beforeWrite", zu = "write", Uu = "afterWrite", Wu = [ju, Au, Du, Fu, Vu, Lu, Bu, zu, Uu];
function qe(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function je(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function mt(e) {
  var t = je(e).Element;
  return e instanceof t || e instanceof Element;
}
function De(e) {
  var t = je(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function zr(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = je(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Hu(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, i = t.attributes[n] || {}, s = t.elements[n];
    !De(s) || !qe(s) || (Object.assign(s.style, r), Object.keys(i).forEach(function(a) {
      var l = i[a];
      l === !1 ? s.removeAttribute(a) : s.setAttribute(a, l === !0 ? "" : l);
    }));
  });
}
function qu(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var i = t.elements[r], s = t.attributes[r] || {}, a = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), l = a.reduce(function(u, c) {
        return u[c] = "", u;
      }, {});
      !De(i) || !qe(i) || (Object.assign(i.style, l), Object.keys(s).forEach(function(u) {
        i.removeAttribute(u);
      }));
    });
  };
}
const Yu = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Hu,
  effect: qu,
  requires: ["computeStyles"]
};
function He(e) {
  return e.split("-")[0];
}
var dt = Math.max, Rn = Math.min, wt = Math.round;
function hr() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function ds() {
  return !/^((?!chrome|android).)*safari/i.test(hr());
}
function Ct(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), i = 1, s = 1;
  t && De(e) && (i = e.offsetWidth > 0 && wt(r.width) / e.offsetWidth || 1, s = e.offsetHeight > 0 && wt(r.height) / e.offsetHeight || 1);
  var a = mt(e) ? je(e) : window, l = a.visualViewport, u = !ds() && n, c = (r.left + (u && l ? l.offsetLeft : 0)) / i, d = (r.top + (u && l ? l.offsetTop : 0)) / s, f = r.width / i, x = r.height / s;
  return {
    width: f,
    height: x,
    top: d,
    right: c + f,
    bottom: d + x,
    left: c,
    x: c,
    y: d
  };
}
function Ur(e) {
  var t = Ct(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function fs(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && zr(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Je(e) {
  return je(e).getComputedStyle(e);
}
function Ku(e) {
  return ["table", "td", "th"].indexOf(qe(e)) >= 0;
}
function it(e) {
  return ((mt(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function _n(e) {
  return qe(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (zr(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    it(e)
  );
}
function zo(e) {
  return !De(e) || // https://github.com/popperjs/popper-core/issues/837
  Je(e).position === "fixed" ? null : e.offsetParent;
}
function Gu(e) {
  var t = /firefox/i.test(hr()), n = /Trident/i.test(hr());
  if (n && De(e)) {
    var r = Je(e);
    if (r.position === "fixed")
      return null;
  }
  var i = _n(e);
  for (zr(i) && (i = i.host); De(i) && ["html", "body"].indexOf(qe(i)) < 0; ) {
    var s = Je(i);
    if (s.transform !== "none" || s.perspective !== "none" || s.contain === "paint" || ["transform", "perspective"].indexOf(s.willChange) !== -1 || t && s.willChange === "filter" || t && s.filter && s.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function nn(e) {
  for (var t = je(e), n = zo(e); n && Ku(n) && Je(n).position === "static"; )
    n = zo(n);
  return n && (qe(n) === "html" || qe(n) === "body" && Je(n).position === "static") ? t : n || Gu(e) || t;
}
function Wr(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Bt(e, t, n) {
  return dt(e, Rn(t, n));
}
function Xu(e, t, n) {
  var r = Bt(e, t, n);
  return r > n ? n : r;
}
function ps() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function hs(e) {
  return Object.assign({}, ps(), e);
}
function ms(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var Ju = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, hs(typeof t != "number" ? t : ms(t, tn));
};
function Zu(e) {
  var t, n = e.state, r = e.name, i = e.options, s = n.elements.arrow, a = n.modifiersData.popperOffsets, l = He(n.placement), u = Wr(l), c = [Ie, Ve].indexOf(l) >= 0, d = c ? "height" : "width";
  if (!(!s || !a)) {
    var f = Ju(i.padding, n), x = Ur(s), y = u === "y" ? Me : Ie, g = u === "y" ? Fe : Ve, E = n.rects.reference[d] + n.rects.reference[u] - a[u] - n.rects.popper[d], v = a[u] - n.rects.reference[u], P = nn(s), C = P ? u === "y" ? P.clientHeight || 0 : P.clientWidth || 0 : 0, R = E / 2 - v / 2, m = f[y], p = C - x[d] - f[g], S = C / 2 - x[d] / 2 + R, w = Bt(m, S, p), N = u;
    n.modifiersData[r] = (t = {}, t[N] = w, t.centerOffset = w - S, t);
  }
}
function Qu(e) {
  var t = e.state, n = e.options, r = n.element, i = r === void 0 ? "[data-popper-arrow]" : r;
  i != null && (typeof i == "string" && (i = t.elements.popper.querySelector(i), !i) || fs(t.elements.popper, i) && (t.elements.arrow = i));
}
const ec = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Zu,
  effect: Qu,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Ot(e) {
  return e.split("-")[1];
}
var tc = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function nc(e, t) {
  var n = e.x, r = e.y, i = t.devicePixelRatio || 1;
  return {
    x: wt(n * i) / i || 0,
    y: wt(r * i) / i || 0
  };
}
function Uo(e) {
  var t, n = e.popper, r = e.popperRect, i = e.placement, s = e.variation, a = e.offsets, l = e.position, u = e.gpuAcceleration, c = e.adaptive, d = e.roundOffsets, f = e.isFixed, x = a.x, y = x === void 0 ? 0 : x, g = a.y, E = g === void 0 ? 0 : g, v = typeof d == "function" ? d({
    x: y,
    y: E
  }) : {
    x: y,
    y: E
  };
  y = v.x, E = v.y;
  var P = a.hasOwnProperty("x"), C = a.hasOwnProperty("y"), R = Ie, m = Me, p = window;
  if (c) {
    var S = nn(n), w = "clientHeight", N = "clientWidth";
    if (S === je(n) && (S = it(n), Je(S).position !== "static" && l === "absolute" && (w = "scrollHeight", N = "scrollWidth")), S = S, i === Me || (i === Ie || i === Ve) && s === Gt) {
      m = Fe;
      var M = f && S === p && p.visualViewport ? p.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        S[w]
      );
      E -= M - r.height, E *= u ? 1 : -1;
    }
    if (i === Ie || (i === Me || i === Fe) && s === Gt) {
      R = Ve;
      var $ = f && S === p && p.visualViewport ? p.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        S[N]
      );
      y -= $ - r.width, y *= u ? 1 : -1;
    }
  }
  var _ = Object.assign({
    position: l
  }, c && tc), D = d === !0 ? nc({
    x: y,
    y: E
  }, je(n)) : {
    x: y,
    y: E
  };
  if (y = D.x, E = D.y, u) {
    var j;
    return Object.assign({}, _, (j = {}, j[m] = C ? "0" : "", j[R] = P ? "0" : "", j.transform = (p.devicePixelRatio || 1) <= 1 ? "translate(" + y + "px, " + E + "px)" : "translate3d(" + y + "px, " + E + "px, 0)", j));
  }
  return Object.assign({}, _, (t = {}, t[m] = C ? E + "px" : "", t[R] = P ? y + "px" : "", t.transform = "", t));
}
function rc(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, i = r === void 0 ? !0 : r, s = n.adaptive, a = s === void 0 ? !0 : s, l = n.roundOffsets, u = l === void 0 ? !0 : l, c = {
    placement: He(t.placement),
    variation: Ot(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: i,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Uo(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: a,
    roundOffsets: u
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Uo(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: u
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const oc = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: rc,
  data: {}
};
var an = {
  passive: !0
};
function ic(e) {
  var t = e.state, n = e.instance, r = e.options, i = r.scroll, s = i === void 0 ? !0 : i, a = r.resize, l = a === void 0 ? !0 : a, u = je(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return s && c.forEach(function(d) {
    d.addEventListener("scroll", n.update, an);
  }), l && u.addEventListener("resize", n.update, an), function() {
    s && c.forEach(function(d) {
      d.removeEventListener("scroll", n.update, an);
    }), l && u.removeEventListener("resize", n.update, an);
  };
}
const sc = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: ic,
  data: {}
};
var ac = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function mn(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return ac[t];
  });
}
var lc = {
  start: "end",
  end: "start"
};
function Wo(e) {
  return e.replace(/start|end/g, function(t) {
    return lc[t];
  });
}
function Hr(e) {
  var t = je(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function qr(e) {
  return Ct(it(e)).left + Hr(e).scrollLeft;
}
function uc(e, t) {
  var n = je(e), r = it(e), i = n.visualViewport, s = r.clientWidth, a = r.clientHeight, l = 0, u = 0;
  if (i) {
    s = i.width, a = i.height;
    var c = ds();
    (c || !c && t === "fixed") && (l = i.offsetLeft, u = i.offsetTop);
  }
  return {
    width: s,
    height: a,
    x: l + qr(e),
    y: u
  };
}
function cc(e) {
  var t, n = it(e), r = Hr(e), i = (t = e.ownerDocument) == null ? void 0 : t.body, s = dt(n.scrollWidth, n.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), a = dt(n.scrollHeight, n.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), l = -r.scrollLeft + qr(e), u = -r.scrollTop;
  return Je(i || n).direction === "rtl" && (l += dt(n.clientWidth, i ? i.clientWidth : 0) - s), {
    width: s,
    height: a,
    x: l,
    y: u
  };
}
function Yr(e) {
  var t = Je(e), n = t.overflow, r = t.overflowX, i = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + i + r);
}
function vs(e) {
  return ["html", "body", "#document"].indexOf(qe(e)) >= 0 ? e.ownerDocument.body : De(e) && Yr(e) ? e : vs(_n(e));
}
function zt(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = vs(e), i = r === ((n = e.ownerDocument) == null ? void 0 : n.body), s = je(r), a = i ? [s].concat(s.visualViewport || [], Yr(r) ? r : []) : r, l = t.concat(a);
  return i ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(zt(_n(a)))
  );
}
function mr(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function dc(e, t) {
  var n = Ct(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Ho(e, t, n) {
  return t === us ? mr(uc(e, n)) : mt(t) ? dc(t, n) : mr(cc(it(e)));
}
function fc(e) {
  var t = zt(_n(e)), n = ["absolute", "fixed"].indexOf(Je(e).position) >= 0, r = n && De(e) ? nn(e) : e;
  return mt(r) ? t.filter(function(i) {
    return mt(i) && fs(i, r) && qe(i) !== "body";
  }) : [];
}
function pc(e, t, n, r) {
  var i = t === "clippingParents" ? fc(e) : [].concat(t), s = [].concat(i, [n]), a = s[0], l = s.reduce(function(u, c) {
    var d = Ho(e, c, r);
    return u.top = dt(d.top, u.top), u.right = Rn(d.right, u.right), u.bottom = Rn(d.bottom, u.bottom), u.left = dt(d.left, u.left), u;
  }, Ho(e, a, r));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function ys(e) {
  var t = e.reference, n = e.element, r = e.placement, i = r ? He(r) : null, s = r ? Ot(r) : null, a = t.x + t.width / 2 - n.width / 2, l = t.y + t.height / 2 - n.height / 2, u;
  switch (i) {
    case Me:
      u = {
        x: a,
        y: t.y - n.height
      };
      break;
    case Fe:
      u = {
        x: a,
        y: t.y + t.height
      };
      break;
    case Ve:
      u = {
        x: t.x + t.width,
        y: l
      };
      break;
    case Ie:
      u = {
        x: t.x - n.width,
        y: l
      };
      break;
    default:
      u = {
        x: t.x,
        y: t.y
      };
  }
  var c = i ? Wr(i) : null;
  if (c != null) {
    var d = c === "y" ? "height" : "width";
    switch (s) {
      case Tt:
        u[c] = u[c] - (t[d] / 2 - n[d] / 2);
        break;
      case Gt:
        u[c] = u[c] + (t[d] / 2 - n[d] / 2);
        break;
    }
  }
  return u;
}
function Xt(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = r === void 0 ? e.placement : r, s = n.strategy, a = s === void 0 ? e.strategy : s, l = n.boundary, u = l === void 0 ? Iu : l, c = n.rootBoundary, d = c === void 0 ? us : c, f = n.elementContext, x = f === void 0 ? Mt : f, y = n.altBoundary, g = y === void 0 ? !1 : y, E = n.padding, v = E === void 0 ? 0 : E, P = hs(typeof v != "number" ? v : ms(v, tn)), C = x === Mt ? _u : Mt, R = e.rects.popper, m = e.elements[g ? C : x], p = pc(mt(m) ? m : m.contextElement || it(e.elements.popper), u, d, a), S = Ct(e.elements.reference), w = ys({
    reference: S,
    element: R,
    strategy: "absolute",
    placement: i
  }), N = mr(Object.assign({}, R, w)), M = x === Mt ? N : S, $ = {
    top: p.top - M.top + P.top,
    bottom: M.bottom - p.bottom + P.bottom,
    left: p.left - M.left + P.left,
    right: M.right - p.right + P.right
  }, _ = e.modifiersData.offset;
  if (x === Mt && _) {
    var D = _[i];
    Object.keys($).forEach(function(j) {
      var V = [Ve, Fe].indexOf(j) >= 0 ? 1 : -1, F = [Me, Fe].indexOf(j) >= 0 ? "y" : "x";
      $[j] += D[F] * V;
    });
  }
  return $;
}
function hc(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = n.boundary, s = n.rootBoundary, a = n.padding, l = n.flipVariations, u = n.allowedAutoPlacements, c = u === void 0 ? cs : u, d = Ot(r), f = d ? l ? Bo : Bo.filter(function(g) {
    return Ot(g) === d;
  }) : tn, x = f.filter(function(g) {
    return c.indexOf(g) >= 0;
  });
  x.length === 0 && (x = f);
  var y = x.reduce(function(g, E) {
    return g[E] = Xt(e, {
      placement: E,
      boundary: i,
      rootBoundary: s,
      padding: a
    })[He(E)], g;
  }, {});
  return Object.keys(y).sort(function(g, E) {
    return y[g] - y[E];
  });
}
function mc(e) {
  if (He(e) === Br)
    return [];
  var t = mn(e);
  return [Wo(e), t, Wo(t)];
}
function vc(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var i = n.mainAxis, s = i === void 0 ? !0 : i, a = n.altAxis, l = a === void 0 ? !0 : a, u = n.fallbackPlacements, c = n.padding, d = n.boundary, f = n.rootBoundary, x = n.altBoundary, y = n.flipVariations, g = y === void 0 ? !0 : y, E = n.allowedAutoPlacements, v = t.options.placement, P = He(v), C = P === v, R = u || (C || !g ? [mn(v)] : mc(v)), m = [v].concat(R).reduce(function(X, Q) {
      return X.concat(He(Q) === Br ? hc(t, {
        placement: Q,
        boundary: d,
        rootBoundary: f,
        padding: c,
        flipVariations: g,
        allowedAutoPlacements: E
      }) : Q);
    }, []), p = t.rects.reference, S = t.rects.popper, w = /* @__PURE__ */ new Map(), N = !0, M = m[0], $ = 0; $ < m.length; $++) {
      var _ = m[$], D = He(_), j = Ot(_) === Tt, V = [Me, Fe].indexOf(D) >= 0, F = V ? "width" : "height", k = Xt(t, {
        placement: _,
        boundary: d,
        rootBoundary: f,
        altBoundary: x,
        padding: c
      }), L = V ? j ? Ve : Ie : j ? Fe : Me;
      p[F] > S[F] && (L = mn(L));
      var A = mn(L), U = [];
      if (s && U.push(k[D] <= 0), l && U.push(k[L] <= 0, k[A] <= 0), U.every(function(X) {
        return X;
      })) {
        M = _, N = !1;
        break;
      }
      w.set(_, U);
    }
    if (N)
      for (var J = g ? 3 : 1, be = function(Q) {
        var ne = m.find(function(me) {
          var pe = w.get(me);
          if (pe)
            return pe.slice(0, Q).every(function(ue) {
              return ue;
            });
        });
        if (ne)
          return M = ne, "break";
      }, le = J; le > 0; le--) {
        var he = be(le);
        if (he === "break")
          break;
      }
    t.placement !== M && (t.modifiersData[r]._skip = !0, t.placement = M, t.reset = !0);
  }
}
const yc = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: vc,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function qo(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function Yo(e) {
  return [Me, Ve, Fe, Ie].some(function(t) {
    return e[t] >= 0;
  });
}
function gc(e) {
  var t = e.state, n = e.name, r = t.rects.reference, i = t.rects.popper, s = t.modifiersData.preventOverflow, a = Xt(t, {
    elementContext: "reference"
  }), l = Xt(t, {
    altBoundary: !0
  }), u = qo(a, r), c = qo(l, i, s), d = Yo(u), f = Yo(c);
  t.modifiersData[n] = {
    referenceClippingOffsets: u,
    popperEscapeOffsets: c,
    isReferenceHidden: d,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": f
  });
}
const bc = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: gc
};
function xc(e, t, n) {
  var r = He(e), i = [Ie, Me].indexOf(r) >= 0 ? -1 : 1, s = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, a = s[0], l = s[1];
  return a = a || 0, l = (l || 0) * i, [Ie, Ve].indexOf(r) >= 0 ? {
    x: l,
    y: a
  } : {
    x: a,
    y: l
  };
}
function Ec(e) {
  var t = e.state, n = e.options, r = e.name, i = n.offset, s = i === void 0 ? [0, 0] : i, a = cs.reduce(function(d, f) {
    return d[f] = xc(f, t.rects, s), d;
  }, {}), l = a[t.placement], u = l.x, c = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += u, t.modifiersData.popperOffsets.y += c), t.modifiersData[r] = a;
}
const Rc = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Ec
};
function Sc(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = ys({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const Pc = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Sc,
  data: {}
};
function Tc(e) {
  return e === "x" ? "y" : "x";
}
function wc(e) {
  var t = e.state, n = e.options, r = e.name, i = n.mainAxis, s = i === void 0 ? !0 : i, a = n.altAxis, l = a === void 0 ? !1 : a, u = n.boundary, c = n.rootBoundary, d = n.altBoundary, f = n.padding, x = n.tether, y = x === void 0 ? !0 : x, g = n.tetherOffset, E = g === void 0 ? 0 : g, v = Xt(t, {
    boundary: u,
    rootBoundary: c,
    padding: f,
    altBoundary: d
  }), P = He(t.placement), C = Ot(t.placement), R = !C, m = Wr(P), p = Tc(m), S = t.modifiersData.popperOffsets, w = t.rects.reference, N = t.rects.popper, M = typeof E == "function" ? E(Object.assign({}, t.rects, {
    placement: t.placement
  })) : E, $ = typeof M == "number" ? {
    mainAxis: M,
    altAxis: M
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, M), _ = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, D = {
    x: 0,
    y: 0
  };
  if (S) {
    if (s) {
      var j, V = m === "y" ? Me : Ie, F = m === "y" ? Fe : Ve, k = m === "y" ? "height" : "width", L = S[m], A = L + v[V], U = L - v[F], J = y ? -N[k] / 2 : 0, be = C === Tt ? w[k] : N[k], le = C === Tt ? -N[k] : -w[k], he = t.elements.arrow, X = y && he ? Ur(he) : {
        width: 0,
        height: 0
      }, Q = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : ps(), ne = Q[V], me = Q[F], pe = Bt(0, w[k], X[k]), ue = R ? w[k] / 2 - J - pe - ne - $.mainAxis : be - pe - ne - $.mainAxis, ye = R ? -w[k] / 2 + J + pe + me + $.mainAxis : le + pe + me + $.mainAxis, K = t.elements.arrow && nn(t.elements.arrow), I = K ? m === "y" ? K.clientTop || 0 : K.clientLeft || 0 : 0, H = (j = _ == null ? void 0 : _[m]) != null ? j : 0, O = L + ue - H - I, Z = L + ye - H, ve = Bt(y ? Rn(A, O) : A, L, y ? dt(U, Z) : U);
      S[m] = ve, D[m] = ve - L;
    }
    if (l) {
      var Re, ke = m === "x" ? Me : Ie, _e = m === "x" ? Fe : Ve, ge = S[p], ce = p === "y" ? "height" : "width", Oe = ge + v[ke], Te = ge - v[_e], de = [Me, Ie].indexOf(P) !== -1, Ne = (Re = _ == null ? void 0 : _[p]) != null ? Re : 0, Ue = de ? Oe : ge - w[ce] - N[ce] - Ne + $.altAxis, Be = de ? ge + w[ce] + N[ce] - Ne - $.altAxis : Te, ee = y && de ? Xu(Ue, ge, Be) : Bt(y ? Ue : Oe, ge, y ? Be : Te);
      S[p] = ee, D[p] = ee - ge;
    }
    t.modifiersData[r] = D;
  }
}
const Cc = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: wc,
  requiresIfExists: ["offset"]
};
function Oc(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Nc(e) {
  return e === je(e) || !De(e) ? Hr(e) : Oc(e);
}
function $c(e) {
  var t = e.getBoundingClientRect(), n = wt(t.width) / e.offsetWidth || 1, r = wt(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function kc(e, t, n) {
  n === void 0 && (n = !1);
  var r = De(t), i = De(t) && $c(t), s = it(t), a = Ct(e, i, n), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((qe(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Yr(s)) && (l = Nc(t)), De(t) ? (u = Ct(t, !0), u.x += t.clientLeft, u.y += t.clientTop) : s && (u.x = qr(s))), {
    x: a.left + l.scrollLeft - u.x,
    y: a.top + l.scrollTop - u.y,
    width: a.width,
    height: a.height
  };
}
function Mc(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(s) {
    t.set(s.name, s);
  });
  function i(s) {
    n.add(s.name);
    var a = [].concat(s.requires || [], s.requiresIfExists || []);
    a.forEach(function(l) {
      if (!n.has(l)) {
        var u = t.get(l);
        u && i(u);
      }
    }), r.push(s);
  }
  return e.forEach(function(s) {
    n.has(s.name) || i(s);
  }), r;
}
function Ic(e) {
  var t = Mc(e);
  return Wu.reduce(function(n, r) {
    return n.concat(t.filter(function(i) {
      return i.phase === r;
    }));
  }, []);
}
function _c(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function jc(e) {
  var t = e.reduce(function(n, r) {
    var i = n[r.name];
    return n[r.name] = i ? Object.assign({}, i, r, {
      options: Object.assign({}, i.options, r.options),
      data: Object.assign({}, i.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var Ko = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Go() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function Ac(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, i = t.defaultOptions, s = i === void 0 ? Ko : i;
  return function(l, u, c) {
    c === void 0 && (c = s);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Ko, s),
      modifiersData: {},
      elements: {
        reference: l,
        popper: u
      },
      attributes: {},
      styles: {}
    }, f = [], x = !1, y = {
      state: d,
      setOptions: function(P) {
        var C = typeof P == "function" ? P(d.options) : P;
        E(), d.options = Object.assign({}, s, d.options, C), d.scrollParents = {
          reference: mt(l) ? zt(l) : l.contextElement ? zt(l.contextElement) : [],
          popper: zt(u)
        };
        var R = Ic(jc([].concat(r, d.options.modifiers)));
        return d.orderedModifiers = R.filter(function(m) {
          return m.enabled;
        }), g(), y.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!x) {
          var P = d.elements, C = P.reference, R = P.popper;
          if (Go(C, R)) {
            d.rects = {
              reference: kc(C, nn(R), d.options.strategy === "fixed"),
              popper: Ur(R)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function($) {
              return d.modifiersData[$.name] = Object.assign({}, $.data);
            });
            for (var m = 0; m < d.orderedModifiers.length; m++) {
              if (d.reset === !0) {
                d.reset = !1, m = -1;
                continue;
              }
              var p = d.orderedModifiers[m], S = p.fn, w = p.options, N = w === void 0 ? {} : w, M = p.name;
              typeof S == "function" && (d = S({
                state: d,
                options: N,
                name: M,
                instance: y
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: _c(function() {
        return new Promise(function(v) {
          y.forceUpdate(), v(d);
        });
      }),
      destroy: function() {
        E(), x = !0;
      }
    };
    if (!Go(l, u))
      return y;
    y.setOptions(c).then(function(v) {
      !x && c.onFirstUpdate && c.onFirstUpdate(v);
    });
    function g() {
      d.orderedModifiers.forEach(function(v) {
        var P = v.name, C = v.options, R = C === void 0 ? {} : C, m = v.effect;
        if (typeof m == "function") {
          var p = m({
            state: d,
            name: P,
            instance: y,
            options: R
          }), S = function() {
          };
          f.push(p || S);
        }
      });
    }
    function E() {
      f.forEach(function(v) {
        return v();
      }), f = [];
    }
    return y;
  };
}
var Dc = [sc, Pc, oc, Yu, Rc, yc, Cc, ec, bc], Fc = /* @__PURE__ */ Ac({
  defaultModifiers: Dc
});
function Vc(e) {
  return typeof e == "function" ? e() : e;
}
const Jt = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const {
    children: r,
    container: i,
    disablePortal: s = !1
  } = t, [a, l] = h.useState(null), u = Ce(/* @__PURE__ */ h.isValidElement(r) ? r.ref : null, n);
  if (Xe(() => {
    s || l(Vc(i) || document.body);
  }, [i, s]), Xe(() => {
    if (a && !s)
      return ir(n, a), () => {
        ir(n, null);
      };
  }, [n, a, s]), s) {
    if (/* @__PURE__ */ h.isValidElement(r)) {
      const c = {
        ref: u
      };
      return /* @__PURE__ */ h.cloneElement(r, c);
    }
    return /* @__PURE__ */ B(h.Fragment, {
      children: r
    });
  }
  return /* @__PURE__ */ B(h.Fragment, {
    children: a && /* @__PURE__ */ Ai.createPortal(r, a)
  });
});
process.env.NODE_ENV !== "production" && (Jt.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The children to render into the `container`.
   */
  children: o.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: o.oneOfType([Ge, o.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: o.bool
});
process.env.NODE_ENV !== "production" && (Jt["propTypes"] = kr(Jt.propTypes));
function Lc(e) {
  return xe("MuiPopper", e);
}
Ee("MuiPopper", ["root"]);
const Bc = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], zc = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function Uc(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function Sn(e) {
  return typeof e == "function" ? e() : e;
}
function jn(e) {
  return e.nodeType !== void 0;
}
function Wc(e) {
  return !jn(e);
}
const Hc = () => Se({
  root: ["root"]
}, Su(Lc)), qc = {}, Yc = /* @__PURE__ */ h.forwardRef(function(t, n) {
  var r;
  const {
    anchorEl: i,
    children: s,
    direction: a,
    disablePortal: l,
    modifiers: u,
    open: c,
    placement: d,
    popperOptions: f,
    popperRef: x,
    slotProps: y = {},
    slots: g = {},
    TransitionProps: E
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = t, v = q(t, Bc), P = h.useRef(null), C = Ce(P, n), R = h.useRef(null), m = Ce(R, x), p = h.useRef(m);
  Xe(() => {
    p.current = m;
  }, [m]), h.useImperativeHandle(x, () => R.current, []);
  const S = Uc(d, a), [w, N] = h.useState(S), [M, $] = h.useState(Sn(i));
  h.useEffect(() => {
    R.current && R.current.forceUpdate();
  }), h.useEffect(() => {
    i && $(Sn(i));
  }, [i]), Xe(() => {
    if (!M || !c)
      return;
    const F = (A) => {
      N(A.placement);
    };
    if (process.env.NODE_ENV !== "production" && M && jn(M) && M.nodeType === 1) {
      const A = M.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && A.top === 0 && A.left === 0 && A.right === 0 && A.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let k = [{
      name: "preventOverflow",
      options: {
        altBoundary: l
      }
    }, {
      name: "flip",
      options: {
        altBoundary: l
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: A
      }) => {
        F(A);
      }
    }];
    u != null && (k = k.concat(u)), f && f.modifiers != null && (k = k.concat(f.modifiers));
    const L = Fc(M, P.current, b({
      placement: S
    }, f, {
      modifiers: k
    }));
    return p.current(L), () => {
      L.destroy(), p.current(null);
    };
  }, [M, l, u, c, f, S]);
  const _ = {
    placement: w
  };
  E !== null && (_.TransitionProps = E);
  const D = Hc(), j = (r = g.root) != null ? r : "div", V = ht({
    elementType: j,
    externalSlotProps: y.root,
    externalForwardedProps: v,
    additionalProps: {
      role: "tooltip",
      ref: C
    },
    ownerState: t,
    className: D.root
  });
  return /* @__PURE__ */ B(j, b({}, V, {
    children: typeof s == "function" ? s(_) : s
  }));
}), gs = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: i,
    container: s,
    direction: a = "ltr",
    disablePortal: l = !1,
    keepMounted: u = !1,
    modifiers: c,
    open: d,
    placement: f = "bottom",
    popperOptions: x = qc,
    popperRef: y,
    style: g,
    transition: E = !1,
    slotProps: v = {},
    slots: P = {}
  } = t, C = q(t, zc), [R, m] = h.useState(!0), p = () => {
    m(!1);
  }, S = () => {
    m(!0);
  };
  if (!u && !d && (!E || R))
    return null;
  let w;
  if (s)
    w = s;
  else if (r) {
    const $ = Sn(r);
    w = $ && jn($) ? $e($).body : $e(null).body;
  }
  const N = !d && u && (!E || R) ? "none" : void 0, M = E ? {
    in: d,
    onEnter: p,
    onExited: S
  } : void 0;
  return /* @__PURE__ */ B(Jt, {
    disablePortal: l,
    container: w,
    children: /* @__PURE__ */ B(Yc, b({
      anchorEl: r,
      direction: a,
      disablePortal: l,
      modifiers: c,
      ref: n,
      open: E ? !R : d,
      placement: f,
      popperOptions: x,
      popperRef: y,
      slotProps: v,
      slots: P
    }, C, {
      style: b({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: N
      }, g),
      TransitionProps: M,
      children: i
    }))
  });
});
process.env.NODE_ENV !== "production" && (gs.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: ot(o.oneOfType([Ge, o.object, o.func]), (e) => {
    if (e.open) {
      const t = Sn(e.anchorEl);
      if (t && jn(t) && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || Wc(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: o.oneOfType([o.node, o.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: o.oneOfType([Ge, o.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: o.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: o.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: o.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: o.arrayOf(o.shape({
    data: o.object,
    effect: o.func,
    enabled: o.bool,
    fn: o.func,
    name: o.any,
    options: o.object,
    phase: o.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: o.arrayOf(o.string),
    requiresIfExists: o.arrayOf(o.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: o.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: o.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: o.shape({
    modifiers: o.array,
    onFirstUpdate: o.func,
    placement: o.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: o.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Ye,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: o.shape({
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: o.shape({
    root: o.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: o.bool
});
function Kc(e) {
  const t = $e(e);
  return t.body === e ? pt(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function Ut(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function Xo(e) {
  return parseInt(pt(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function Gc(e) {
  const n = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].indexOf(e.tagName) !== -1, r = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return n || r;
}
function Jo(e, t, n, r, i) {
  const s = [t, n, ...r];
  [].forEach.call(e.children, (a) => {
    const l = s.indexOf(a) === -1, u = !Gc(a);
    l && u && Ut(a, i);
  });
}
function Wn(e, t) {
  let n = -1;
  return e.some((r, i) => t(r) ? (n = i, !0) : !1), n;
}
function Xc(e, t) {
  const n = [], r = e.container;
  if (!t.disableScrollLock) {
    if (Kc(r)) {
      const a = Bi($e(r));
      n.push({
        value: r.style.paddingRight,
        property: "padding-right",
        el: r
      }), r.style.paddingRight = `${Xo(r) + a}px`;
      const l = $e(r).querySelectorAll(".mui-fixed");
      [].forEach.call(l, (u) => {
        n.push({
          value: u.style.paddingRight,
          property: "padding-right",
          el: u
        }), u.style.paddingRight = `${Xo(u) + a}px`;
      });
    }
    let s;
    if (r.parentNode instanceof DocumentFragment)
      s = $e(r).body;
    else {
      const a = r.parentElement, l = pt(r);
      s = (a == null ? void 0 : a.nodeName) === "HTML" && l.getComputedStyle(a).overflowY === "scroll" ? a : r;
    }
    n.push({
      value: s.style.overflow,
      property: "overflow",
      el: s
    }, {
      value: s.style.overflowX,
      property: "overflow-x",
      el: s
    }, {
      value: s.style.overflowY,
      property: "overflow-y",
      el: s
    }), s.style.overflow = "hidden";
  }
  return () => {
    n.forEach(({
      value: s,
      el: a,
      property: l
    }) => {
      s ? a.style.setProperty(l, s) : a.style.removeProperty(l);
    });
  };
}
function Jc(e) {
  const t = [];
  return [].forEach.call(e.children, (n) => {
    n.getAttribute("aria-hidden") === "true" && t.push(n);
  }), t;
}
class Zc {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(t, n) {
    let r = this.modals.indexOf(t);
    if (r !== -1)
      return r;
    r = this.modals.length, this.modals.push(t), t.modalRef && Ut(t.modalRef, !1);
    const i = Jc(n);
    Jo(n, t.mount, t.modalRef, i, !0);
    const s = Wn(this.containers, (a) => a.container === n);
    return s !== -1 ? (this.containers[s].modals.push(t), r) : (this.containers.push({
      modals: [t],
      container: n,
      restore: null,
      hiddenSiblings: i
    }), r);
  }
  mount(t, n) {
    const r = Wn(this.containers, (s) => s.modals.indexOf(t) !== -1), i = this.containers[r];
    i.restore || (i.restore = Xc(i, n));
  }
  remove(t, n = !0) {
    const r = this.modals.indexOf(t);
    if (r === -1)
      return r;
    const i = Wn(this.containers, (a) => a.modals.indexOf(t) !== -1), s = this.containers[i];
    if (s.modals.splice(s.modals.indexOf(t), 1), this.modals.splice(r, 1), s.modals.length === 0)
      s.restore && s.restore(), t.modalRef && Ut(t.modalRef, n), Jo(s.container, t.mount, t.modalRef, s.hiddenSiblings, !1), this.containers.splice(i, 1);
    else {
      const a = s.modals[s.modals.length - 1];
      a.modalRef && Ut(a.modalRef, !1);
    }
    return r;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
function Qc(e) {
  return typeof e == "function" ? e() : e;
}
function ed(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const td = new Zc();
function nd(e) {
  const {
    container: t,
    disableEscapeKeyDown: n = !1,
    disableScrollLock: r = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: i = td,
    closeAfterTransition: s = !1,
    onTransitionEnter: a,
    onTransitionExited: l,
    children: u,
    onClose: c,
    open: d,
    rootRef: f
  } = e, x = h.useRef({}), y = h.useRef(null), g = h.useRef(null), E = Ce(g, f), [v, P] = h.useState(!d), C = ed(u);
  let R = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (R = !1);
  const m = () => $e(y.current), p = () => (x.current.modalRef = g.current, x.current.mount = y.current, x.current), S = () => {
    i.mount(p(), {
      disableScrollLock: r
    }), g.current && (g.current.scrollTop = 0);
  }, w = St(() => {
    const k = Qc(t) || m().body;
    i.add(p(), k), g.current && S();
  }), N = h.useCallback(() => i.isTopModal(p()), [i]), M = St((k) => {
    y.current = k, k && (d && N() ? S() : g.current && Ut(g.current, R));
  }), $ = h.useCallback(() => {
    i.remove(p(), R);
  }, [R, i]);
  h.useEffect(() => () => {
    $();
  }, [$]), h.useEffect(() => {
    d ? w() : (!C || !s) && $();
  }, [d, $, C, s, w]);
  const _ = (k) => (L) => {
    var A;
    (A = k.onKeyDown) == null || A.call(k, L), !(L.key !== "Escape" || !N()) && (n || (L.stopPropagation(), c && c(L, "escapeKeyDown")));
  }, D = (k) => (L) => {
    var A;
    (A = k.onClick) == null || A.call(k, L), L.target === L.currentTarget && c && c(L, "backdropClick");
  };
  return {
    getRootProps: (k = {}) => {
      const L = ls(e);
      delete L.onTransitionEnter, delete L.onTransitionExited;
      const A = b({}, L, k);
      return b({
        role: "presentation"
      }, A, {
        onKeyDown: _(A),
        ref: E
      });
    },
    getBackdropProps: (k = {}) => {
      const L = k;
      return b({
        "aria-hidden": !0
      }, L, {
        onClick: D(L),
        open: d
      });
    },
    getTransitionProps: () => {
      const k = () => {
        P(!1), a && a();
      }, L = () => {
        P(!0), l && l(), s && $();
      };
      return {
        onEnter: mo(k, u == null ? void 0 : u.props.onEnter),
        onExited: mo(L, u == null ? void 0 : u.props.onExited)
      };
    },
    rootRef: E,
    portalRef: M,
    isTopModal: N,
    exited: v,
    hasTransition: C
  };
}
const rd = ["onChange", "maxRows", "minRows", "style", "value"];
function ln(e) {
  return parseInt(e, 10) || 0;
}
const od = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function Zo(e) {
  return e == null || Object.keys(e).length === 0 || e.outerHeightStyle === 0 && !e.overflow;
}
const bs = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const {
    onChange: r,
    maxRows: i,
    minRows: s = 1,
    style: a,
    value: l
  } = t, u = q(t, rd), {
    current: c
  } = h.useRef(l != null), d = h.useRef(null), f = Ce(n, d), x = h.useRef(null), y = h.useRef(0), [g, E] = h.useState({
    outerHeightStyle: 0
  }), v = h.useCallback(() => {
    const m = d.current, S = pt(m).getComputedStyle(m);
    if (S.width === "0px")
      return {
        outerHeightStyle: 0
      };
    const w = x.current;
    w.style.width = S.width, w.value = m.value || t.placeholder || "x", w.value.slice(-1) === `
` && (w.value += " ");
    const N = S.boxSizing, M = ln(S.paddingBottom) + ln(S.paddingTop), $ = ln(S.borderBottomWidth) + ln(S.borderTopWidth), _ = w.scrollHeight;
    w.value = "x";
    const D = w.scrollHeight;
    let j = _;
    s && (j = Math.max(Number(s) * D, j)), i && (j = Math.min(Number(i) * D, j)), j = Math.max(j, D);
    const V = j + (N === "border-box" ? M + $ : 0), F = Math.abs(j - _) <= 1;
    return {
      outerHeightStyle: V,
      overflow: F
    };
  }, [i, s, t.placeholder]), P = (m, p) => {
    const {
      outerHeightStyle: S,
      overflow: w
    } = p;
    return y.current < 20 && (S > 0 && Math.abs((m.outerHeightStyle || 0) - S) > 1 || m.overflow !== w) ? (y.current += 1, {
      overflow: w,
      outerHeightStyle: S
    }) : (process.env.NODE_ENV !== "production" && y.current === 20 && console.error(["MUI: Too many re-renders. The layout is unstable.", "TextareaAutosize limits the number of renders to prevent an infinite loop."].join(`
`)), m);
  }, C = h.useCallback(() => {
    const m = v();
    Zo(m) || E((p) => P(p, m));
  }, [v]);
  Xe(() => {
    const m = () => {
      const D = v();
      Zo(D) || Ai.flushSync(() => {
        E((j) => P(j, D));
      });
    }, p = () => {
      y.current = 0, m();
    };
    let S;
    const w = () => {
      cancelAnimationFrame(S), S = requestAnimationFrame(() => {
        p();
      });
    }, N = Li(p), M = d.current, $ = pt(M);
    $.addEventListener("resize", N);
    let _;
    return typeof ResizeObserver < "u" && (_ = new ResizeObserver(process.env.NODE_ENV === "test" ? w : p), _.observe(M)), () => {
      N.clear(), cancelAnimationFrame(S), $.removeEventListener("resize", N), _ && _.disconnect();
    };
  }, [v]), Xe(() => {
    C();
  }), h.useEffect(() => {
    y.current = 0;
  }, [l]);
  const R = (m) => {
    y.current = 0, c || C(), r && r(m);
  };
  return /* @__PURE__ */ ze(h.Fragment, {
    children: [/* @__PURE__ */ B("textarea", b({
      value: l,
      onChange: R,
      ref: f,
      rows: s,
      style: b({
        height: g.outerHeightStyle,
        // Need a large enough difference to allow scrolling.
        // This prevents infinite rendering loop.
        overflow: g.overflow ? "hidden" : void 0
      }, a)
    }, u)), /* @__PURE__ */ B("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: x,
      tabIndex: -1,
      style: b({}, od.shadow, a, {
        paddingTop: 0,
        paddingBottom: 0
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (bs.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  className: o.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: o.oneOfType([o.number, o.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: o.oneOfType([o.number, o.string]),
  /**
   * @ignore
   */
  onChange: o.func,
  /**
   * @ignore
   */
  placeholder: o.string,
  /**
   * @ignore
   */
  style: o.object,
  /**
   * @ignore
   */
  value: o.oneOfType([o.arrayOf(o.string), o.number, o.string])
});
const id = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"], sd = G(gs, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), xs = /* @__PURE__ */ h.forwardRef(function(t, n) {
  var r;
  const i = ki(), s = Pe({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: a,
    component: l,
    components: u,
    componentsProps: c,
    container: d,
    disablePortal: f,
    keepMounted: x,
    modifiers: y,
    open: g,
    placement: E,
    popperOptions: v,
    popperRef: P,
    transition: C,
    slots: R,
    slotProps: m
  } = s, p = q(s, id), S = (r = R == null ? void 0 : R.root) != null ? r : u == null ? void 0 : u.Root, w = b({
    anchorEl: a,
    container: d,
    disablePortal: f,
    keepMounted: x,
    modifiers: y,
    open: g,
    placement: E,
    popperOptions: v,
    popperRef: P,
    transition: C
  }, p);
  return /* @__PURE__ */ B(sd, b({
    as: l,
    direction: i == null ? void 0 : i.direction,
    slots: {
      root: S
    },
    slotProps: m ?? c
  }, w, {
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (xs.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: o.oneOfType([Ge, o.object, o.func]),
  /**
   * Popper render function or node.
   */
  children: o.oneOfType([o.node, o.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: o.shape({
    Root: o.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  componentsProps: o.shape({
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: o.oneOfType([Ge, o.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: o.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: o.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: o.arrayOf(o.shape({
    data: o.object,
    effect: o.func,
    enabled: o.bool,
    fn: o.func,
    name: o.any,
    options: o.object,
    phase: o.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: o.arrayOf(o.string),
    requiresIfExists: o.arrayOf(o.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: o.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: o.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: o.shape({
    modifiers: o.array,
    onFirstUpdate: o.func,
    placement: o.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: o.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Ye,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: o.shape({
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: o.shape({
    root: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: o.bool
});
const xm = xs;
function Kr({
  props: e,
  states: t,
  muiFormControl: n
}) {
  return t.reduce((r, i) => (r[i] = e[i], n && typeof e[i] > "u" && (r[i] = n[i]), r), {});
}
const Es = /* @__PURE__ */ h.createContext(void 0);
process.env.NODE_ENV !== "production" && (Es.displayName = "FormControlContext");
const Rs = Es;
function Gr() {
  return h.useContext(Rs);
}
function Ss(e) {
  return /* @__PURE__ */ B(Ji, b({}, e, {
    defaultTheme: $n,
    themeId: Qt
  }));
}
process.env.NODE_ENV !== "production" && (Ss.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The styles you want to apply globally.
   */
  styles: o.oneOfType([o.array, o.func, o.number, o.object, o.string, o.bool])
});
function Qo(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function Ps(e, t = !1) {
  return e && (Qo(e.value) && e.value !== "" || t && Qo(e.defaultValue) && e.defaultValue !== "");
}
function Em(e) {
  return e.startAdornment;
}
function ad(e) {
  return xe("MuiInputBase", e);
}
const ld = Ee("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]), Nt = ld, ud = ["aria-describedby", "autoComplete", "autoFocus", "className", "color", "components", "componentsProps", "defaultValue", "disabled", "disableInjectingGlobalStyles", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "size", "slotProps", "slots", "startAdornment", "type", "value"], An = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.formControl && t.formControl, n.startAdornment && t.adornedStart, n.endAdornment && t.adornedEnd, n.error && t.error, n.size === "small" && t.sizeSmall, n.multiline && t.multiline, n.color && t[`color${fe(n.color)}`], n.fullWidth && t.fullWidth, n.hiddenLabel && t.hiddenLabel];
}, Dn = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.input, n.size === "small" && t.inputSizeSmall, n.multiline && t.inputMultiline, n.type === "search" && t.inputTypeSearch, n.startAdornment && t.inputAdornedStart, n.endAdornment && t.inputAdornedEnd, n.hiddenLabel && t.inputHiddenLabel];
}, cd = (e) => {
  const {
    classes: t,
    color: n,
    disabled: r,
    error: i,
    endAdornment: s,
    focused: a,
    formControl: l,
    fullWidth: u,
    hiddenLabel: c,
    multiline: d,
    readOnly: f,
    size: x,
    startAdornment: y,
    type: g
  } = e, E = {
    root: ["root", `color${fe(n)}`, r && "disabled", i && "error", u && "fullWidth", a && "focused", l && "formControl", x && x !== "medium" && `size${fe(x)}`, d && "multiline", y && "adornedStart", s && "adornedEnd", c && "hiddenLabel", f && "readOnly"],
    input: ["input", r && "disabled", g === "search" && "inputTypeSearch", d && "inputMultiline", x === "small" && "inputSizeSmall", c && "inputHiddenLabel", y && "inputAdornedStart", s && "inputAdornedEnd", f && "readOnly"]
  };
  return Se(E, ad, t);
}, Fn = G("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: An
})(({
  theme: e,
  ownerState: t
}) => b({}, e.typography.body1, {
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${Nt.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  }
}, t.multiline && b({
  padding: "4px 0 5px"
}, t.size === "small" && {
  paddingTop: 1
}), t.fullWidth && {
  width: "100%"
})), Vn = G("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: Dn
})(({
  theme: e,
  ownerState: t
}) => {
  const n = e.palette.mode === "light", r = b({
    color: "currentColor"
  }, e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: n ? 0.42 : 0.5
  }, {
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }), i = {
    opacity: "0 !important"
  }, s = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: n ? 0.42 : 0.5
  };
  return b({
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    // Fix IE11 width issue
    animationName: "mui-auto-fill-cancel",
    animationDuration: "10ms",
    "&::-webkit-input-placeholder": r,
    "&::-moz-placeholder": r,
    // Firefox 19+
    "&:-ms-input-placeholder": r,
    // IE11
    "&::-ms-input-placeholder": r,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${Nt.formControl} &`]: {
      "&::-webkit-input-placeholder": i,
      "&::-moz-placeholder": i,
      // Firefox 19+
      "&:-ms-input-placeholder": i,
      // IE11
      "&::-ms-input-placeholder": i,
      // Edge
      "&:focus::-webkit-input-placeholder": s,
      "&:focus::-moz-placeholder": s,
      // Firefox 19+
      "&:focus:-ms-input-placeholder": s,
      // IE11
      "&:focus::-ms-input-placeholder": s
      // Edge
    },
    [`&.${Nt.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    "&:-webkit-autofill": {
      animationDuration: "5000s",
      animationName: "mui-auto-fill"
    }
  }, t.size === "small" && {
    paddingTop: 1
  }, t.multiline && {
    height: "auto",
    resize: "none",
    padding: 0,
    paddingTop: 0
  }, t.type === "search" && {
    // Improve type search style.
    MozAppearance: "textfield"
  });
}), dd = /* @__PURE__ */ B(Ss, {
  styles: {
    "@keyframes mui-auto-fill": {
      from: {
        display: "block"
      }
    },
    "@keyframes mui-auto-fill-cancel": {
      from: {
        display: "block"
      }
    }
  }
}), Ts = /* @__PURE__ */ h.forwardRef(function(t, n) {
  var r;
  const i = Pe({
    props: t,
    name: "MuiInputBase"
  }), {
    "aria-describedby": s,
    autoComplete: a,
    autoFocus: l,
    className: u,
    components: c = {},
    componentsProps: d = {},
    defaultValue: f,
    disabled: x,
    disableInjectingGlobalStyles: y,
    endAdornment: g,
    fullWidth: E = !1,
    id: v,
    inputComponent: P = "input",
    inputProps: C = {},
    inputRef: R,
    maxRows: m,
    minRows: p,
    multiline: S = !1,
    name: w,
    onBlur: N,
    onChange: M,
    onClick: $,
    onFocus: _,
    onKeyDown: D,
    onKeyUp: j,
    placeholder: V,
    readOnly: F,
    renderSuffix: k,
    rows: L,
    slotProps: A = {},
    slots: U = {},
    startAdornment: J,
    type: be = "text",
    value: le
  } = i, he = q(i, ud), X = C.value != null ? C.value : le, {
    current: Q
  } = h.useRef(X != null), ne = h.useRef(), me = h.useCallback((ee) => {
    process.env.NODE_ENV !== "production" && ee && ee.nodeName !== "INPUT" && !ee.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), pe = Ce(ne, R, C.ref, me), [ue, ye] = h.useState(!1), K = Gr();
  process.env.NODE_ENV !== "production" && h.useEffect(() => {
    if (K)
      return K.registerEffect();
  }, [K]);
  const I = Kr({
    props: i,
    muiFormControl: K,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  I.focused = K ? K.focused : ue, h.useEffect(() => {
    !K && x && ue && (ye(!1), N && N());
  }, [K, x, ue, N]);
  const H = K && K.onFilled, O = K && K.onEmpty, Z = h.useCallback((ee) => {
    Ps(ee) ? H && H() : O && O();
  }, [H, O]);
  Xe(() => {
    Q && Z({
      value: X
    });
  }, [X, Z, Q]);
  const ve = (ee) => {
    if (I.disabled) {
      ee.stopPropagation();
      return;
    }
    _ && _(ee), C.onFocus && C.onFocus(ee), K && K.onFocus ? K.onFocus(ee) : ye(!0);
  }, Re = (ee) => {
    N && N(ee), C.onBlur && C.onBlur(ee), K && K.onBlur ? K.onBlur(ee) : ye(!1);
  }, ke = (ee, ...W) => {
    if (!Q) {
      const We = ee.target || ne.current;
      if (We == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : ji(1));
      Z({
        value: We.value
      });
    }
    C.onChange && C.onChange(ee, ...W), M && M(ee, ...W);
  };
  h.useEffect(() => {
    Z(ne.current);
  }, []);
  const _e = (ee) => {
    ne.current && ee.currentTarget === ee.target && ne.current.focus(), $ && $(ee);
  };
  let ge = P, ce = C;
  S && ge === "input" && (L ? (process.env.NODE_ENV !== "production" && (p || m) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), ce = b({
    type: void 0,
    minRows: L,
    maxRows: L
  }, ce)) : ce = b({
    type: void 0,
    maxRows: m,
    minRows: p
  }, ce), ge = bs);
  const Oe = (ee) => {
    Z(ee.animationName === "mui-auto-fill-cancel" ? ne.current : {
      value: "x"
    });
  };
  h.useEffect(() => {
    K && K.setAdornedStart(!!J);
  }, [K, J]);
  const Te = b({}, i, {
    color: I.color || "primary",
    disabled: I.disabled,
    endAdornment: g,
    error: I.error,
    focused: I.focused,
    formControl: K,
    fullWidth: E,
    hiddenLabel: I.hiddenLabel,
    multiline: S,
    size: I.size,
    startAdornment: J,
    type: be
  }), de = cd(Te), Ne = U.root || c.Root || Fn, Ue = A.root || d.root || {}, Be = U.input || c.Input || Vn;
  return ce = b({}, ce, (r = A.input) != null ? r : d.input), /* @__PURE__ */ ze(h.Fragment, {
    children: [!y && dd, /* @__PURE__ */ ze(Ne, b({}, Ue, !xn(Ne) && {
      ownerState: b({}, Te, Ue.ownerState)
    }, {
      ref: n,
      onClick: _e
    }, he, {
      className: ae(de.root, Ue.className, u, F && "MuiInputBase-readOnly"),
      children: [J, /* @__PURE__ */ B(Rs.Provider, {
        value: null,
        children: /* @__PURE__ */ B(Be, b({
          ownerState: Te,
          "aria-invalid": I.error,
          "aria-describedby": s,
          autoComplete: a,
          autoFocus: l,
          defaultValue: f,
          disabled: I.disabled,
          id: v,
          onAnimationStart: Oe,
          name: w,
          placeholder: V,
          readOnly: F,
          required: I.required,
          rows: L,
          value: X,
          onKeyDown: D,
          onKeyUp: j,
          type: be
        }, ce, !xn(Be) && {
          as: ge,
          ownerState: b({}, Te, ce.ownerState)
        }, {
          ref: pe,
          className: ae(de.input, ce.className, F && "MuiInputBase-readOnly"),
          onBlur: Re,
          onChange: ke,
          onFocus: ve
        }))
      }), g, k ? k(b({}, I, {
        startAdornment: J
      })) : null]
    }))]
  });
});
process.env.NODE_ENV !== "production" && (Ts.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  "aria-describedby": o.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: o.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: o.shape({
    Input: o.elementType,
    Root: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: o.shape({
    input: o.object,
    root: o.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: o.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: o.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: o.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: o.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * The id of the `input` element.
   */
  id: o.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: Mr,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Ye,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: o.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: o.oneOfType([o.number, o.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: o.oneOfType([o.number, o.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: o.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: o.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: o.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: o.func,
  /**
   * @ignore
   */
  onClick: o.func,
  /**
   * @ignore
   */
  onFocus: o.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: o.func,
  /**
   * @ignore
   */
  onKeyDown: o.func,
  /**
   * @ignore
   */
  onKeyUp: o.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: o.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: o.bool,
  /**
   * @ignore
   */
  renderSuffix: o.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: o.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: o.oneOfType([o.number, o.string]),
  /**
   * The size of the component.
   */
  size: o.oneOfType([o.oneOf(["medium", "small"]), o.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: o.shape({
    input: o.object,
    root: o.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: o.shape({
    input: o.elementType,
    root: o.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: o.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: o.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: o.any
});
const Xr = Ts;
function fd(e) {
  return xe("MuiInput", e);
}
const pd = b({}, Nt, Ee("MuiInput", ["root", "underline", "input"])), It = pd;
function hd(e) {
  return xe("MuiOutlinedInput", e);
}
const md = b({}, Nt, Ee("MuiOutlinedInput", ["root", "notchedOutline", "input"])), Qe = md;
function vd(e) {
  return xe("MuiFilledInput", e);
}
const yd = b({}, Nt, Ee("MuiFilledInput", ["root", "underline", "input"])), st = yd, gd = Fr(/* @__PURE__ */ B("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"), bd = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], xd = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, ws = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const r = kn(), i = {
    enter: r.transitions.duration.enteringScreen,
    exit: r.transitions.duration.leavingScreen
  }, {
    addEndListener: s,
    appear: a = !0,
    children: l,
    easing: u,
    in: c,
    onEnter: d,
    onEntered: f,
    onEntering: x,
    onExit: y,
    onExited: g,
    onExiting: E,
    style: v,
    timeout: P = i,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: C = es
  } = t, R = q(t, bd), m = h.useRef(null), p = Ce(m, l.ref, n), S = (V) => (F) => {
    if (V) {
      const k = m.current;
      F === void 0 ? V(k) : V(k, F);
    }
  }, w = S(x), N = S((V, F) => {
    ts(V);
    const k = bn({
      style: v,
      timeout: P,
      easing: u
    }, {
      mode: "enter"
    });
    V.style.webkitTransition = r.transitions.create("opacity", k), V.style.transition = r.transitions.create("opacity", k), d && d(V, F);
  }), M = S(f), $ = S(E), _ = S((V) => {
    const F = bn({
      style: v,
      timeout: P,
      easing: u
    }, {
      mode: "exit"
    });
    V.style.webkitTransition = r.transitions.create("opacity", F), V.style.transition = r.transitions.create("opacity", F), y && y(V);
  }), D = S(g);
  return /* @__PURE__ */ B(C, b({
    appear: a,
    in: c,
    nodeRef: m,
    onEnter: N,
    onEntered: M,
    onEntering: w,
    onExit: _,
    onExited: D,
    onExiting: $,
    addEndListener: (V) => {
      s && s(m.current, V);
    },
    timeout: P
  }, R, {
    children: (V, F) => /* @__PURE__ */ h.cloneElement(l, b({
      style: b({
        opacity: 0,
        visibility: V === "exited" && !c ? "hidden" : void 0
      }, xd[V], v, l.props.style),
      ref: p
    }, F))
  }));
});
process.env.NODE_ENV !== "production" && (ws.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: o.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: o.bool,
  /**
   * A single child content element.
   */
  children: Cn.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: o.oneOfType([o.shape({
    enter: o.string,
    exit: o.string
  }), o.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: o.bool,
  /**
   * @ignore
   */
  onEnter: o.func,
  /**
   * @ignore
   */
  onEntered: o.func,
  /**
   * @ignore
   */
  onEntering: o.func,
  /**
   * @ignore
   */
  onExit: o.func,
  /**
   * @ignore
   */
  onExited: o.func,
  /**
   * @ignore
   */
  onExiting: o.func,
  /**
   * @ignore
   */
  style: o.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: o.oneOfType([o.number, o.shape({
    appear: o.number,
    enter: o.number,
    exit: o.number
  })])
});
const Ed = ws;
function Rd(e) {
  return xe("MuiBackdrop", e);
}
Ee("MuiBackdrop", ["root", "invisible"]);
const Sd = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"], Pd = (e) => {
  const {
    classes: t,
    invisible: n
  } = e;
  return Se({
    root: ["root", n && "invisible"]
  }, Rd, t);
}, Td = G("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.invisible && t.invisible];
  }
})(({
  ownerState: e
}) => b({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent"
}, e.invisible && {
  backgroundColor: "transparent"
})), Cs = /* @__PURE__ */ h.forwardRef(function(t, n) {
  var r, i, s;
  const a = Pe({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: l,
    className: u,
    component: c = "div",
    components: d = {},
    componentsProps: f = {},
    invisible: x = !1,
    open: y,
    slotProps: g = {},
    slots: E = {},
    TransitionComponent: v = Ed,
    transitionDuration: P
  } = a, C = q(a, Sd), R = b({}, a, {
    component: c,
    invisible: x
  }), m = Pd(R), p = (r = g.root) != null ? r : f.root;
  return /* @__PURE__ */ B(v, b({
    in: y,
    timeout: P
  }, C, {
    children: /* @__PURE__ */ B(Td, b({
      "aria-hidden": !0
    }, p, {
      as: (i = (s = E.root) != null ? s : d.Root) != null ? i : c,
      className: ae(m.root, u, p == null ? void 0 : p.className),
      ownerState: b({}, R, p == null ? void 0 : p.ownerState),
      classes: m,
      ref: n,
      children: l
    }))
  }));
});
process.env.NODE_ENV !== "production" && (Cs.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: o.shape({
    Root: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: o.shape({
    root: o.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: o.bool,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool.isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: o.shape({
    root: o.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: o.shape({
    root: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: o.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: o.oneOfType([o.number, o.shape({
    appear: o.number,
    enter: o.number,
    exit: o.number
  })])
});
const wd = Cs, Cd = _i(), Os = fl({
  themeId: Qt,
  defaultTheme: Cd,
  defaultClassName: "MuiBox-root",
  generateClassName: ca.generate
});
process.env.NODE_ENV !== "production" && (Os.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: o.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
const Rm = Os;
function Od(e) {
  return xe("MuiCircularProgress", e);
}
Ee("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const Nd = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];
let Ln = (e) => e, ei, ti, ni, ri;
const et = 44, $d = en(ei || (ei = Ln`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`)), kd = en(ti || (ti = Ln`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`)), Md = (e) => {
  const {
    classes: t,
    variant: n,
    color: r,
    disableShrink: i
  } = e, s = {
    root: ["root", n, `color${fe(r)}`],
    svg: ["svg"],
    circle: ["circle", `circle${fe(n)}`, i && "circleDisableShrink"]
  };
  return Se(s, Od, t);
}, Id = G("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`color${fe(n.color)}`]];
  }
})(({
  ownerState: e,
  theme: t
}) => b({
  display: "inline-block"
}, e.variant === "determinate" && {
  transition: t.transitions.create("transform")
}, e.color !== "inherit" && {
  color: (t.vars || t).palette[e.color].main
}), ({
  ownerState: e
}) => e.variant === "indeterminate" && Ar(ni || (ni = Ln`
      animation: ${0} 1.4s linear infinite;
    `), $d)), _d = G("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (e, t) => t.svg
})({
  display: "block"
  // Keeps the progress centered
}), jd = G("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.circle, t[`circle${fe(n.variant)}`], n.disableShrink && t.circleDisableShrink];
  }
})(({
  ownerState: e,
  theme: t
}) => b({
  stroke: "currentColor"
}, e.variant === "determinate" && {
  transition: t.transitions.create("stroke-dashoffset")
}, e.variant === "indeterminate" && {
  // Some default value that looks fine waiting for the animation to kicks in.
  strokeDasharray: "80px, 200px",
  strokeDashoffset: 0
  // Add the unit to fix a Edge 16 and below bug.
}), ({
  ownerState: e
}) => e.variant === "indeterminate" && !e.disableShrink && Ar(ri || (ri = Ln`
      animation: ${0} 1.4s ease-in-out infinite;
    `), kd)), Ns = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const r = Pe({
    props: t,
    name: "MuiCircularProgress"
  }), {
    className: i,
    color: s = "primary",
    disableShrink: a = !1,
    size: l = 40,
    style: u,
    thickness: c = 3.6,
    value: d = 0,
    variant: f = "indeterminate"
  } = r, x = q(r, Nd), y = b({}, r, {
    color: s,
    disableShrink: a,
    size: l,
    thickness: c,
    value: d,
    variant: f
  }), g = Md(y), E = {}, v = {}, P = {};
  if (f === "determinate") {
    const C = 2 * Math.PI * ((et - c) / 2);
    E.strokeDasharray = C.toFixed(3), P["aria-valuenow"] = Math.round(d), E.strokeDashoffset = `${((100 - d) / 100 * C).toFixed(3)}px`, v.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ B(Id, b({
    className: ae(g.root, i),
    style: b({
      width: l,
      height: l
    }, v, u),
    ownerState: y,
    ref: n,
    role: "progressbar"
  }, P, x, {
    children: /* @__PURE__ */ B(_d, {
      className: g.svg,
      ownerState: y,
      viewBox: `${et / 2} ${et / 2} ${et} ${et}`,
      children: /* @__PURE__ */ B(jd, {
        className: g.circle,
        style: E,
        ownerState: y,
        cx: et,
        cy: et,
        r: (et - c) / 2,
        fill: "none",
        strokeWidth: c
      })
    })
  }));
});
process.env.NODE_ENV !== "production" && (Ns.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: o.oneOfType([o.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: ot(o.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, e.g. '3rem'.
   * @default 40
   */
  size: o.oneOfType([o.number, o.string]),
  /**
   * @ignore
   */
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: o.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: o.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: o.oneOf(["determinate", "indeterminate"])
});
const Sm = Ns;
function Ad(e) {
  return xe("MuiModal", e);
}
Ee("MuiModal", ["root", "hidden", "backdrop"]);
const Dd = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onTransitionEnter", "onTransitionExited", "open", "slotProps", "slots", "theme"], Fd = (e) => {
  const {
    open: t,
    exited: n,
    classes: r
  } = e;
  return Se({
    root: ["root", !t && n && "hidden"],
    backdrop: ["backdrop"]
  }, Ad, r);
}, Vd = G("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.open && n.exited && t.hidden];
  }
})(({
  theme: e,
  ownerState: t
}) => b({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !t.open && t.exited && {
  visibility: "hidden"
})), Ld = G(wd, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), $s = /* @__PURE__ */ h.forwardRef(function(t, n) {
  var r, i, s, a, l, u;
  const c = Pe({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: d = Ld,
    BackdropProps: f,
    className: x,
    closeAfterTransition: y = !1,
    children: g,
    container: E,
    component: v,
    components: P = {},
    componentsProps: C = {},
    disableAutoFocus: R = !1,
    disableEnforceFocus: m = !1,
    disableEscapeKeyDown: p = !1,
    disablePortal: S = !1,
    disableRestoreFocus: w = !1,
    disableScrollLock: N = !1,
    hideBackdrop: M = !1,
    keepMounted: $ = !1,
    onBackdropClick: _,
    open: D,
    slotProps: j,
    slots: V
    // eslint-disable-next-line react/prop-types
  } = c, F = q(c, Dd), k = b({}, c, {
    closeAfterTransition: y,
    disableAutoFocus: R,
    disableEnforceFocus: m,
    disableEscapeKeyDown: p,
    disablePortal: S,
    disableRestoreFocus: w,
    disableScrollLock: N,
    hideBackdrop: M,
    keepMounted: $
  }), {
    getRootProps: L,
    getBackdropProps: A,
    getTransitionProps: U,
    portalRef: J,
    isTopModal: be,
    exited: le,
    hasTransition: he
  } = nd(b({}, k, {
    rootRef: n
  })), X = b({}, k, {
    exited: le
  }), Q = Fd(X), ne = {};
  if (g.props.tabIndex === void 0 && (ne.tabIndex = "-1"), he) {
    const {
      onEnter: H,
      onExited: O
    } = U();
    ne.onEnter = H, ne.onExited = O;
  }
  const me = (r = (i = V == null ? void 0 : V.root) != null ? i : P.Root) != null ? r : Vd, pe = (s = (a = V == null ? void 0 : V.backdrop) != null ? a : P.Backdrop) != null ? s : d, ue = (l = j == null ? void 0 : j.root) != null ? l : C.root, ye = (u = j == null ? void 0 : j.backdrop) != null ? u : C.backdrop, K = ht({
    elementType: me,
    externalSlotProps: ue,
    externalForwardedProps: F,
    getSlotProps: L,
    additionalProps: {
      ref: n,
      as: v
    },
    ownerState: X,
    className: ae(x, ue == null ? void 0 : ue.className, Q == null ? void 0 : Q.root, !X.open && X.exited && (Q == null ? void 0 : Q.hidden))
  }), I = ht({
    elementType: pe,
    externalSlotProps: ye,
    additionalProps: f,
    getSlotProps: (H) => A(b({}, H, {
      onClick: (O) => {
        _ && _(O), H != null && H.onClick && H.onClick(O);
      }
    })),
    className: ae(ye == null ? void 0 : ye.className, f == null ? void 0 : f.className, Q == null ? void 0 : Q.backdrop),
    ownerState: X
  });
  return !$ && !D && (!he || le) ? null : /* @__PURE__ */ B(Jt, {
    ref: J,
    container: E,
    disablePortal: S,
    children: /* @__PURE__ */ ze(me, b({}, K, {
      children: [!M && d ? /* @__PURE__ */ B(pe, b({}, I)) : null, /* @__PURE__ */ B(En, {
        disableEnforceFocus: m,
        disableAutoFocus: R,
        disableRestoreFocus: w,
        isEnabled: be,
        open: D,
        children: /* @__PURE__ */ h.cloneElement(g, ne)
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && ($s.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: o.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: o.object,
  /**
   * A single child content element.
   */
  children: Cn.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: o.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: o.shape({
    Backdrop: o.elementType,
    Root: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: o.shape({
    backdrop: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: o.oneOfType([Ge, o.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: o.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: o.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: o.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: o.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: o.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: o.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: o.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: o.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: o.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: o.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: o.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: o.func,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: o.shape({
    backdrop: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: o.shape({
    backdrop: o.elementType,
    root: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
const Bd = $s, zd = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "slotProps", "slots", "type"], Ud = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, i = Se({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, vd, t);
  return b({}, t, i);
}, Wd = G(Fn, {
  shouldForwardProp: (e) => vt(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...An(e, t), !n.disableUnderline && t.underline];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n;
  const r = e.palette.mode === "light", i = r ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", s = r ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", a = r ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", l = r ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return b({
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : s,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : a,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : s
      }
    },
    [`&.${st.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : s
    },
    [`&.${st.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : l
    }
  }, !t.disableUnderline && {
    "&:after": {
      borderBottom: `2px solid ${(n = (e.vars || e).palette[t.color || "primary"]) == null ? void 0 : n.main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${st.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${st.error}`]: {
      "&:before, &:after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&:before": {
      borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : i}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${st.disabled}, .${st.error}):before`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
    },
    [`&.${st.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  }, t.startAdornment && {
    paddingLeft: 12
  }, t.endAdornment && {
    paddingRight: 12
  }, t.multiline && b({
    padding: "25px 12px 8px"
  }, t.size === "small" && {
    paddingTop: 21,
    paddingBottom: 4
  }, t.hiddenLabel && {
    paddingTop: 16,
    paddingBottom: 17
  }));
}), Hd = G(Vn, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: Dn
})(({
  theme: e,
  ownerState: t
}) => b({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, t.size === "small" && {
  paddingTop: 21,
  paddingBottom: 4
}, t.hiddenLabel && {
  paddingTop: 16,
  paddingBottom: 17
}, t.multiline && {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
}, t.startAdornment && {
  paddingLeft: 0
}, t.endAdornment && {
  paddingRight: 0
}, t.hiddenLabel && t.size === "small" && {
  paddingTop: 8,
  paddingBottom: 9
})), Jr = /* @__PURE__ */ h.forwardRef(function(t, n) {
  var r, i, s, a;
  const l = Pe({
    props: t,
    name: "MuiFilledInput"
  }), {
    components: u = {},
    componentsProps: c,
    fullWidth: d = !1,
    // declare here to prevent spreading to DOM
    inputComponent: f = "input",
    multiline: x = !1,
    slotProps: y,
    slots: g = {},
    type: E = "text"
  } = l, v = q(l, zd), P = b({}, l, {
    fullWidth: d,
    inputComponent: f,
    multiline: x,
    type: E
  }), C = Ud(l), R = {
    root: {
      ownerState: P
    },
    input: {
      ownerState: P
    }
  }, m = y ?? c ? qt(y ?? c, R) : R, p = (r = (i = g.root) != null ? i : u.Root) != null ? r : Wd, S = (s = (a = g.input) != null ? a : u.Input) != null ? s : Hd;
  return /* @__PURE__ */ B(Xr, b({
    slots: {
      root: p,
      input: S
    },
    componentsProps: m,
    fullWidth: d,
    inputComponent: f,
    multiline: x,
    ref: n,
    type: E
  }, v, {
    classes: C
  }));
});
process.env.NODE_ENV !== "production" && (Jr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: o.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary"]), o.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: o.shape({
    Input: o.elementType,
    Root: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: o.shape({
    input: o.object,
    root: o.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: o.bool,
  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: o.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: o.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: o.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: o.bool,
  /**
   * The id of the `input` element.
   */
  id: o.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: o.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Ye,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: o.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: o.oneOfType([o.number, o.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: o.oneOfType([o.number, o.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: o.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: o.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: o.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: o.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: o.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: o.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: o.oneOfType([o.number, o.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: o.shape({
    input: o.object,
    root: o.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: o.shape({
    input: o.elementType,
    root: o.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: o.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: o.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: o.any
});
Jr.muiName = "Input";
const qd = Jr, Yd = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function vr(e) {
  return `scale(${e}, ${e ** 2})`;
}
const Kd = {
  entering: {
    opacity: 1,
    transform: vr(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, Hn = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), Zr = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const {
    addEndListener: r,
    appear: i = !0,
    children: s,
    easing: a,
    in: l,
    onEnter: u,
    onEntered: c,
    onEntering: d,
    onExit: f,
    onExited: x,
    onExiting: y,
    style: g,
    timeout: E = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: v = es
  } = t, P = q(t, Yd), C = h.useRef(), R = h.useRef(), m = kn(), p = h.useRef(null), S = Ce(p, s.ref, n), w = (F) => (k) => {
    if (F) {
      const L = p.current;
      k === void 0 ? F(L) : F(L, k);
    }
  }, N = w(d), M = w((F, k) => {
    ts(F);
    const {
      duration: L,
      delay: A,
      easing: U
    } = bn({
      style: g,
      timeout: E,
      easing: a
    }, {
      mode: "enter"
    });
    let J;
    E === "auto" ? (J = m.transitions.getAutoHeightDuration(F.clientHeight), R.current = J) : J = L, F.style.transition = [m.transitions.create("opacity", {
      duration: J,
      delay: A
    }), m.transitions.create("transform", {
      duration: Hn ? J : J * 0.666,
      delay: A,
      easing: U
    })].join(","), u && u(F, k);
  }), $ = w(c), _ = w(y), D = w((F) => {
    const {
      duration: k,
      delay: L,
      easing: A
    } = bn({
      style: g,
      timeout: E,
      easing: a
    }, {
      mode: "exit"
    });
    let U;
    E === "auto" ? (U = m.transitions.getAutoHeightDuration(F.clientHeight), R.current = U) : U = k, F.style.transition = [m.transitions.create("opacity", {
      duration: U,
      delay: L
    }), m.transitions.create("transform", {
      duration: Hn ? U : U * 0.666,
      delay: Hn ? L : L || U * 0.333,
      easing: A
    })].join(","), F.style.opacity = 0, F.style.transform = vr(0.75), f && f(F);
  }), j = w(x), V = (F) => {
    E === "auto" && (C.current = setTimeout(F, R.current || 0)), r && r(p.current, F);
  };
  return h.useEffect(() => () => {
    clearTimeout(C.current);
  }, []), /* @__PURE__ */ B(v, b({
    appear: i,
    in: l,
    nodeRef: p,
    onEnter: M,
    onEntered: $,
    onEntering: N,
    onExit: D,
    onExited: j,
    onExiting: _,
    addEndListener: V,
    timeout: E === "auto" ? null : E
  }, P, {
    children: (F, k) => /* @__PURE__ */ h.cloneElement(s, b({
      style: b({
        opacity: 0,
        transform: vr(0.75),
        visibility: F === "exited" && !l ? "hidden" : void 0
      }, Kd[F], g, s.props.style),
      ref: S
    }, k))
  }));
});
process.env.NODE_ENV !== "production" && (Zr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: o.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: o.bool,
  /**
   * A single child content element.
   */
  children: Cn.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: o.oneOfType([o.shape({
    enter: o.string,
    exit: o.string
  }), o.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: o.bool,
  /**
   * @ignore
   */
  onEnter: o.func,
  /**
   * @ignore
   */
  onEntered: o.func,
  /**
   * @ignore
   */
  onEntering: o.func,
  /**
   * @ignore
   */
  onExit: o.func,
  /**
   * @ignore
   */
  onExited: o.func,
  /**
   * @ignore
   */
  onExiting: o.func,
  /**
   * @ignore
   */
  style: o.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: o.oneOfType([o.oneOf(["auto"]), o.number, o.shape({
    appear: o.number,
    enter: o.number,
    exit: o.number
  })])
});
Zr.muiSupportAuto = !0;
const Gd = Zr, Xd = ["disableUnderline", "components", "componentsProps", "fullWidth", "inputComponent", "multiline", "slotProps", "slots", "type"], Jd = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, i = Se({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, fd, t);
  return b({}, t, i);
}, Zd = G(Fn, {
  shouldForwardProp: (e) => vt(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...An(e, t), !n.disableUnderline && t.underline];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  let r = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (r = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), b({
    position: "relative"
  }, t.formControl && {
    "label + &": {
      marginTop: 16
    }
  }, !t.disableUnderline && {
    "&:after": {
      borderBottom: `2px solid ${(e.vars || e).palette[t.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${It.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${It.error}`]: {
      "&:before, &:after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&:before": {
      borderBottom: `1px solid ${r}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${It.disabled}, .${It.error}):before`]: {
      borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        borderBottom: `1px solid ${r}`
      }
    },
    [`&.${It.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  });
}), Qd = G(Vn, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: Dn
})({}), Qr = /* @__PURE__ */ h.forwardRef(function(t, n) {
  var r, i, s, a;
  const l = Pe({
    props: t,
    name: "MuiInput"
  }), {
    disableUnderline: u,
    components: c = {},
    componentsProps: d,
    fullWidth: f = !1,
    inputComponent: x = "input",
    multiline: y = !1,
    slotProps: g,
    slots: E = {},
    type: v = "text"
  } = l, P = q(l, Xd), C = Jd(l), m = {
    root: {
      ownerState: {
        disableUnderline: u
      }
    }
  }, p = g ?? d ? qt(g ?? d, m) : m, S = (r = (i = E.root) != null ? i : c.Root) != null ? r : Zd, w = (s = (a = E.input) != null ? a : c.Input) != null ? s : Qd;
  return /* @__PURE__ */ B(Xr, b({
    slots: {
      root: S,
      input: w
    },
    slotProps: p,
    fullWidth: f,
    inputComponent: x,
    multiline: y,
    ref: n,
    type: v
  }, P, {
    classes: C
  }));
});
process.env.NODE_ENV !== "production" && (Qr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: o.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary"]), o.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: o.shape({
    Input: o.elementType,
    Root: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: o.shape({
    input: o.object,
    root: o.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: o.bool,
  /**
   * If `true`, the `input` will not have an underline.
   */
  disableUnderline: o.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: o.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: o.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * The id of the `input` element.
   */
  id: o.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: o.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Ye,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: o.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: o.oneOfType([o.number, o.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: o.oneOfType([o.number, o.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: o.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: o.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: o.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: o.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: o.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: o.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: o.oneOfType([o.number, o.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: o.shape({
    input: o.object,
    root: o.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: o.shape({
    input: o.elementType,
    root: o.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: o.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: o.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: o.any
});
Qr.muiName = "Input";
const ef = Qr, ks = /* @__PURE__ */ h.createContext({});
process.env.NODE_ENV !== "production" && (ks.displayName = "ListContext");
const tf = ks;
function nf(e) {
  return xe("MuiList", e);
}
Ee("MuiList", ["root", "padding", "dense", "subheader"]);
const rf = ["children", "className", "component", "dense", "disablePadding", "subheader"], of = (e) => {
  const {
    classes: t,
    disablePadding: n,
    dense: r,
    subheader: i
  } = e;
  return Se({
    root: ["root", !n && "padding", r && "dense", i && "subheader"]
  }, nf, t);
}, sf = G("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disablePadding && t.padding, n.dense && t.dense, n.subheader && t.subheader];
  }
})(({
  ownerState: e
}) => b({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !e.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, e.subheader && {
  paddingTop: 0
})), Ms = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const r = Pe({
    props: t,
    name: "MuiList"
  }), {
    children: i,
    className: s,
    component: a = "ul",
    dense: l = !1,
    disablePadding: u = !1,
    subheader: c
  } = r, d = q(r, rf), f = h.useMemo(() => ({
    dense: l
  }), [l]), x = b({}, r, {
    component: a,
    dense: l,
    disablePadding: u
  }), y = of(x);
  return /* @__PURE__ */ B(tf.Provider, {
    value: f,
    children: /* @__PURE__ */ ze(sf, b({
      as: a,
      className: ae(y.root, s),
      ref: n,
      ownerState: x
    }, d, {
      children: [c, i]
    }))
  });
});
process.env.NODE_ENV !== "production" && (Ms.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: o.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: o.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: o.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
const af = Ms, lf = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function qn(e, t, n) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild;
}
function oi(e, t, n) {
  return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild;
}
function Is(e, t) {
  if (t === void 0)
    return !0;
  let n = e.innerText;
  return n === void 0 && (n = e.textContent), n = n.trim().toLowerCase(), n.length === 0 ? !1 : t.repeating ? n[0] === t.keys[0] : n.indexOf(t.keys.join("")) === 0;
}
function _t(e, t, n, r, i, s) {
  let a = !1, l = i(e, t, t ? n : !1);
  for (; l; ) {
    if (l === e.firstChild) {
      if (a)
        return !1;
      a = !0;
    }
    const u = r ? !1 : l.disabled || l.getAttribute("aria-disabled") === "true";
    if (!l.hasAttribute("tabindex") || !Is(l, s) || u)
      l = i(e, l, n);
    else
      return l.focus(), !0;
  }
  return !1;
}
const _s = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: r,
    autoFocus: i = !1,
    autoFocusItem: s = !1,
    children: a,
    className: l,
    disabledItemsFocusable: u = !1,
    disableListWrap: c = !1,
    onKeyDown: d,
    variant: f = "selectedMenu"
  } = t, x = q(t, lf), y = h.useRef(null), g = h.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  Xe(() => {
    i && y.current.focus();
  }, [i]), h.useImperativeHandle(r, () => ({
    adjustStyleForScrollbar: (R, m) => {
      const p = !y.current.style.width;
      if (R.clientHeight < y.current.clientHeight && p) {
        const S = `${Bi($e(R))}px`;
        y.current.style[m.direction === "rtl" ? "paddingLeft" : "paddingRight"] = S, y.current.style.width = `calc(100% + ${S})`;
      }
      return y.current;
    }
  }), []);
  const E = (R) => {
    const m = y.current, p = R.key, S = $e(m).activeElement;
    if (p === "ArrowDown")
      R.preventDefault(), _t(m, S, c, u, qn);
    else if (p === "ArrowUp")
      R.preventDefault(), _t(m, S, c, u, oi);
    else if (p === "Home")
      R.preventDefault(), _t(m, null, c, u, qn);
    else if (p === "End")
      R.preventDefault(), _t(m, null, c, u, oi);
    else if (p.length === 1) {
      const w = g.current, N = p.toLowerCase(), M = performance.now();
      w.keys.length > 0 && (M - w.lastTime > 500 ? (w.keys = [], w.repeating = !0, w.previousKeyMatched = !0) : w.repeating && N !== w.keys[0] && (w.repeating = !1)), w.lastTime = M, w.keys.push(N);
      const $ = S && !w.repeating && Is(S, w);
      w.previousKeyMatched && ($ || _t(m, S, !1, u, qn, w)) ? R.preventDefault() : w.previousKeyMatched = !1;
    }
    d && d(R);
  }, v = Ce(y, n);
  let P = -1;
  h.Children.forEach(a, (R, m) => {
    if (!/* @__PURE__ */ h.isValidElement(R)) {
      P === m && (P += 1, P >= a.length && (P = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && Yt.isFragment(R) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), R.props.disabled || (f === "selectedMenu" && R.props.selected || P === -1) && (P = m), P === m && (R.props.disabled || R.props.muiSkipListHighlight || R.type.muiSkipListHighlight) && (P += 1, P >= a.length && (P = -1));
  });
  const C = h.Children.map(a, (R, m) => {
    if (m === P) {
      const p = {};
      return s && (p.autoFocus = !0), R.props.tabIndex === void 0 && f === "selectedMenu" && (p.tabIndex = 0), /* @__PURE__ */ h.cloneElement(R, p);
    }
    return R;
  });
  return /* @__PURE__ */ B(af, b({
    role: "menu",
    ref: v,
    className: l,
    onKeyDown: E,
    tabIndex: i ? 0 : -1
  }, x, {
    children: C
  }));
});
process.env.NODE_ENV !== "production" && (_s.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: o.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: o.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: o.node,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: o.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: o.bool,
  /**
   * @ignore
   */
  onKeyDown: o.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: o.oneOf(["menu", "selectedMenu"])
});
const uf = _s;
function cf(e) {
  return xe("MuiPopover", e);
}
Ee("MuiPopover", ["root", "paper"]);
const df = ["onEntering"], ff = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"], pf = ["slotProps"];
function ii(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.height / 2 : t === "bottom" && (n = e.height), n;
}
function si(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.width / 2 : t === "right" && (n = e.width), n;
}
function ai(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function vn(e) {
  return typeof e == "function" ? e() : e;
}
const hf = (e) => {
  const {
    classes: t
  } = e;
  return Se({
    root: ["root"],
    paper: ["paper"]
  }, cf, t);
}, mf = G(Bd, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), js = G(Hl, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), As = /* @__PURE__ */ h.forwardRef(function(t, n) {
  var r, i, s;
  const a = Pe({
    props: t,
    name: "MuiPopover"
  }), {
    action: l,
    anchorEl: u,
    anchorOrigin: c = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: d,
    anchorReference: f = "anchorEl",
    children: x,
    className: y,
    container: g,
    elevation: E = 8,
    marginThreshold: v = 16,
    open: P,
    PaperProps: C = {},
    slots: R,
    slotProps: m,
    transformOrigin: p = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: S = Gd,
    transitionDuration: w = "auto",
    TransitionProps: {
      onEntering: N
    } = {},
    disableScrollLock: M = !1
  } = a, $ = q(a.TransitionProps, df), _ = q(a, ff), D = (r = m == null ? void 0 : m.paper) != null ? r : C, j = h.useRef(), V = Ce(j, D.ref), F = b({}, a, {
    anchorOrigin: c,
    anchorReference: f,
    elevation: E,
    marginThreshold: v,
    externalPaperSlotProps: D,
    transformOrigin: p,
    TransitionComponent: S,
    transitionDuration: w,
    TransitionProps: $
  }), k = hf(F), L = h.useCallback(() => {
    if (f === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (d || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), d;
    const H = vn(u), O = H && H.nodeType === 1 ? H : $e(j.current).body, Z = O.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const ve = O.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && ve.top === 0 && ve.left === 0 && ve.right === 0 && ve.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: Z.top + ii(Z, c.vertical),
      left: Z.left + si(Z, c.horizontal)
    };
  }, [u, c.horizontal, c.vertical, d, f]), A = h.useCallback((H) => ({
    vertical: ii(H, p.vertical),
    horizontal: si(H, p.horizontal)
  }), [p.horizontal, p.vertical]), U = h.useCallback((H) => {
    const O = {
      width: H.offsetWidth,
      height: H.offsetHeight
    }, Z = A(O);
    if (f === "none")
      return {
        top: null,
        left: null,
        transformOrigin: ai(Z)
      };
    const ve = L();
    let Re = ve.top - Z.vertical, ke = ve.left - Z.horizontal;
    const _e = Re + O.height, ge = ke + O.width, ce = pt(vn(u)), Oe = ce.innerHeight - v, Te = ce.innerWidth - v;
    if (v !== null && Re < v) {
      const de = Re - v;
      Re -= de, Z.vertical += de;
    } else if (v !== null && _e > Oe) {
      const de = _e - Oe;
      Re -= de, Z.vertical += de;
    }
    if (process.env.NODE_ENV !== "production" && O.height > Oe && O.height && Oe && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${O.height - Oe}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), v !== null && ke < v) {
      const de = ke - v;
      ke -= de, Z.horizontal += de;
    } else if (ge > Te) {
      const de = ge - Te;
      ke -= de, Z.horizontal += de;
    }
    return {
      top: `${Math.round(Re)}px`,
      left: `${Math.round(ke)}px`,
      transformOrigin: ai(Z)
    };
  }, [u, f, L, A, v]), [J, be] = h.useState(P), le = h.useCallback(() => {
    const H = j.current;
    if (!H)
      return;
    const O = U(H);
    O.top !== null && (H.style.top = O.top), O.left !== null && (H.style.left = O.left), H.style.transformOrigin = O.transformOrigin, be(!0);
  }, [U]);
  h.useEffect(() => (M && window.addEventListener("scroll", le), () => window.removeEventListener("scroll", le)), [u, M, le]);
  const he = (H, O) => {
    N && N(H, O), le();
  }, X = () => {
    be(!1);
  };
  h.useEffect(() => {
    P && le();
  }), h.useImperativeHandle(l, () => P ? {
    updatePosition: () => {
      le();
    }
  } : null, [P, le]), h.useEffect(() => {
    if (!P)
      return;
    const H = Li(() => {
      le();
    }), O = pt(u);
    return O.addEventListener("resize", H), () => {
      H.clear(), O.removeEventListener("resize", H);
    };
  }, [u, P, le]);
  let Q = w;
  w === "auto" && !S.muiSupportAuto && (Q = void 0);
  const ne = g || (u ? $e(vn(u)).body : void 0), me = (i = R == null ? void 0 : R.root) != null ? i : mf, pe = (s = R == null ? void 0 : R.paper) != null ? s : js, ue = ht({
    elementType: pe,
    externalSlotProps: b({}, D, {
      style: J ? D.style : b({}, D.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation: E,
      ref: V
    },
    ownerState: F,
    className: ae(k.paper, D == null ? void 0 : D.className)
  }), ye = ht({
    elementType: me,
    externalSlotProps: (m == null ? void 0 : m.root) || {},
    externalForwardedProps: _,
    additionalProps: {
      ref: n,
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: ne,
      open: P
    },
    ownerState: F,
    className: ae(k.root, y)
  }), {
    slotProps: K
  } = ye, I = q(ye, pf);
  return /* @__PURE__ */ B(me, b({}, I, !xn(me) && {
    slotProps: K,
    disableScrollLock: M
  }, {
    children: /* @__PURE__ */ B(S, b({
      appear: !0,
      in: P,
      onEntering: he,
      onExited: X,
      timeout: Q
    }, $, {
      children: /* @__PURE__ */ B(pe, b({}, ue, {
        children: x
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" && (As.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: Ye,
  /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: ot(o.oneOfType([Ge, o.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = vn(e.anchorEl);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: o.shape({
    horizontal: o.oneOfType([o.oneOf(["center", "left", "right"]), o.number]).isRequired,
    vertical: o.oneOfType([o.oneOf(["bottom", "center", "top"]), o.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: o.shape({
    left: o.number.isRequired,
    top: o.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: o.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: o.oneOfType([Ge, o.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: o.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: Wi,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: o.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: o.func,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: o.shape({
    component: Mr
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: o.shape({
    paper: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: o.shape({
    paper: o.elementType,
    root: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: o.shape({
    horizontal: o.oneOfType([o.oneOf(["center", "left", "right"]), o.number]).isRequired,
    vertical: o.oneOfType([o.oneOf(["bottom", "center", "top"]), o.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: o.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: o.oneOfType([o.oneOf(["auto"]), o.number, o.shape({
    appear: o.number,
    enter: o.number,
    exit: o.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: o.object
});
const vf = As;
function yf(e) {
  return xe("MuiMenu", e);
}
Ee("MuiMenu", ["root", "paper", "list"]);
const gf = ["onEntering"], bf = ["autoFocus", "children", "className", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant", "slots", "slotProps"], xf = {
  vertical: "top",
  horizontal: "right"
}, Ef = {
  vertical: "top",
  horizontal: "left"
}, Rf = (e) => {
  const {
    classes: t
  } = e;
  return Se({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, yf, t);
}, Sf = G(vf, {
  shouldForwardProp: (e) => vt(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Pf = G(js, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), Tf = G(uf, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Ds = /* @__PURE__ */ h.forwardRef(function(t, n) {
  var r, i;
  const s = Pe({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: a = !0,
    children: l,
    className: u,
    disableAutoFocusItem: c = !1,
    MenuListProps: d = {},
    onClose: f,
    open: x,
    PaperProps: y = {},
    PopoverClasses: g,
    transitionDuration: E = "auto",
    TransitionProps: {
      onEntering: v
    } = {},
    variant: P = "selectedMenu",
    slots: C = {},
    slotProps: R = {}
  } = s, m = q(s.TransitionProps, gf), p = q(s, bf), S = kn(), w = S.direction === "rtl", N = b({}, s, {
    autoFocus: a,
    disableAutoFocusItem: c,
    MenuListProps: d,
    onEntering: v,
    PaperProps: y,
    transitionDuration: E,
    TransitionProps: m,
    variant: P
  }), M = Rf(N), $ = a && !c && x, _ = h.useRef(null), D = (U, J) => {
    _.current && _.current.adjustStyleForScrollbar(U, S), v && v(U, J);
  }, j = (U) => {
    U.key === "Tab" && (U.preventDefault(), f && f(U, "tabKeyDown"));
  };
  let V = -1;
  h.Children.map(l, (U, J) => {
    /* @__PURE__ */ h.isValidElement(U) && (process.env.NODE_ENV !== "production" && Yt.isFragment(U) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), U.props.disabled || (P === "selectedMenu" && U.props.selected || V === -1) && (V = J));
  });
  const F = (r = C.paper) != null ? r : Pf, k = (i = R.paper) != null ? i : y, L = ht({
    elementType: C.root,
    externalSlotProps: R.root,
    ownerState: N,
    className: [M.root, u]
  }), A = ht({
    elementType: F,
    externalSlotProps: k,
    ownerState: N,
    className: M.paper
  });
  return /* @__PURE__ */ B(Sf, b({
    onClose: f,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: w ? "right" : "left"
    },
    transformOrigin: w ? xf : Ef,
    slots: {
      paper: F,
      root: C.root
    },
    slotProps: {
      root: L,
      paper: A
    },
    open: x,
    ref: n,
    transitionDuration: E,
    TransitionProps: b({
      onEntering: D
    }, m),
    ownerState: N
  }, p, {
    classes: g,
    children: /* @__PURE__ */ B(Tf, b({
      onKeyDown: j,
      actions: _,
      autoFocus: a && (V === -1 || c),
      autoFocusItem: $,
      variant: P
    }, d, {
      className: ae(M.list, d.className),
      children: l
    }))
  }));
});
process.env.NODE_ENV !== "production" && (Ds.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: o.oneOfType([Ge, o.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: o.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: o.bool,
  /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: o.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: o.func,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: o.object,
  /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */
  PopoverClasses: o.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: o.shape({
    paper: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: o.shape({
    paper: o.elementType,
    root: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: o.oneOfType([o.oneOf(["auto"]), o.number, o.shape({
    appear: o.number,
    enter: o.number,
    exit: o.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: o.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: o.oneOf(["menu", "selectedMenu"])
});
const wf = Ds;
function Cf(e) {
  return xe("MuiNativeSelect", e);
}
const Of = Ee("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), eo = Of, Nf = ["className", "disabled", "error", "IconComponent", "inputRef", "variant"], $f = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: i,
    open: s,
    error: a
  } = e, l = {
    select: ["select", n, r && "disabled", i && "multiple", a && "error"],
    icon: ["icon", `icon${fe(n)}`, s && "iconOpen", r && "disabled"]
  };
  return Se(l, Cf, t);
}, Fs = ({
  ownerState: e,
  theme: t
}) => b({
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  borderRadius: 0,
  // Reset
  cursor: "pointer",
  "&:focus": b({}, t.vars ? {
    backgroundColor: `rgba(${t.vars.palette.common.onBackgroundChannel} / 0.05)`
  } : {
    backgroundColor: t.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
  }, {
    borderRadius: 0
    // Reset Chrome style
  }),
  // Remove IE11 arrow
  "&::-ms-expand": {
    display: "none"
  },
  [`&.${eo.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (t.vars || t).palette.background.paper
  },
  // Bump specificity to allow extending custom inputs
  "&&&": {
    paddingRight: 24,
    minWidth: 16
    // So it doesn't collapse.
  }
}, e.variant === "filled" && {
  "&&&": {
    paddingRight: 32
  }
}, e.variant === "outlined" && {
  borderRadius: (t.vars || t).shape.borderRadius,
  "&:focus": {
    borderRadius: (t.vars || t).shape.borderRadius
    // Reset the reset for Chrome style
  },
  "&&&": {
    paddingRight: 32
  }
}), kf = G("select", {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: vt,
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.select, t[n.variant], n.error && t.error, {
      [`&.${eo.multiple}`]: t.multiple
    }];
  }
})(Fs), Vs = ({
  ownerState: e,
  theme: t
}) => b({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  top: "calc(50% - .5em)",
  // Center vertically, height is 1em
  pointerEvents: "none",
  // Don't block pointer events on the select under the icon.
  color: (t.vars || t).palette.action.active,
  [`&.${eo.disabled}`]: {
    color: (t.vars || t).palette.action.disabled
  }
}, e.open && {
  transform: "rotate(180deg)"
}, e.variant === "filled" && {
  right: 7
}, e.variant === "outlined" && {
  right: 7
}), Mf = G("svg", {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${fe(n.variant)}`], n.open && t.iconOpen];
  }
})(Vs), Ls = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const {
    className: r,
    disabled: i,
    error: s,
    IconComponent: a,
    inputRef: l,
    variant: u = "standard"
  } = t, c = q(t, Nf), d = b({}, t, {
    disabled: i,
    variant: u,
    error: s
  }), f = $f(d);
  return /* @__PURE__ */ ze(h.Fragment, {
    children: [/* @__PURE__ */ B(kf, b({
      ownerState: d,
      className: ae(f.select, r),
      disabled: i,
      ref: l || n
    }, c)), t.multiple ? null : /* @__PURE__ */ B(Mf, {
      as: a,
      ownerState: d,
      className: f.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (Ls.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: o.object,
  /**
   * The CSS class name of the select element.
   */
  className: o.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: o.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: o.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: o.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: Ye,
  /**
   * @ignore
   */
  multiple: o.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: o.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: o.func,
  /**
   * The input value.
   */
  value: o.any,
  /**
   * The variant to use.
   */
  variant: o.oneOf(["standard", "outlined", "filled"])
});
const If = Ls;
var li;
const _f = ["children", "classes", "className", "label", "notched"], jf = G("fieldset")({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), Af = G("legend")(({
  ownerState: e,
  theme: t
}) => b({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden"
}, !e.withLabel && {
  padding: 0,
  lineHeight: "11px",
  // sync with `height` in `legend` styles
  transition: t.transitions.create("width", {
    duration: 150,
    easing: t.transitions.easing.easeOut
  })
}, e.withLabel && b({
  display: "block",
  // Fix conflict with normalize.css and sanitize.css
  padding: 0,
  height: 11,
  // sync with `lineHeight` in `legend` styles
  fontSize: "0.75em",
  visibility: "hidden",
  maxWidth: 0.01,
  transition: t.transitions.create("max-width", {
    duration: 50,
    easing: t.transitions.easing.easeOut
  }),
  whiteSpace: "nowrap",
  "& > span": {
    paddingLeft: 5,
    paddingRight: 5,
    display: "inline-block",
    opacity: 0,
    visibility: "visible"
  }
}, e.notched && {
  maxWidth: "100%",
  transition: t.transitions.create("max-width", {
    duration: 100,
    easing: t.transitions.easing.easeOut,
    delay: 50
  })
})));
function Bs(e) {
  const {
    className: t,
    label: n,
    notched: r
  } = e, i = q(e, _f), s = n != null && n !== "", a = b({}, e, {
    notched: r,
    withLabel: s
  });
  return /* @__PURE__ */ B(jf, b({
    "aria-hidden": !0,
    className: t,
    ownerState: a
  }, i, {
    children: /* @__PURE__ */ B(Af, {
      ownerState: a,
      children: s ? /* @__PURE__ */ B("span", {
        children: n
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        li || (li = /* @__PURE__ */ B("span", {
          className: "notranslate",
          children: "​"
        }))
      )
    })
  }));
}
process.env.NODE_ENV !== "production" && (Bs.propTypes = {
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The label.
   */
  label: o.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: o.bool.isRequired,
  /**
   * @ignore
   */
  style: o.object
});
const Df = ["components", "fullWidth", "inputComponent", "label", "multiline", "notched", "slots", "type"], Ff = (e) => {
  const {
    classes: t
  } = e, r = Se({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, hd, t);
  return b({}, t, r);
}, Vf = G(Fn, {
  shouldForwardProp: (e) => vt(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: An
})(({
  theme: e,
  ownerState: t
}) => {
  const n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return b({
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${Qe.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${Qe.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : n
      }
    },
    [`&.${Qe.focused} .${Qe.notchedOutline}`]: {
      borderColor: (e.vars || e).palette[t.color].main,
      borderWidth: 2
    },
    [`&.${Qe.error} .${Qe.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.error.main
    },
    [`&.${Qe.disabled} .${Qe.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.action.disabled
    }
  }, t.startAdornment && {
    paddingLeft: 14
  }, t.endAdornment && {
    paddingRight: 14
  }, t.multiline && b({
    padding: "16.5px 14px"
  }, t.size === "small" && {
    padding: "8.5px 14px"
  }));
}), Lf = G(Bs, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
}), Bf = G(Vn, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: Dn
})(({
  theme: e,
  ownerState: t
}) => b({
  padding: "16.5px 14px"
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, t.size === "small" && {
  padding: "8.5px 14px"
}, t.multiline && {
  padding: 0
}, t.startAdornment && {
  paddingLeft: 0
}, t.endAdornment && {
  paddingRight: 0
})), to = /* @__PURE__ */ h.forwardRef(function(t, n) {
  var r, i, s, a, l;
  const u = Pe({
    props: t,
    name: "MuiOutlinedInput"
  }), {
    components: c = {},
    fullWidth: d = !1,
    inputComponent: f = "input",
    label: x,
    multiline: y = !1,
    notched: g,
    slots: E = {},
    type: v = "text"
  } = u, P = q(u, Df), C = Ff(u), R = Gr(), m = Kr({
    props: u,
    muiFormControl: R,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), p = b({}, u, {
    color: m.color || "primary",
    disabled: m.disabled,
    error: m.error,
    focused: m.focused,
    formControl: R,
    fullWidth: d,
    hiddenLabel: m.hiddenLabel,
    multiline: y,
    size: m.size,
    type: v
  }), S = (r = (i = E.root) != null ? i : c.Root) != null ? r : Vf, w = (s = (a = E.input) != null ? a : c.Input) != null ? s : Bf;
  return /* @__PURE__ */ B(Xr, b({
    slots: {
      root: S,
      input: w
    },
    renderSuffix: (N) => /* @__PURE__ */ B(Lf, {
      ownerState: p,
      className: C.notchedOutline,
      label: x != null && x !== "" && m.required ? l || (l = /* @__PURE__ */ ze(h.Fragment, {
        children: [x, " ", "*"]
      })) : x,
      notched: typeof g < "u" ? g : !!(N.startAdornment || N.filled || N.focused)
    }),
    fullWidth: d,
    inputComponent: f,
    multiline: y,
    ref: n,
    type: v
  }, P, {
    classes: b({}, C, {
      notchedOutline: null
    })
  }));
});
process.env.NODE_ENV !== "production" && (to.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: o.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary"]), o.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: o.shape({
    Input: o.elementType,
    Root: o.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: o.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: o.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: o.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * The id of the `input` element.
   */
  id: o.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: o.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Ye,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: o.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: o.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: o.oneOfType([o.number, o.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: o.oneOfType([o.number, o.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: o.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: o.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: o.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: o.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: o.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: o.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: o.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: o.oneOfType([o.number, o.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: o.shape({
    input: o.elementType,
    root: o.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: o.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: o.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: o.any
});
to.muiName = "Input";
const zf = to;
function Uf(e) {
  return xe("MuiSelect", e);
}
const Wf = Ee("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), jt = Wf;
var ui;
const Hf = ["aria-describedby", "aria-label", "autoFocus", "autoWidth", "children", "className", "defaultOpen", "defaultValue", "disabled", "displayEmpty", "error", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"], qf = G("div", {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${jt.select}`]: t.select
      },
      {
        [`&.${jt.select}`]: t[n.variant]
      },
      {
        [`&.${jt.error}`]: t.error
      },
      {
        [`&.${jt.multiple}`]: t.multiple
      }
    ];
  }
})(Fs, {
  // Win specificity over the input base
  [`&.${jt.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), Yf = G("svg", {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${fe(n.variant)}`], n.open && t.iconOpen];
  }
})(Vs), Kf = G("input", {
  shouldForwardProp: (e) => wl(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, t) => t.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function ci(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
function Gf(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const Xf = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: i,
    open: s,
    error: a
  } = e, l = {
    select: ["select", n, r && "disabled", i && "multiple", a && "error"],
    icon: ["icon", `icon${fe(n)}`, s && "iconOpen", r && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return Se(l, Uf, t);
}, zs = /* @__PURE__ */ h.forwardRef(function(t, n) {
  var r;
  const {
    "aria-describedby": i,
    "aria-label": s,
    autoFocus: a,
    autoWidth: l,
    children: u,
    className: c,
    defaultOpen: d,
    defaultValue: f,
    disabled: x,
    displayEmpty: y,
    error: g = !1,
    IconComponent: E,
    inputRef: v,
    labelId: P,
    MenuProps: C = {},
    multiple: R,
    name: m,
    onBlur: p,
    onChange: S,
    onClose: w,
    onFocus: N,
    onOpen: M,
    open: $,
    readOnly: _,
    renderValue: D,
    SelectDisplayProps: j = {},
    tabIndex: V,
    value: F,
    variant: k = "standard"
  } = t, L = q(t, Hf), [A, U] = go({
    controlled: F,
    default: f,
    name: "Select"
  }), [J, be] = go({
    controlled: $,
    default: d,
    name: "Select"
  }), le = h.useRef(null), he = h.useRef(null), [X, Q] = h.useState(null), {
    current: ne
  } = h.useRef($ != null), [me, pe] = h.useState(), ue = Ce(n, v), ye = h.useCallback((z) => {
    he.current = z, z && Q(z);
  }, []), K = X == null ? void 0 : X.parentNode;
  h.useImperativeHandle(ue, () => ({
    focus: () => {
      he.current.focus();
    },
    node: le.current,
    value: A
  }), [A]), h.useEffect(() => {
    d && J && X && !ne && (pe(l ? null : K.clientWidth), he.current.focus());
  }, [X, l]), h.useEffect(() => {
    a && he.current.focus();
  }, [a]), h.useEffect(() => {
    if (!P)
      return;
    const z = $e(he.current).getElementById(P);
    if (z) {
      const te = () => {
        getSelection().isCollapsed && he.current.focus();
      };
      return z.addEventListener("click", te), () => {
        z.removeEventListener("click", te);
      };
    }
  }, [P]);
  const I = (z, te) => {
    z ? M && M(te) : w && w(te), ne || (pe(l ? null : K.clientWidth), be(z));
  }, H = (z) => {
    z.button === 0 && (z.preventDefault(), he.current.focus(), I(!0, z));
  }, O = (z) => {
    I(!1, z);
  }, Z = h.Children.toArray(u), ve = (z) => {
    const te = Z.find((we) => we.props.value === z.target.value);
    te !== void 0 && (U(te.props.value), S && S(z, te));
  }, Re = (z) => (te) => {
    let we;
    if (te.currentTarget.hasAttribute("tabindex")) {
      if (R) {
        we = Array.isArray(A) ? A.slice() : [];
        const gt = A.indexOf(z.props.value);
        gt === -1 ? we.push(z.props.value) : we.splice(gt, 1);
      } else
        we = z.props.value;
      if (z.props.onClick && z.props.onClick(te), A !== we && (U(we), S)) {
        const gt = te.nativeEvent || te, uo = new gt.constructor(gt.type, gt);
        Object.defineProperty(uo, "target", {
          writable: !0,
          value: {
            value: we,
            name: m
          }
        }), S(uo, z);
      }
      R || I(!1, te);
    }
  }, ke = (z) => {
    _ || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].indexOf(z.key) !== -1 && (z.preventDefault(), I(!0, z));
  }, _e = X !== null && J, ge = (z) => {
    !_e && p && (Object.defineProperty(z, "target", {
      writable: !0,
      value: {
        value: A,
        name: m
      }
    }), p(z));
  };
  delete L["aria-invalid"];
  let ce, Oe;
  const Te = [];
  let de = !1, Ne = !1;
  (Ps({
    value: A
  }) || y) && (D ? ce = D(A) : de = !0);
  const Ue = Z.map((z) => {
    if (!/* @__PURE__ */ h.isValidElement(z))
      return null;
    process.env.NODE_ENV !== "production" && Yt.isFragment(z) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let te;
    if (R) {
      if (!Array.isArray(A))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : ji(2));
      te = A.some((we) => ci(we, z.props.value)), te && de && Te.push(z.props.children);
    } else
      te = ci(A, z.props.value), te && de && (Oe = z.props.children);
    return te && (Ne = !0), /* @__PURE__ */ h.cloneElement(z, {
      "aria-selected": te ? "true" : "false",
      onClick: Re(z),
      onKeyUp: (we) => {
        we.key === " " && we.preventDefault(), z.props.onKeyUp && z.props.onKeyUp(we);
      },
      role: "option",
      selected: te,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": z.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && h.useEffect(() => {
    if (!Ne && !R && A !== "") {
      const z = Z.map((te) => te.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${A}\` for the select ${m ? `(name="${m}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${z.filter((te) => te != null).map((te) => `\`${te}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [Ne, Z, R, m, A]), de && (R ? Te.length === 0 ? ce = null : ce = Te.reduce((z, te, we) => (z.push(te), we < Te.length - 1 && z.push(", "), z), []) : ce = Oe);
  let Be = me;
  !l && ne && X && (Be = K.clientWidth);
  let ee;
  typeof V < "u" ? ee = V : ee = x ? null : 0;
  const W = j.id || (m ? `mui-component-select-${m}` : void 0), We = b({}, t, {
    variant: k,
    value: A,
    open: _e,
    error: g
  }), kt = Xf(We), yt = b({}, C.PaperProps, (r = C.slotProps) == null ? void 0 : r.paper), zn = Sa();
  return /* @__PURE__ */ ze(h.Fragment, {
    children: [/* @__PURE__ */ B(qf, b({
      ref: ye,
      tabIndex: ee,
      role: "combobox",
      "aria-controls": zn,
      "aria-disabled": x ? "true" : void 0,
      "aria-expanded": _e ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": s,
      "aria-labelledby": [P, W].filter(Boolean).join(" ") || void 0,
      "aria-describedby": i,
      onKeyDown: ke,
      onMouseDown: x || _ ? null : H,
      onBlur: ge,
      onFocus: N
    }, j, {
      ownerState: We,
      className: ae(j.className, kt.select, c),
      id: W,
      children: Gf(ce) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        ui || (ui = /* @__PURE__ */ B("span", {
          className: "notranslate",
          children: "​"
        }))
      ) : ce
    })), /* @__PURE__ */ B(Kf, b({
      "aria-invalid": g,
      value: Array.isArray(A) ? A.join(",") : A,
      name: m,
      ref: le,
      "aria-hidden": !0,
      onChange: ve,
      tabIndex: -1,
      disabled: x,
      className: kt.nativeInput,
      autoFocus: a,
      ownerState: We
    }, L)), /* @__PURE__ */ B(Yf, {
      as: E,
      className: kt.icon,
      ownerState: We
    }), /* @__PURE__ */ B(wf, b({
      id: `menu-${m || ""}`,
      anchorEl: K,
      open: _e,
      onClose: O,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    }, C, {
      MenuListProps: b({
        "aria-labelledby": P,
        role: "listbox",
        "aria-multiselectable": R ? "true" : void 0,
        disableListWrap: !0,
        id: zn
      }, C.MenuListProps),
      slotProps: b({}, C.slotProps, {
        paper: b({}, yt, {
          style: b({
            minWidth: Be
          }, yt != null ? yt.style : null)
        })
      }),
      children: Ue
    }))]
  });
});
process.env.NODE_ENV !== "production" && (zs.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": o.string,
  /**
   * @ignore
   */
  "aria-label": o.string,
  /**
   * @ignore
   */
  autoFocus: o.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: o.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: o.object,
  /**
   * The CSS class name of the select element.
   */
  className: o.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: o.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: o.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: o.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: o.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: o.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: Ye,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: o.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: o.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: o.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: o.string,
  /**
   * @ignore
   */
  onBlur: o.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: o.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: o.func,
  /**
   * @ignore
   */
  onFocus: o.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: o.func,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool,
  /**
   * @ignore
   */
  readOnly: o.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: o.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: o.object,
  /**
   * @ignore
   */
  tabIndex: o.oneOfType([o.number, o.string]),
  /**
   * @ignore
   */
  type: o.any,
  /**
   * The input value.
   */
  value: o.any,
  /**
   * The variant to use.
   */
  variant: o.oneOf(["standard", "outlined", "filled"])
});
const Jf = zs, Zf = ["autoWidth", "children", "classes", "className", "defaultOpen", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"], Qf = ["root"], ep = (e) => {
  const {
    classes: t
  } = e;
  return t;
}, no = {
  name: "MuiSelect",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => vt(e) && e !== "variant",
  slot: "Root"
}, tp = G(ef, no)(""), np = G(zf, no)(""), rp = G(qd, no)(""), ro = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const r = Pe({
    name: "MuiSelect",
    props: t
  }), {
    autoWidth: i = !1,
    children: s,
    classes: a = {},
    className: l,
    defaultOpen: u = !1,
    displayEmpty: c = !1,
    IconComponent: d = gd,
    id: f,
    input: x,
    inputProps: y,
    label: g,
    labelId: E,
    MenuProps: v,
    multiple: P = !1,
    native: C = !1,
    onClose: R,
    onOpen: m,
    open: p,
    renderValue: S,
    SelectDisplayProps: w,
    variant: N = "outlined"
  } = r, M = q(r, Zf), $ = C ? If : Jf, _ = Gr(), D = Kr({
    props: r,
    muiFormControl: _,
    states: ["variant", "error"]
  }), j = D.variant || N, V = b({}, r, {
    variant: j,
    classes: a
  }), F = ep(V), k = q(F, Qf), L = x || {
    standard: /* @__PURE__ */ B(tp, {
      ownerState: V
    }),
    outlined: /* @__PURE__ */ B(np, {
      label: g,
      ownerState: V
    }),
    filled: /* @__PURE__ */ B(rp, {
      ownerState: V
    })
  }[j], A = Ce(n, L.ref);
  return /* @__PURE__ */ B(h.Fragment, {
    children: /* @__PURE__ */ h.cloneElement(L, b({
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: $,
      inputProps: b({
        children: s,
        error: D.error,
        IconComponent: d,
        variant: j,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: P
      }, C ? {
        id: f
      } : {
        autoWidth: i,
        defaultOpen: u,
        displayEmpty: c,
        labelId: E,
        MenuProps: v,
        onClose: R,
        onOpen: m,
        open: p,
        renderValue: S,
        SelectDisplayProps: b({
          id: f
        }, w)
      }, y, {
        classes: y ? qt(k, y.classes) : k
      }, x ? x.props.inputProps : {})
    }, P && C && j === "outlined" ? {
      notched: !0
    } : {}, {
      ref: A,
      className: ae(L.props.className, l, F.root)
    }, !x && {
      variant: j
    }, M))
  });
});
process.env.NODE_ENV !== "production" && (ro.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: o.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: o.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: o.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: o.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: o.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: o.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: o.object,
  /**
   * See [OutlinedInput#label](/material-ui/api/outlined-input/#props)
   */
  label: o.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: o.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: o.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: o.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: o.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: o.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: o.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: o.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: o.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: o.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: o.oneOfType([o.oneOf([""]), o.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: o.oneOf(["filled", "outlined", "standard"])
});
ro.muiName = "Select";
const Pm = ro, op = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"];
function ip(e = {}) {
  const {
    disableGlobal: t = !1,
    productionPrefix: n = "jss",
    seed: r = ""
  } = e, i = r === "" ? "" : `${r}-`;
  let s = 0;
  const a = () => (s += 1, process.env.NODE_ENV !== "production" && s >= 1e10 && console.warn(["MUI: You might have a memory leak.", "The ruleCounter is not supposed to grow that much."].join("")), s);
  return (l, u) => {
    const c = u.options.name;
    if (c && c.indexOf("Mui") === 0 && !u.options.link && !t) {
      if (op.indexOf(l.key) !== -1)
        return `Mui-${l.key}`;
      const f = `${i}${c}-${l.key}`;
      return !u.options.theme[da] || r !== "" ? f : `${f}-${a()}`;
    }
    if (process.env.NODE_ENV === "production")
      return `${i}${n}${a()}`;
    const d = `${l.key}-${a()}`;
    return u.options.classNamePrefix ? `${i}${u.options.classNamePrefix}-${d}` : `${i}${d}`;
  };
}
var sp = process.env.NODE_ENV === "production";
function Le(e, t) {
  if (!sp) {
    if (e)
      return;
    var n = "Warning: " + t;
    typeof console < "u" && console.warn(n);
    try {
      throw Error(n);
    } catch {
    }
  }
}
var di = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
  return typeof e;
} : function(e) {
  return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
}, rn = (typeof window > "u" ? "undefined" : di(window)) === "object" && (typeof document > "u" ? "undefined" : di(document)) === "object" && document.nodeType === 9;
function fi(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Pl(r.key), r);
  }
}
function Us(e, t, n) {
  return t && fi(e.prototype, t), n && fi(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var ap = {}.constructor;
function yr(e) {
  if (e == null || typeof e != "object")
    return e;
  if (Array.isArray(e))
    return e.map(yr);
  if (e.constructor !== ap)
    return e;
  var t = {};
  for (var n in e)
    t[n] = yr(e[n]);
  return t;
}
function oo(e, t, n) {
  e === void 0 && (e = "unnamed");
  var r = n.jss, i = yr(t), s = r.plugins.onCreateRule(e, i, n);
  return s || (e[0] === "@" && process.env.NODE_ENV !== "production" && Le(!1, "[JSS] Unknown rule " + e), null);
}
var pi = function(t, n) {
  for (var r = "", i = 0; i < t.length && t[i] !== "!important"; i++)
    r && (r += n), r += t[i];
  return r;
}, ft = function(t) {
  if (!Array.isArray(t))
    return t;
  var n = "";
  if (Array.isArray(t[0]))
    for (var r = 0; r < t.length && t[r] !== "!important"; r++)
      n && (n += ", "), n += pi(t[r], " ");
  else
    n = pi(t, ", ");
  return t[t.length - 1] === "!important" && (n += " !important"), n;
};
function $t(e) {
  return e && e.format === !1 ? {
    linebreak: "",
    space: ""
  } : {
    linebreak: `
`,
    space: " "
  };
}
function At(e, t) {
  for (var n = "", r = 0; r < t; r++)
    n += "  ";
  return n + e;
}
function Zt(e, t, n) {
  n === void 0 && (n = {});
  var r = "";
  if (!t)
    return r;
  var i = n, s = i.indent, a = s === void 0 ? 0 : s, l = t.fallbacks;
  n.format === !1 && (a = -1 / 0);
  var u = $t(n), c = u.linebreak, d = u.space;
  if (e && a++, l)
    if (Array.isArray(l))
      for (var f = 0; f < l.length; f++) {
        var x = l[f];
        for (var y in x) {
          var g = x[y];
          g != null && (r && (r += c), r += At(y + ":" + d + ft(g) + ";", a));
        }
      }
    else
      for (var E in l) {
        var v = l[E];
        v != null && (r && (r += c), r += At(E + ":" + d + ft(v) + ";", a));
      }
  for (var P in t) {
    var C = t[P];
    C != null && P !== "fallbacks" && (r && (r += c), r += At(P + ":" + d + ft(C) + ";", a));
  }
  return !r && !n.allowEmpty || !e ? r : (a--, r && (r = "" + c + r + c), At("" + e + d + "{" + r, a) + At("}", a));
}
var lp = /([[\].#*$><+~=|^:(),"'`\s])/g, hi = typeof CSS < "u" && CSS.escape, io = function(e) {
  return hi ? hi(e) : e.replace(lp, "\\$1");
}, Ws = /* @__PURE__ */ function() {
  function e(n, r, i) {
    this.type = "style", this.isProcessed = !1;
    var s = i.sheet, a = i.Renderer;
    this.key = n, this.options = i, this.style = r, s ? this.renderer = s.renderer : a && (this.renderer = new a());
  }
  var t = e.prototype;
  return t.prop = function(r, i, s) {
    if (i === void 0)
      return this.style[r];
    var a = s ? s.force : !1;
    if (!a && this.style[r] === i)
      return this;
    var l = i;
    (!s || s.process !== !1) && (l = this.options.jss.plugins.onChangeValue(i, r, this));
    var u = l == null || l === !1, c = r in this.style;
    if (u && !c && !a)
      return this;
    var d = u && c;
    if (d ? delete this.style[r] : this.style[r] = l, this.renderable && this.renderer)
      return d ? this.renderer.removeProperty(this.renderable, r) : this.renderer.setProperty(this.renderable, r, l), this;
    var f = this.options.sheet;
    return f && f.attached && process.env.NODE_ENV !== "production" && Le(!1, '[JSS] Rule is not linked. Missing sheet option "link: true".'), this;
  }, e;
}(), gr = /* @__PURE__ */ function(e) {
  Mn(t, e);
  function t(r, i, s) {
    var a;
    a = e.call(this, r, i, s) || this;
    var l = s.selector, u = s.scoped, c = s.sheet, d = s.generateId;
    return l ? a.selectorText = l : u !== !1 && (a.id = d(fr(fr(a)), c), a.selectorText = "." + io(a.id)), a;
  }
  var n = t.prototype;
  return n.applyTo = function(i) {
    var s = this.renderer;
    if (s) {
      var a = this.toJSON();
      for (var l in a)
        s.setProperty(i, l, a[l]);
    }
    return this;
  }, n.toJSON = function() {
    var i = {};
    for (var s in this.style) {
      var a = this.style[s];
      typeof a != "object" ? i[s] = a : Array.isArray(a) && (i[s] = ft(a));
    }
    return i;
  }, n.toString = function(i) {
    var s = this.options.sheet, a = s ? s.options.link : !1, l = a ? b({}, i, {
      allowEmpty: !0
    }) : i;
    return Zt(this.selectorText, this.style, l);
  }, Us(t, [{
    key: "selector",
    set: function(i) {
      if (i !== this.selectorText) {
        this.selectorText = i;
        var s = this.renderer, a = this.renderable;
        if (!(!a || !s)) {
          var l = s.setSelector(a, i);
          l || s.replaceRule(a, this);
        }
      }
    },
    get: function() {
      return this.selectorText;
    }
  }]), t;
}(Ws), up = {
  onCreateRule: function(t, n, r) {
    return t[0] === "@" || r.parent && r.parent.type === "keyframes" ? null : new gr(t, n, r);
  }
}, Yn = {
  indent: 1,
  children: !0
}, cp = /@([\w-]+)/, dp = /* @__PURE__ */ function() {
  function e(n, r, i) {
    this.type = "conditional", this.isProcessed = !1, this.key = n;
    var s = n.match(cp);
    this.at = s ? s[1] : "unknown", this.query = i.name || "@" + this.at, this.options = i, this.rules = new Bn(b({}, i, {
      parent: this
    }));
    for (var a in r)
      this.rules.add(a, r[a]);
    this.rules.process();
  }
  var t = e.prototype;
  return t.getRule = function(r) {
    return this.rules.get(r);
  }, t.indexOf = function(r) {
    return this.rules.indexOf(r);
  }, t.addRule = function(r, i, s) {
    var a = this.rules.add(r, i, s);
    return a ? (this.options.jss.plugins.onProcessRule(a), a) : null;
  }, t.replaceRule = function(r, i, s) {
    var a = this.rules.replace(r, i, s);
    return a && this.options.jss.plugins.onProcessRule(a), a;
  }, t.toString = function(r) {
    r === void 0 && (r = Yn);
    var i = $t(r), s = i.linebreak;
    if (r.indent == null && (r.indent = Yn.indent), r.children == null && (r.children = Yn.children), r.children === !1)
      return this.query + " {}";
    var a = this.rules.toString(r);
    return a ? this.query + " {" + s + a + s + "}" : "";
  }, e;
}(), fp = /@container|@media|@supports\s+/, pp = {
  onCreateRule: function(t, n, r) {
    return fp.test(t) ? new dp(t, n, r) : null;
  }
}, Kn = {
  indent: 1,
  children: !0
}, hp = /@keyframes\s+([\w-]+)/, br = /* @__PURE__ */ function() {
  function e(n, r, i) {
    this.type = "keyframes", this.at = "@keyframes", this.isProcessed = !1;
    var s = n.match(hp);
    s && s[1] ? this.name = s[1] : (this.name = "noname", process.env.NODE_ENV !== "production" && Le(!1, "[JSS] Bad keyframes name " + n)), this.key = this.type + "-" + this.name, this.options = i;
    var a = i.scoped, l = i.sheet, u = i.generateId;
    this.id = a === !1 ? this.name : io(u(this, l)), this.rules = new Bn(b({}, i, {
      parent: this
    }));
    for (var c in r)
      this.rules.add(c, r[c], b({}, i, {
        parent: this
      }));
    this.rules.process();
  }
  var t = e.prototype;
  return t.toString = function(r) {
    r === void 0 && (r = Kn);
    var i = $t(r), s = i.linebreak;
    if (r.indent == null && (r.indent = Kn.indent), r.children == null && (r.children = Kn.children), r.children === !1)
      return this.at + " " + this.id + " {}";
    var a = this.rules.toString(r);
    return a && (a = "" + s + a + s), this.at + " " + this.id + " {" + a + "}";
  }, e;
}(), mp = /@keyframes\s+/, vp = /\$([\w-]+)/g, xr = function(t, n) {
  return typeof t == "string" ? t.replace(vp, function(r, i) {
    return i in n ? n[i] : (process.env.NODE_ENV !== "production" && Le(!1, '[JSS] Referenced keyframes rule "' + i + '" is not defined.'), r);
  }) : t;
}, mi = function(t, n, r) {
  var i = t[n], s = xr(i, r);
  s !== i && (t[n] = s);
}, yp = {
  onCreateRule: function(t, n, r) {
    return typeof t == "string" && mp.test(t) ? new br(t, n, r) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function(t, n, r) {
    return n.type !== "style" || !r || ("animation-name" in t && mi(t, "animation-name", r.keyframes), "animation" in t && mi(t, "animation", r.keyframes)), t;
  },
  onChangeValue: function(t, n, r) {
    var i = r.options.sheet;
    if (!i)
      return t;
    switch (n) {
      case "animation":
        return xr(t, i.keyframes);
      case "animation-name":
        return xr(t, i.keyframes);
      default:
        return t;
    }
  }
}, gp = /* @__PURE__ */ function(e) {
  Mn(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var n = t.prototype;
  return n.toString = function(i) {
    var s = this.options.sheet, a = s ? s.options.link : !1, l = a ? b({}, i, {
      allowEmpty: !0
    }) : i;
    return Zt(this.key, this.style, l);
  }, t;
}(Ws), bp = {
  onCreateRule: function(t, n, r) {
    return r.parent && r.parent.type === "keyframes" ? new gp(t, n, r) : null;
  }
}, xp = /* @__PURE__ */ function() {
  function e(n, r, i) {
    this.type = "font-face", this.at = "@font-face", this.isProcessed = !1, this.key = n, this.style = r, this.options = i;
  }
  var t = e.prototype;
  return t.toString = function(r) {
    var i = $t(r), s = i.linebreak;
    if (Array.isArray(this.style)) {
      for (var a = "", l = 0; l < this.style.length; l++)
        a += Zt(this.at, this.style[l]), this.style[l + 1] && (a += s);
      return a;
    }
    return Zt(this.at, this.style, r);
  }, e;
}(), Ep = /@font-face/, Rp = {
  onCreateRule: function(t, n, r) {
    return Ep.test(t) ? new xp(t, n, r) : null;
  }
}, Sp = /* @__PURE__ */ function() {
  function e(n, r, i) {
    this.type = "viewport", this.at = "@viewport", this.isProcessed = !1, this.key = n, this.style = r, this.options = i;
  }
  var t = e.prototype;
  return t.toString = function(r) {
    return Zt(this.key, this.style, r);
  }, e;
}(), Pp = {
  onCreateRule: function(t, n, r) {
    return t === "@viewport" || t === "@-ms-viewport" ? new Sp(t, n, r) : null;
  }
}, Tp = /* @__PURE__ */ function() {
  function e(n, r, i) {
    this.type = "simple", this.isProcessed = !1, this.key = n, this.value = r, this.options = i;
  }
  var t = e.prototype;
  return t.toString = function(r) {
    if (Array.isArray(this.value)) {
      for (var i = "", s = 0; s < this.value.length; s++)
        i += this.key + " " + this.value[s] + ";", this.value[s + 1] && (i += `
`);
      return i;
    }
    return this.key + " " + this.value + ";";
  }, e;
}(), wp = {
  "@charset": !0,
  "@import": !0,
  "@namespace": !0
}, Cp = {
  onCreateRule: function(t, n, r) {
    return t in wp ? new Tp(t, n, r) : null;
  }
}, yi = [up, pp, yp, bp, Rp, Pp, Cp], Op = {
  process: !0
}, gi = {
  force: !0,
  process: !0
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */
}, Bn = /* @__PURE__ */ function() {
  function e(n) {
    this.map = {}, this.raw = {}, this.index = [], this.counter = 0, this.options = n, this.classes = n.classes, this.keyframes = n.keyframes;
  }
  var t = e.prototype;
  return t.add = function(r, i, s) {
    var a = this.options, l = a.parent, u = a.sheet, c = a.jss, d = a.Renderer, f = a.generateId, x = a.scoped, y = b({
      classes: this.classes,
      parent: l,
      sheet: u,
      jss: c,
      Renderer: d,
      generateId: f,
      scoped: x,
      name: r,
      keyframes: this.keyframes,
      selector: void 0
    }, s), g = r;
    r in this.raw && (g = r + "-d" + this.counter++), this.raw[g] = i, g in this.classes && (y.selector = "." + io(this.classes[g]));
    var E = oo(g, i, y);
    if (!E)
      return null;
    this.register(E);
    var v = y.index === void 0 ? this.index.length : y.index;
    return this.index.splice(v, 0, E), E;
  }, t.replace = function(r, i, s) {
    var a = this.get(r), l = this.index.indexOf(a);
    a && this.remove(a);
    var u = s;
    return l !== -1 && (u = b({}, s, {
      index: l
    })), this.add(r, i, u);
  }, t.get = function(r) {
    return this.map[r];
  }, t.remove = function(r) {
    this.unregister(r), delete this.raw[r.key], this.index.splice(this.index.indexOf(r), 1);
  }, t.indexOf = function(r) {
    return this.index.indexOf(r);
  }, t.process = function() {
    var r = this.options.jss.plugins;
    this.index.slice(0).forEach(r.onProcessRule, r);
  }, t.register = function(r) {
    this.map[r.key] = r, r instanceof gr ? (this.map[r.selector] = r, r.id && (this.classes[r.key] = r.id)) : r instanceof br && this.keyframes && (this.keyframes[r.name] = r.id);
  }, t.unregister = function(r) {
    delete this.map[r.key], r instanceof gr ? (delete this.map[r.selector], delete this.classes[r.key]) : r instanceof br && delete this.keyframes[r.name];
  }, t.update = function() {
    var r, i, s;
    if (typeof (arguments.length <= 0 ? void 0 : arguments[0]) == "string" ? (r = arguments.length <= 0 ? void 0 : arguments[0], i = arguments.length <= 1 ? void 0 : arguments[1], s = arguments.length <= 2 ? void 0 : arguments[2]) : (i = arguments.length <= 0 ? void 0 : arguments[0], s = arguments.length <= 1 ? void 0 : arguments[1], r = null), r)
      this.updateOne(this.get(r), i, s);
    else
      for (var a = 0; a < this.index.length; a++)
        this.updateOne(this.index[a], i, s);
  }, t.updateOne = function(r, i, s) {
    s === void 0 && (s = Op);
    var a = this.options, l = a.jss.plugins, u = a.sheet;
    if (r.rules instanceof e) {
      r.rules.update(i, s);
      return;
    }
    var c = r.style;
    if (l.onUpdate(i, r, u, s), s.process && c && c !== r.style) {
      l.onProcessStyle(r.style, r, u);
      for (var d in r.style) {
        var f = r.style[d], x = c[d];
        f !== x && r.prop(d, f, gi);
      }
      for (var y in c) {
        var g = r.style[y], E = c[y];
        g == null && g !== E && r.prop(y, null, gi);
      }
    }
  }, t.toString = function(r) {
    for (var i = "", s = this.options.sheet, a = s ? s.options.link : !1, l = $t(r), u = l.linebreak, c = 0; c < this.index.length; c++) {
      var d = this.index[c], f = d.toString(r);
      !f && !a || (i && (i += u), i += f);
    }
    return i;
  }, e;
}(), Hs = /* @__PURE__ */ function() {
  function e(n, r) {
    this.attached = !1, this.deployed = !1, this.classes = {}, this.keyframes = {}, this.options = b({}, r, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    }), r.Renderer && (this.renderer = new r.Renderer(this)), this.rules = new Bn(this.options);
    for (var i in n)
      this.rules.add(i, n[i]);
    this.rules.process();
  }
  var t = e.prototype;
  return t.attach = function() {
    return this.attached ? this : (this.renderer && this.renderer.attach(), this.attached = !0, this.deployed || this.deploy(), this);
  }, t.detach = function() {
    return this.attached ? (this.renderer && this.renderer.detach(), this.attached = !1, this) : this;
  }, t.addRule = function(r, i, s) {
    var a = this.queue;
    this.attached && !a && (this.queue = []);
    var l = this.rules.add(r, i, s);
    return l ? (this.options.jss.plugins.onProcessRule(l), this.attached ? (this.deployed && (a ? a.push(l) : (this.insertRule(l), this.queue && (this.queue.forEach(this.insertRule, this), this.queue = void 0))), l) : (this.deployed = !1, l)) : null;
  }, t.replaceRule = function(r, i, s) {
    var a = this.rules.get(r);
    if (!a)
      return this.addRule(r, i, s);
    var l = this.rules.replace(r, i, s);
    return l && this.options.jss.plugins.onProcessRule(l), this.attached ? (this.deployed && this.renderer && (l ? a.renderable && this.renderer.replaceRule(a.renderable, l) : this.renderer.deleteRule(a)), l) : (this.deployed = !1, l);
  }, t.insertRule = function(r) {
    this.renderer && this.renderer.insertRule(r);
  }, t.addRules = function(r, i) {
    var s = [];
    for (var a in r) {
      var l = this.addRule(a, r[a], i);
      l && s.push(l);
    }
    return s;
  }, t.getRule = function(r) {
    return this.rules.get(r);
  }, t.deleteRule = function(r) {
    var i = typeof r == "object" ? r : this.rules.get(r);
    return !i || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !i.renderable ? !1 : (this.rules.remove(i), this.attached && i.renderable && this.renderer ? this.renderer.deleteRule(i.renderable) : !0);
  }, t.indexOf = function(r) {
    return this.rules.indexOf(r);
  }, t.deploy = function() {
    return this.renderer && this.renderer.deploy(), this.deployed = !0, this;
  }, t.update = function() {
    var r;
    return (r = this.rules).update.apply(r, arguments), this;
  }, t.updateOne = function(r, i, s) {
    return this.rules.updateOne(r, i, s), this;
  }, t.toString = function(r) {
    return this.rules.toString(r);
  }, e;
}(), Np = /* @__PURE__ */ function() {
  function e() {
    this.plugins = {
      internal: [],
      external: []
    }, this.registry = {};
  }
  var t = e.prototype;
  return t.onCreateRule = function(r, i, s) {
    for (var a = 0; a < this.registry.onCreateRule.length; a++) {
      var l = this.registry.onCreateRule[a](r, i, s);
      if (l)
        return l;
    }
    return null;
  }, t.onProcessRule = function(r) {
    if (!r.isProcessed) {
      for (var i = r.options.sheet, s = 0; s < this.registry.onProcessRule.length; s++)
        this.registry.onProcessRule[s](r, i);
      r.style && this.onProcessStyle(r.style, r, i), r.isProcessed = !0;
    }
  }, t.onProcessStyle = function(r, i, s) {
    for (var a = 0; a < this.registry.onProcessStyle.length; a++)
      i.style = this.registry.onProcessStyle[a](i.style, i, s);
  }, t.onProcessSheet = function(r) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++)
      this.registry.onProcessSheet[i](r);
  }, t.onUpdate = function(r, i, s, a) {
    for (var l = 0; l < this.registry.onUpdate.length; l++)
      this.registry.onUpdate[l](r, i, s, a);
  }, t.onChangeValue = function(r, i, s) {
    for (var a = r, l = 0; l < this.registry.onChangeValue.length; l++)
      a = this.registry.onChangeValue[l](a, i, s);
    return a;
  }, t.use = function(r, i) {
    i === void 0 && (i = {
      queue: "external"
    });
    var s = this.plugins[i.queue];
    s.indexOf(r) === -1 && (s.push(r), this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(a, l) {
      for (var u in l)
        u in a ? a[u].push(l[u]) : process.env.NODE_ENV !== "production" && Le(!1, '[JSS] Unknown hook "' + u + '".');
      return a;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    }));
  }, e;
}(), $p = /* @__PURE__ */ function() {
  function e() {
    this.registry = [];
  }
  var t = e.prototype;
  return t.add = function(r) {
    var i = this.registry, s = r.options.index;
    if (i.indexOf(r) === -1) {
      if (i.length === 0 || s >= this.index) {
        i.push(r);
        return;
      }
      for (var a = 0; a < i.length; a++)
        if (i[a].options.index > s) {
          i.splice(a, 0, r);
          return;
        }
    }
  }, t.reset = function() {
    this.registry = [];
  }, t.remove = function(r) {
    var i = this.registry.indexOf(r);
    this.registry.splice(i, 1);
  }, t.toString = function(r) {
    for (var i = r === void 0 ? {} : r, s = i.attached, a = q(i, ["attached"]), l = $t(a), u = l.linebreak, c = "", d = 0; d < this.registry.length; d++) {
      var f = this.registry[d];
      s != null && f.attached !== s || (c && (c += u), c += f.toString(a));
    }
    return c;
  }, Us(e, [{
    key: "index",
    /**
     * Current highest index number.
     */
    get: function() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]), e;
}(), Wt = new $p(), Er = typeof globalThis < "u" ? globalThis : typeof window < "u" && window.Math === Math ? window : typeof self < "u" && self.Math === Math ? self : Function("return this")(), Rr = "2f1acc6c3a606b082e5eef5e54414ffb";
Er[Rr] == null && (Er[Rr] = 0);
var bi = Er[Rr]++, kp = 1e10, xi = function(t) {
  t === void 0 && (t = {});
  var n = 0, r = function(s, a) {
    n += 1, n > kp && process.env.NODE_ENV !== "production" && Le(!1, "[JSS] You might have a memory leak. Rule counter is at " + n + ".");
    var l = "", u = "";
    return a && (a.options.classNamePrefix && (u = a.options.classNamePrefix), a.options.jss.id != null && (l = String(a.options.jss.id))), t.minify ? "" + (u || "c") + bi + l + n : u + s.key + "-" + bi + (l ? "-" + l : "") + "-" + n;
  };
  return r;
}, qs = function(t) {
  var n;
  return function() {
    return n || (n = t()), n;
  };
}, Mp = function(t, n) {
  try {
    return t.attributeStyleMap ? t.attributeStyleMap.get(n) : t.style.getPropertyValue(n);
  } catch {
    return "";
  }
}, Ip = function(t, n, r) {
  try {
    var i = r;
    if (Array.isArray(r) && (i = ft(r)), t.attributeStyleMap)
      t.attributeStyleMap.set(n, i);
    else {
      var s = i ? i.indexOf("!important") : -1, a = s > -1 ? i.substr(0, s - 1) : i;
      t.style.setProperty(n, a, s > -1 ? "important" : "");
    }
  } catch {
    return !1;
  }
  return !0;
}, _p = function(t, n) {
  try {
    t.attributeStyleMap ? t.attributeStyleMap.delete(n) : t.style.removeProperty(n);
  } catch (r) {
    process.env.NODE_ENV !== "production" && Le(!1, '[JSS] DOMException "' + r.message + '" was thrown. Tried to remove property "' + n + '".');
  }
}, jp = function(t, n) {
  return t.selectorText = n, t.selectorText === n;
}, Ys = qs(function() {
  return document.querySelector("head");
});
function Ap(e, t) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    if (r.attached && r.options.index > t.index && r.options.insertionPoint === t.insertionPoint)
      return r;
  }
  return null;
}
function Dp(e, t) {
  for (var n = e.length - 1; n >= 0; n--) {
    var r = e[n];
    if (r.attached && r.options.insertionPoint === t.insertionPoint)
      return r;
  }
  return null;
}
function Fp(e) {
  for (var t = Ys(), n = 0; n < t.childNodes.length; n++) {
    var r = t.childNodes[n];
    if (r.nodeType === 8 && r.nodeValue.trim() === e)
      return r;
  }
  return null;
}
function Vp(e) {
  var t = Wt.registry;
  if (t.length > 0) {
    var n = Ap(t, e);
    if (n && n.renderer)
      return {
        parent: n.renderer.element.parentNode,
        node: n.renderer.element
      };
    if (n = Dp(t, e), n && n.renderer)
      return {
        parent: n.renderer.element.parentNode,
        node: n.renderer.element.nextSibling
      };
  }
  var r = e.insertionPoint;
  if (r && typeof r == "string") {
    var i = Fp(r);
    if (i)
      return {
        parent: i.parentNode,
        node: i.nextSibling
      };
    process.env.NODE_ENV !== "production" && Le(!1, '[JSS] Insertion point "' + r + '" not found.');
  }
  return !1;
}
function Lp(e, t) {
  var n = t.insertionPoint, r = Vp(t);
  if (r !== !1 && r.parent) {
    r.parent.insertBefore(e, r.node);
    return;
  }
  if (n && typeof n.nodeType == "number") {
    var i = n, s = i.parentNode;
    s ? s.insertBefore(e, i.nextSibling) : process.env.NODE_ENV !== "production" && Le(!1, "[JSS] Insertion point is not in the DOM.");
    return;
  }
  Ys().appendChild(e);
}
var Bp = qs(function() {
  var e = document.querySelector('meta[property="csp-nonce"]');
  return e ? e.getAttribute("content") : null;
}), Ei = function(t, n, r) {
  try {
    "insertRule" in t ? t.insertRule(n, r) : "appendRule" in t && t.appendRule(n);
  } catch (i) {
    return process.env.NODE_ENV !== "production" && Le(!1, "[JSS] " + i.message), !1;
  }
  return t.cssRules[r];
}, Ri = function(t, n) {
  var r = t.cssRules.length;
  return n === void 0 || n > r ? r : n;
}, zp = function() {
  var t = document.createElement("style");
  return t.textContent = `
`, t;
}, Up = /* @__PURE__ */ function() {
  function e(n) {
    this.getPropertyValue = Mp, this.setProperty = Ip, this.removeProperty = _p, this.setSelector = jp, this.hasInsertedRules = !1, this.cssRules = [], n && Wt.add(n), this.sheet = n;
    var r = this.sheet ? this.sheet.options : {}, i = r.media, s = r.meta, a = r.element;
    this.element = a || zp(), this.element.setAttribute("data-jss", ""), i && this.element.setAttribute("media", i), s && this.element.setAttribute("data-meta", s);
    var l = Bp();
    l && this.element.setAttribute("nonce", l);
  }
  var t = e.prototype;
  return t.attach = function() {
    if (!(this.element.parentNode || !this.sheet)) {
      Lp(this.element, this.sheet.options);
      var r = !!(this.sheet && this.sheet.deployed);
      this.hasInsertedRules && r && (this.hasInsertedRules = !1, this.deploy());
    }
  }, t.detach = function() {
    if (this.sheet) {
      var r = this.element.parentNode;
      r && r.removeChild(this.element), this.sheet.options.link && (this.cssRules = [], this.element.textContent = `
`);
    }
  }, t.deploy = function() {
    var r = this.sheet;
    if (r) {
      if (r.options.link) {
        this.insertRules(r.rules);
        return;
      }
      this.element.textContent = `
` + r.toString() + `
`;
    }
  }, t.insertRules = function(r, i) {
    for (var s = 0; s < r.index.length; s++)
      this.insertRule(r.index[s], s, i);
  }, t.insertRule = function(r, i, s) {
    if (s === void 0 && (s = this.element.sheet), r.rules) {
      var a = r, l = s;
      if (r.type === "conditional" || r.type === "keyframes") {
        var u = Ri(s, i);
        if (l = Ei(s, a.toString({
          children: !1
        }), u), l === !1)
          return !1;
        this.refCssRule(r, u, l);
      }
      return this.insertRules(a.rules, l), l;
    }
    var c = r.toString();
    if (!c)
      return !1;
    var d = Ri(s, i), f = Ei(s, c, d);
    return f === !1 ? !1 : (this.hasInsertedRules = !0, this.refCssRule(r, d, f), f);
  }, t.refCssRule = function(r, i, s) {
    r.renderable = s, r.options.parent instanceof Hs && this.cssRules.splice(i, 0, s);
  }, t.deleteRule = function(r) {
    var i = this.element.sheet, s = this.indexOf(r);
    return s === -1 ? !1 : (i.deleteRule(s), this.cssRules.splice(s, 1), !0);
  }, t.indexOf = function(r) {
    return this.cssRules.indexOf(r);
  }, t.replaceRule = function(r, i) {
    var s = this.indexOf(r);
    return s === -1 ? !1 : (this.element.sheet.deleteRule(s), this.cssRules.splice(s, 1), this.insertRule(i, s));
  }, t.getRules = function() {
    return this.element.sheet.cssRules;
  }, e;
}(), Wp = 0, Hp = /* @__PURE__ */ function() {
  function e(n) {
    this.id = Wp++, this.version = "10.10.0", this.plugins = new Np(), this.options = {
      id: {
        minify: !1
      },
      createGenerateId: xi,
      Renderer: rn ? Up : null,
      plugins: []
    }, this.generateId = xi({
      minify: !1
    });
    for (var r = 0; r < yi.length; r++)
      this.plugins.use(yi[r], {
        queue: "internal"
      });
    this.setup(n);
  }
  var t = e.prototype;
  return t.setup = function(r) {
    return r === void 0 && (r = {}), r.createGenerateId && (this.options.createGenerateId = r.createGenerateId), r.id && (this.options.id = b({}, this.options.id, r.id)), (r.createGenerateId || r.id) && (this.generateId = this.options.createGenerateId(this.options.id)), r.insertionPoint != null && (this.options.insertionPoint = r.insertionPoint), "Renderer" in r && (this.options.Renderer = r.Renderer), r.plugins && this.use.apply(this, r.plugins), this;
  }, t.createStyleSheet = function(r, i) {
    i === void 0 && (i = {});
    var s = i, a = s.index;
    typeof a != "number" && (a = Wt.index === 0 ? 0 : Wt.index + 1);
    var l = new Hs(r, b({}, i, {
      jss: this,
      generateId: i.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: a
    }));
    return this.plugins.onProcessSheet(l), l;
  }, t.removeStyleSheet = function(r) {
    return r.detach(), Wt.remove(r), this;
  }, t.createRule = function(r, i, s) {
    if (i === void 0 && (i = {}), s === void 0 && (s = {}), typeof r == "object")
      return this.createRule(void 0, r, i);
    var a = b({}, s, {
      name: r,
      jss: this,
      Renderer: this.options.Renderer
    });
    a.generateId || (a.generateId = this.generateId), a.classes || (a.classes = {}), a.keyframes || (a.keyframes = {});
    var l = oo(r, i, a);
    return l && this.plugins.onProcessRule(l), l;
  }, t.use = function() {
    for (var r = this, i = arguments.length, s = new Array(i), a = 0; a < i; a++)
      s[a] = arguments[a];
    return s.forEach(function(l) {
      r.plugins.use(l);
    }), this;
  }, e;
}(), so = function(t) {
  return new Hp(t);
}, ao = typeof CSS == "object" && CSS != null && "number" in CSS;
function Ks(e) {
  var t = null;
  for (var n in e) {
    var r = e[n], i = typeof r;
    if (i === "function")
      t || (t = {}), t[n] = r;
    else if (i === "object" && r !== null && !Array.isArray(r)) {
      var s = Ks(r);
      s && (t || (t = {}), t[n] = s);
    }
  }
  return t;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
so();
var Gs = Date.now(), Gn = "fnValues" + Gs, Xn = "fnStyle" + ++Gs, qp = function() {
  return {
    onCreateRule: function(n, r, i) {
      if (typeof r != "function")
        return null;
      var s = oo(n, {}, i);
      return s[Xn] = r, s;
    },
    onProcessStyle: function(n, r) {
      if (Gn in r || Xn in r)
        return n;
      var i = {};
      for (var s in n) {
        var a = n[s];
        typeof a == "function" && (delete n[s], i[s] = a);
      }
      return r[Gn] = i, n;
    },
    onUpdate: function(n, r, i, s) {
      var a = r, l = a[Xn];
      if (l && (a.style = l(n) || {}, process.env.NODE_ENV === "development")) {
        for (var u in a.style)
          if (typeof a.style[u] == "function") {
            process.env.NODE_ENV !== "production" && Le(!1, "[JSS] Function values inside function rules are not supported.");
            break;
          }
      }
      var c = a[Gn];
      if (c)
        for (var d in c)
          a.prop(d, c[d](n), s);
    }
  };
};
const Yp = qp;
var nt = "@global", Sr = "@global ", Kp = /* @__PURE__ */ function() {
  function e(n, r, i) {
    this.type = "global", this.at = nt, this.isProcessed = !1, this.key = n, this.options = i, this.rules = new Bn(b({}, i, {
      parent: this
    }));
    for (var s in r)
      this.rules.add(s, r[s]);
    this.rules.process();
  }
  var t = e.prototype;
  return t.getRule = function(r) {
    return this.rules.get(r);
  }, t.addRule = function(r, i, s) {
    var a = this.rules.add(r, i, s);
    return a && this.options.jss.plugins.onProcessRule(a), a;
  }, t.replaceRule = function(r, i, s) {
    var a = this.rules.replace(r, i, s);
    return a && this.options.jss.plugins.onProcessRule(a), a;
  }, t.indexOf = function(r) {
    return this.rules.indexOf(r);
  }, t.toString = function(r) {
    return this.rules.toString(r);
  }, e;
}(), Gp = /* @__PURE__ */ function() {
  function e(n, r, i) {
    this.type = "global", this.at = nt, this.isProcessed = !1, this.key = n, this.options = i;
    var s = n.substr(Sr.length);
    this.rule = i.jss.createRule(s, r, b({}, i, {
      parent: this
    }));
  }
  var t = e.prototype;
  return t.toString = function(r) {
    return this.rule ? this.rule.toString(r) : "";
  }, e;
}(), Xp = /\s*,\s*/g;
function Xs(e, t) {
  for (var n = e.split(Xp), r = "", i = 0; i < n.length; i++)
    r += t + " " + n[i].trim(), n[i + 1] && (r += ", ");
  return r;
}
function Jp(e, t) {
  var n = e.options, r = e.style, i = r ? r[nt] : null;
  if (i) {
    for (var s in i)
      t.addRule(s, i[s], b({}, n, {
        selector: Xs(s, e.selector)
      }));
    delete r[nt];
  }
}
function Zp(e, t) {
  var n = e.options, r = e.style;
  for (var i in r)
    if (!(i[0] !== "@" || i.substr(0, nt.length) !== nt)) {
      var s = Xs(i.substr(nt.length), e.selector);
      t.addRule(s, r[i], b({}, n, {
        selector: s
      })), delete r[i];
    }
}
function Qp() {
  function e(n, r, i) {
    if (!n)
      return null;
    if (n === nt)
      return new Kp(n, r, i);
    if (n[0] === "@" && n.substr(0, Sr.length) === Sr)
      return new Gp(n, r, i);
    var s = i.parent;
    return s && (s.type === "global" || s.options.parent && s.options.parent.type === "global") && (i.scoped = !1), !i.selector && i.scoped === !1 && (i.selector = n), null;
  }
  function t(n, r) {
    n.type !== "style" || !r || (Jp(n, r), Zp(n, r));
  }
  return {
    onCreateRule: e,
    onProcessRule: t
  };
}
var Si = /\s*,\s*/g, eh = /&/g, th = /\$([\w-]+)/g;
function nh() {
  function e(i, s) {
    return function(a, l) {
      var u = i.getRule(l) || s && s.getRule(l);
      return u ? u.selector : (process.env.NODE_ENV !== "production" && Le(!1, '[JSS] Could not find the referenced rule "' + l + '" in "' + (i.options.meta || i.toString()) + '".'), l);
    };
  }
  function t(i, s) {
    for (var a = s.split(Si), l = i.split(Si), u = "", c = 0; c < a.length; c++)
      for (var d = a[c], f = 0; f < l.length; f++) {
        var x = l[f];
        u && (u += ", "), u += x.indexOf("&") !== -1 ? x.replace(eh, d) : d + " " + x;
      }
    return u;
  }
  function n(i, s, a) {
    if (a)
      return b({}, a, {
        index: a.index + 1
      });
    var l = i.options.nestingLevel;
    l = l === void 0 ? 1 : l + 1;
    var u = b({}, i.options, {
      nestingLevel: l,
      index: s.indexOf(i) + 1
      // We don't need the parent name to be set options for chlid.
    });
    return delete u.name, u;
  }
  function r(i, s, a) {
    if (s.type !== "style")
      return i;
    var l = s, u = l.options.parent, c, d;
    for (var f in i) {
      var x = f.indexOf("&") !== -1, y = f[0] === "@";
      if (!(!x && !y)) {
        if (c = n(l, u, c), x) {
          var g = t(f, l.selector);
          d || (d = e(u, a)), g = g.replace(th, d);
          var E = l.key + "-" + f;
          "replaceRule" in u ? u.replaceRule(E, i[f], b({}, c, {
            selector: g
          })) : u.addRule(E, i[f], b({}, c, {
            selector: g
          }));
        } else
          y && u.addRule(f, {}, c).addRule(l.key, i[f], {
            selector: l.selector
          });
        delete i[f];
      }
    }
    return i;
  }
  return {
    onProcessStyle: r
  };
}
var rh = /[A-Z]/g, oh = /^ms-/, Jn = {};
function ih(e) {
  return "-" + e.toLowerCase();
}
function Js(e) {
  if (Jn.hasOwnProperty(e))
    return Jn[e];
  var t = e.replace(rh, ih);
  return Jn[e] = oh.test(t) ? "-" + t : t;
}
function Pn(e) {
  var t = {};
  for (var n in e) {
    var r = n.indexOf("--") === 0 ? n : Js(n);
    t[r] = e[n];
  }
  return e.fallbacks && (Array.isArray(e.fallbacks) ? t.fallbacks = e.fallbacks.map(Pn) : t.fallbacks = Pn(e.fallbacks)), t;
}
function sh() {
  function e(n) {
    if (Array.isArray(n)) {
      for (var r = 0; r < n.length; r++)
        n[r] = Pn(n[r]);
      return n;
    }
    return Pn(n);
  }
  function t(n, r, i) {
    if (r.indexOf("--") === 0)
      return n;
    var s = Js(r);
    return r === s ? n : (i.prop(s, n), null);
  }
  return {
    onProcessStyle: e,
    onChangeValue: t
  };
}
var T = ao && CSS ? CSS.px : "px", un = ao && CSS ? CSS.ms : "ms", xt = ao && CSS ? CSS.percent : "%", ah = {
  // Animation properties
  "animation-delay": un,
  "animation-duration": un,
  // Background properties
  "background-position": T,
  "background-position-x": T,
  "background-position-y": T,
  "background-size": T,
  // Border Properties
  border: T,
  "border-bottom": T,
  "border-bottom-left-radius": T,
  "border-bottom-right-radius": T,
  "border-bottom-width": T,
  "border-left": T,
  "border-left-width": T,
  "border-radius": T,
  "border-right": T,
  "border-right-width": T,
  "border-top": T,
  "border-top-left-radius": T,
  "border-top-right-radius": T,
  "border-top-width": T,
  "border-width": T,
  "border-block": T,
  "border-block-end": T,
  "border-block-end-width": T,
  "border-block-start": T,
  "border-block-start-width": T,
  "border-block-width": T,
  "border-inline": T,
  "border-inline-end": T,
  "border-inline-end-width": T,
  "border-inline-start": T,
  "border-inline-start-width": T,
  "border-inline-width": T,
  "border-start-start-radius": T,
  "border-start-end-radius": T,
  "border-end-start-radius": T,
  "border-end-end-radius": T,
  // Margin properties
  margin: T,
  "margin-bottom": T,
  "margin-left": T,
  "margin-right": T,
  "margin-top": T,
  "margin-block": T,
  "margin-block-end": T,
  "margin-block-start": T,
  "margin-inline": T,
  "margin-inline-end": T,
  "margin-inline-start": T,
  // Padding properties
  padding: T,
  "padding-bottom": T,
  "padding-left": T,
  "padding-right": T,
  "padding-top": T,
  "padding-block": T,
  "padding-block-end": T,
  "padding-block-start": T,
  "padding-inline": T,
  "padding-inline-end": T,
  "padding-inline-start": T,
  // Mask properties
  "mask-position-x": T,
  "mask-position-y": T,
  "mask-size": T,
  // Width and height properties
  height: T,
  width: T,
  "min-height": T,
  "max-height": T,
  "min-width": T,
  "max-width": T,
  // Position properties
  bottom: T,
  left: T,
  top: T,
  right: T,
  inset: T,
  "inset-block": T,
  "inset-block-end": T,
  "inset-block-start": T,
  "inset-inline": T,
  "inset-inline-end": T,
  "inset-inline-start": T,
  // Shadow properties
  "box-shadow": T,
  "text-shadow": T,
  // Column properties
  "column-gap": T,
  "column-rule": T,
  "column-rule-width": T,
  "column-width": T,
  // Font and text properties
  "font-size": T,
  "font-size-delta": T,
  "letter-spacing": T,
  "text-decoration-thickness": T,
  "text-indent": T,
  "text-stroke": T,
  "text-stroke-width": T,
  "word-spacing": T,
  // Motion properties
  motion: T,
  "motion-offset": T,
  // Outline properties
  outline: T,
  "outline-offset": T,
  "outline-width": T,
  // Perspective properties
  perspective: T,
  "perspective-origin-x": xt,
  "perspective-origin-y": xt,
  // Transform properties
  "transform-origin": xt,
  "transform-origin-x": xt,
  "transform-origin-y": xt,
  "transform-origin-z": xt,
  // Transition properties
  "transition-delay": un,
  "transition-duration": un,
  // Alignment properties
  "vertical-align": T,
  "flex-basis": T,
  // Some random properties
  "shape-margin": T,
  size: T,
  gap: T,
  // Grid properties
  grid: T,
  "grid-gap": T,
  "row-gap": T,
  "grid-row-gap": T,
  "grid-column-gap": T,
  "grid-template-rows": T,
  "grid-template-columns": T,
  "grid-auto-rows": T,
  "grid-auto-columns": T,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  "box-shadow-x": T,
  "box-shadow-y": T,
  "box-shadow-blur": T,
  "box-shadow-spread": T,
  "font-line-height": T,
  "text-shadow-x": T,
  "text-shadow-y": T,
  "text-shadow-blur": T
};
function Zs(e) {
  var t = /(-[a-z])/g, n = function(a) {
    return a[1].toUpperCase();
  }, r = {};
  for (var i in e)
    r[i] = e[i], r[i.replace(t, n)] = e[i];
  return r;
}
var lh = Zs(ah);
function Ht(e, t, n) {
  if (t == null)
    return t;
  if (Array.isArray(t))
    for (var r = 0; r < t.length; r++)
      t[r] = Ht(e, t[r], n);
  else if (typeof t == "object")
    if (e === "fallbacks")
      for (var i in t)
        t[i] = Ht(i, t[i], n);
    else
      for (var s in t)
        t[s] = Ht(e + "-" + s, t[s], n);
  else if (typeof t == "number" && isNaN(t) === !1) {
    var a = n[e] || lh[e];
    return a && !(t === 0 && a === T) ? typeof a == "function" ? a(t).toString() : "" + t + a : t.toString();
  }
  return t;
}
function uh(e) {
  e === void 0 && (e = {});
  var t = Zs(e);
  function n(i, s) {
    if (s.type !== "style")
      return i;
    for (var a in i)
      i[a] = Ht(a, i[a], t);
    return i;
  }
  function r(i, s) {
    return Ht(s, i, t);
  }
  return {
    onProcessStyle: n,
    onChangeValue: r
  };
}
function Pr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function ch(e) {
  if (Array.isArray(e))
    return Pr(e);
}
function dh(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function fh(e, t) {
  if (e) {
    if (typeof e == "string")
      return Pr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Pr(e, t) : void 0;
  }
}
function ph() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function hh(e) {
  return ch(e) || dh(e) || fh(e) || ph();
}
var Ft = "", Tr = "", Qs = "", ea = "", mh = rn && "ontouchstart" in document.documentElement;
if (rn) {
  var Zn = {
    Moz: "-moz-",
    ms: "-ms-",
    O: "-o-",
    Webkit: "-webkit-"
  }, vh = document.createElement("p"), Qn = vh.style, yh = "Transform";
  for (var er in Zn)
    if (er + yh in Qn) {
      Ft = er, Tr = Zn[er];
      break;
    }
  Ft === "Webkit" && "msHyphens" in Qn && (Ft = "ms", Tr = Zn.ms, ea = "edge"), Ft === "Webkit" && "-apple-trailing-word" in Qn && (Qs = "apple");
}
var Y = {
  js: Ft,
  css: Tr,
  vendor: Qs,
  browser: ea,
  isTouch: mh
};
function gh(e) {
  return e[1] === "-" || Y.js === "ms" ? e : "@" + Y.css + "keyframes" + e.substr(10);
}
var bh = {
  noPrefill: ["appearance"],
  supportedProperty: function(t) {
    return t !== "appearance" ? !1 : Y.js === "ms" ? "-webkit-" + t : Y.css + t;
  }
}, xh = {
  noPrefill: ["color-adjust"],
  supportedProperty: function(t) {
    return t !== "color-adjust" ? !1 : Y.js === "Webkit" ? Y.css + "print-" + t : t;
  }
}, Eh = /[-\s]+(.)?/g;
function Rh(e, t) {
  return t ? t.toUpperCase() : "";
}
function lo(e) {
  return e.replace(Eh, Rh);
}
function rt(e) {
  return lo("-" + e);
}
var Sh = {
  noPrefill: ["mask"],
  supportedProperty: function(t, n) {
    if (!/^mask/.test(t))
      return !1;
    if (Y.js === "Webkit") {
      var r = "mask-image";
      if (lo(r) in n)
        return t;
      if (Y.js + rt(r) in n)
        return Y.css + t;
    }
    return t;
  }
}, Ph = {
  noPrefill: ["text-orientation"],
  supportedProperty: function(t) {
    return t !== "text-orientation" ? !1 : Y.vendor === "apple" && !Y.isTouch ? Y.css + t : t;
  }
}, Th = {
  noPrefill: ["transform"],
  supportedProperty: function(t, n, r) {
    return t !== "transform" ? !1 : r.transform ? t : Y.css + t;
  }
}, wh = {
  noPrefill: ["transition"],
  supportedProperty: function(t, n, r) {
    return t !== "transition" ? !1 : r.transition ? t : Y.css + t;
  }
}, Ch = {
  noPrefill: ["writing-mode"],
  supportedProperty: function(t) {
    return t !== "writing-mode" ? !1 : Y.js === "Webkit" || Y.js === "ms" && Y.browser !== "edge" ? Y.css + t : t;
  }
}, Oh = {
  noPrefill: ["user-select"],
  supportedProperty: function(t) {
    return t !== "user-select" ? !1 : Y.js === "Moz" || Y.js === "ms" || Y.vendor === "apple" ? Y.css + t : t;
  }
}, Nh = {
  supportedProperty: function(t, n) {
    if (!/^break-/.test(t))
      return !1;
    if (Y.js === "Webkit") {
      var r = "WebkitColumn" + rt(t);
      return r in n ? Y.css + "column-" + t : !1;
    }
    if (Y.js === "Moz") {
      var i = "page" + rt(t);
      return i in n ? "page-" + t : !1;
    }
    return !1;
  }
}, $h = {
  supportedProperty: function(t, n) {
    if (!/^(border|margin|padding)-inline/.test(t))
      return !1;
    if (Y.js === "Moz")
      return t;
    var r = t.replace("-inline", "");
    return Y.js + rt(r) in n ? Y.css + r : !1;
  }
}, kh = {
  supportedProperty: function(t, n) {
    return lo(t) in n ? t : !1;
  }
}, Mh = {
  supportedProperty: function(t, n) {
    var r = rt(t);
    return t[0] === "-" || t[0] === "-" && t[1] === "-" ? t : Y.js + r in n ? Y.css + t : Y.js !== "Webkit" && "Webkit" + r in n ? "-webkit-" + t : !1;
  }
}, Ih = {
  supportedProperty: function(t) {
    return t.substring(0, 11) !== "scroll-snap" ? !1 : Y.js === "ms" ? "" + Y.css + t : t;
  }
}, _h = {
  supportedProperty: function(t) {
    return t !== "overscroll-behavior" ? !1 : Y.js === "ms" ? Y.css + "scroll-chaining" : t;
  }
}, jh = {
  "flex-grow": "flex-positive",
  "flex-shrink": "flex-negative",
  "flex-basis": "flex-preferred-size",
  "justify-content": "flex-pack",
  order: "flex-order",
  "align-items": "flex-align",
  "align-content": "flex-line-pack"
  // 'align-self' is handled by 'align-self' plugin.
}, Ah = {
  supportedProperty: function(t, n) {
    var r = jh[t];
    return r && Y.js + rt(r) in n ? Y.css + r : !1;
  }
}, ta = {
  flex: "box-flex",
  "flex-grow": "box-flex",
  "flex-direction": ["box-orient", "box-direction"],
  order: "box-ordinal-group",
  "align-items": "box-align",
  "flex-flow": ["box-orient", "box-direction"],
  "justify-content": "box-pack"
}, Dh = Object.keys(ta), Fh = function(t) {
  return Y.css + t;
}, Vh = {
  supportedProperty: function(t, n, r) {
    var i = r.multiple;
    if (Dh.indexOf(t) > -1) {
      var s = ta[t];
      if (!Array.isArray(s))
        return Y.js + rt(s) in n ? Y.css + s : !1;
      if (!i)
        return !1;
      for (var a = 0; a < s.length; a++)
        if (!(Y.js + rt(s[0]) in n))
          return !1;
      return s.map(Fh);
    }
    return !1;
  }
}, na = [bh, xh, Sh, Ph, Th, wh, Ch, Oh, Nh, $h, kh, Mh, Ih, _h, Ah, Vh], Pi = na.filter(function(e) {
  return e.supportedProperty;
}).map(function(e) {
  return e.supportedProperty;
}), Lh = na.filter(function(e) {
  return e.noPrefill;
}).reduce(function(e, t) {
  return e.push.apply(e, hh(t.noPrefill)), e;
}, []), Vt, ut = {};
if (rn) {
  Vt = document.createElement("p");
  var tr = window.getComputedStyle(document.documentElement, "");
  for (var nr in tr)
    isNaN(nr) || (ut[tr[nr]] = tr[nr]);
  Lh.forEach(function(e) {
    return delete ut[e];
  });
}
function wr(e, t) {
  if (t === void 0 && (t = {}), !Vt)
    return e;
  if (process.env.NODE_ENV !== "benchmark" && ut[e] != null)
    return ut[e];
  (e === "transition" || e === "transform") && (t[e] = e in Vt.style);
  for (var n = 0; n < Pi.length && (ut[e] = Pi[n](e, Vt.style, t), !ut[e]); n++)
    ;
  try {
    Vt.style[e] = "";
  } catch {
    return !1;
  }
  return ut[e];
}
var Et = {}, Bh = {
  transition: 1,
  "transition-property": 1,
  "-webkit-transition": 1,
  "-webkit-transition-property": 1
}, zh = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g, tt;
function Uh(e, t, n) {
  if (t === "var")
    return "var";
  if (t === "all")
    return "all";
  if (n === "all")
    return ", all";
  var r = t ? wr(t) : ", " + wr(n);
  return r || t || n;
}
rn && (tt = document.createElement("p"));
function Ti(e, t) {
  var n = t;
  if (!tt || e === "content")
    return t;
  if (typeof n != "string" || !isNaN(parseInt(n, 10)))
    return n;
  var r = e + n;
  if (process.env.NODE_ENV !== "benchmark" && Et[r] != null)
    return Et[r];
  try {
    tt.style[e] = n;
  } catch {
    return Et[r] = !1, !1;
  }
  if (Bh[e])
    n = n.replace(zh, Uh);
  else if (tt.style[e] === "" && (n = Y.css + n, n === "-ms-flex" && (tt.style[e] = "-ms-flexbox"), tt.style[e] = n, tt.style[e] === ""))
    return Et[r] = !1, !1;
  return tt.style[e] = "", Et[r] = n, Et[r];
}
function Wh() {
  function e(i) {
    if (i.type === "keyframes") {
      var s = i;
      s.at = gh(s.at);
    }
  }
  function t(i) {
    for (var s in i) {
      var a = i[s];
      if (s === "fallbacks" && Array.isArray(a)) {
        i[s] = a.map(t);
        continue;
      }
      var l = !1, u = wr(s);
      u && u !== s && (l = !0);
      var c = !1, d = Ti(u, ft(a));
      d && d !== a && (c = !0), (l || c) && (l && delete i[s], i[u || s] = d || a);
    }
    return i;
  }
  function n(i, s) {
    return s.type !== "style" ? i : t(i);
  }
  function r(i, s) {
    return Ti(s, ft(i)) || i;
  }
  return {
    onProcessRule: e,
    onProcessStyle: n,
    onChangeValue: r
  };
}
function Hh() {
  var e = function(n, r) {
    return n.length === r.length ? n > r ? 1 : -1 : n.length - r.length;
  };
  return {
    onProcessStyle: function(n, r) {
      if (r.type !== "style")
        return n;
      for (var i = {}, s = Object.keys(n).sort(e), a = 0; a < s.length; a++)
        i[s[a]] = n[s[a]];
      return i;
    }
  };
}
function ra() {
  return {
    plugins: [
      Yp(),
      Qp(),
      nh(),
      sh(),
      uh(),
      // Disable the vendor prefixer server-side, it does nothing.
      // This way, we can get a performance boost.
      // In the documentation, we are using `autoprefixer` to solve this problem.
      typeof window > "u" ? null : Wh(),
      Hh()
    ]
  };
}
function oa(e = {}) {
  const {
    baseClasses: t,
    newClasses: n,
    Component: r
  } = e;
  if (!n)
    return t;
  const i = b({}, t);
  return process.env.NODE_ENV !== "production" && typeof n == "string" ? (console.error([`MUI: The value \`${n}\` provided to the classes prop of ${pn(r)} is incorrect.`, "You might want to use the className prop instead."].join(`
`)), t) : (Object.keys(n).forEach((s) => {
    process.env.NODE_ENV !== "production" && (!t[s] && n[s] && console.error([`MUI: The key \`${s}\` provided to the classes prop is not implemented in ${pn(r)}.`, `You can only override one of the following: ${Object.keys(t).join(",")}.`].join(`
`)), n[s] && typeof n[s] != "string" && console.error([`MUI: The key \`${s}\` provided to the classes prop is not valid for ${pn(r)}.`, `You need to provide a non empty string instead of: ${n[s]}.`].join(`
`))), n[s] && (i[s] = `${t[s]} ${n[s]}`);
  }), i);
}
const qh = {
  set: (e, t, n, r) => {
    let i = e.get(t);
    i || (i = /* @__PURE__ */ new Map(), e.set(t, i)), i.set(n, r);
  },
  get: (e, t, n) => {
    const r = e.get(t);
    return r ? r.get(n) : void 0;
  },
  delete: (e, t, n) => {
    e.get(t).delete(n);
  }
}, Pt = qh;
function Yh() {
  var e;
  const t = fa();
  return (e = t == null ? void 0 : t.$$material) != null ? e : t;
}
const Kh = ["children", "injectFirst", "disableGeneration"], Gh = so(ra()), Xh = ip(), Jh = /* @__PURE__ */ new Map(), Zh = {
  disableGeneration: !1,
  generateClassName: Xh,
  jss: Gh,
  sheetsCache: null,
  sheetsManager: Jh,
  sheetsRegistry: null
}, Tn = /* @__PURE__ */ h.createContext(Zh);
process.env.NODE_ENV !== "production" && (Tn.displayName = "StylesContext");
let cn;
function Cr(e) {
  const {
    children: t,
    injectFirst: n = !1,
    disableGeneration: r = !1
  } = e, i = q(e, Kh), s = h.useContext(Tn), {
    generateClassName: a,
    jss: l,
    serverGenerateClassName: u,
    sheetsCache: c,
    sheetsManager: d,
    sheetsRegistry: f
  } = b({}, s, i);
  process.env.NODE_ENV !== "production" && n && i.jss && console.error("MUI: You cannot use the jss and injectFirst props at the same time.");
  const x = h.useMemo(() => {
    const y = {
      disableGeneration: r,
      generateClassName: a,
      jss: l,
      serverGenerateClassName: u,
      sheetsCache: c,
      sheetsManager: d,
      sheetsRegistry: f
    };
    if (process.env.NODE_ENV !== "production" && typeof window > "u" && !y.sheetsManager && console.error("MUI: You need to use the ServerStyleSheets API when rendering on the server."), process.env.NODE_ENV !== "production" && y.jss.options.insertionPoint && n && console.error("MUI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time."), !y.jss.options.insertionPoint && n && typeof window < "u") {
      if (!cn) {
        const g = document.head;
        cn = document.createComment("mui-inject-first"), g.insertBefore(cn, g.firstChild);
      }
      y.jss = so({
        plugins: ra().plugins,
        insertionPoint: cn
      });
    }
    return y;
  }, [n, r, a, l, u, c, d, f]);
  return /* @__PURE__ */ B(Tn.Provider, {
    value: x,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (Cr.propTypes = {
  /**
   * Your component tree.
   */
  children: o.node,
  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: o.bool,
  /**
   * JSS's class name generator.
   */
  generateClassName: o.func,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: o.bool,
  /**
   * JSS's instance.
   */
  jss: o.object,
  /**
   * @ignore
   */
  serverGenerateClassName: o.func,
  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: o.object,
  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: o.object,
  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: o.object
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Cr.propTypes = kr(Cr.propTypes));
let rr = -1e9;
function Qh() {
  return rr += 1, process.env.NODE_ENV !== "production" && rr >= 0 && console.warn(["MUI: You might have a memory leak.", "The indexCounter is not supposed to grow that much."].join(`
`)), rr;
}
const em = ["variant"];
function wi(e) {
  return e.length === 0;
}
function tm(e) {
  const {
    variant: t
  } = e, n = q(e, em);
  let r = t || "";
  return Object.keys(n).sort().forEach((i) => {
    i === "color" ? r += wi(r) ? e[i] : fe(e[i]) : r += `${wi(r) ? i : fe(i)}${fe(e[i].toString())}`;
  }), r;
}
const nm = {}, ia = nm;
function rm(e) {
  const t = typeof e == "function";
  return process.env.NODE_ENV !== "production" && typeof e != "object" && !t && console.error(["MUI: The `styles` argument provided is invalid.", "You need to provide a function generating the styles or a styles object."].join(`
`)), {
    create: (n, r) => {
      let i;
      try {
        i = t ? e(n) : e;
      } catch (u) {
        throw process.env.NODE_ENV !== "production" && t === !0 && n === ia && console.error(["MUI: The `styles` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`)), u;
      }
      if (!r || !n.components || !n.components[r] || !n.components[r].styleOverrides && !n.components[r].variants)
        return i;
      const s = n.components[r].styleOverrides || {}, a = n.components[r].variants || [], l = b({}, i);
      return Object.keys(s).forEach((u) => {
        process.env.NODE_ENV !== "production" && (l[u] || console.warn(["MUI: You are trying to override a style that does not exist.", `Fix the \`${u}\` key of \`theme.components.${r}.styleOverrides\`.`, "", `If you intentionally wanted to add a new key, please use the theme.components[${r}].variants option.`].join(`
`))), l[u] = qt(l[u] || {}, s[u]);
      }), a.forEach((u) => {
        const c = tm(u.props);
        l[c] = qt(l[c] || {}, u.style);
      }), l;
    },
    options: {}
  };
}
const om = ["name", "classNamePrefix", "Component", "defaultTheme"];
function im({
  state: e,
  stylesOptions: t
}, n, r) {
  if (t.disableGeneration)
    return n || {};
  e.cacheClasses || (e.cacheClasses = {
    // Cache for the finalized classes value.
    value: null,
    // Cache for the last used classes prop pointer.
    lastProp: null,
    // Cache for the last used rendered classes pointer.
    lastJSS: {}
  });
  let i = !1;
  return e.classes !== e.cacheClasses.lastJSS && (e.cacheClasses.lastJSS = e.classes, i = !0), n !== e.cacheClasses.lastProp && (e.cacheClasses.lastProp = n, i = !0), i && (e.cacheClasses.value = oa({
    baseClasses: e.cacheClasses.lastJSS,
    newClasses: n,
    Component: r
  })), e.cacheClasses.value;
}
function sm({
  state: e,
  theme: t,
  stylesOptions: n,
  stylesCreator: r,
  name: i
}, s) {
  if (n.disableGeneration)
    return;
  let a = Pt.get(n.sheetsManager, r, t);
  a || (a = {
    refs: 0,
    staticSheet: null,
    dynamicStyles: null
  }, Pt.set(n.sheetsManager, r, t, a));
  const l = b({}, r.options, n, {
    theme: t,
    flip: typeof n.flip == "boolean" ? n.flip : t.direction === "rtl"
  });
  l.generateId = l.serverGenerateClassName || l.generateClassName;
  const u = n.sheetsRegistry;
  if (a.refs === 0) {
    let c;
    n.sheetsCache && (c = Pt.get(n.sheetsCache, r, t));
    const d = r.create(t, i);
    c || (c = n.jss.createStyleSheet(d, b({
      link: !1
    }, l)), c.attach(), n.sheetsCache && Pt.set(n.sheetsCache, r, t, c)), u && u.add(c), a.staticSheet = c, a.dynamicStyles = Ks(d);
  }
  if (a.dynamicStyles) {
    const c = n.jss.createStyleSheet(a.dynamicStyles, b({
      link: !0
    }, l));
    c.update(s), c.attach(), e.dynamicSheet = c, e.classes = oa({
      baseClasses: a.staticSheet.classes,
      newClasses: c.classes
    }), u && u.add(c);
  } else
    e.classes = a.staticSheet.classes;
  a.refs += 1;
}
function am({
  state: e
}, t) {
  e.dynamicSheet && e.dynamicSheet.update(t);
}
function lm({
  state: e,
  theme: t,
  stylesOptions: n,
  stylesCreator: r
}) {
  if (n.disableGeneration)
    return;
  const i = Pt.get(n.sheetsManager, r, t);
  i.refs -= 1;
  const s = n.sheetsRegistry;
  i.refs === 0 && (Pt.delete(n.sheetsManager, r, t), n.jss.removeStyleSheet(i.staticSheet), s && s.remove(i.staticSheet)), e.dynamicSheet && (n.jss.removeStyleSheet(e.dynamicSheet), s && s.remove(e.dynamicSheet));
}
function um(e, t) {
  const n = h.useRef([]);
  let r;
  const i = h.useMemo(() => ({}), t);
  n.current !== i && (n.current = i, r = e()), h.useEffect(
    () => () => {
      r && r();
    },
    [i]
    // eslint-disable-line react-hooks/exhaustive-deps
  );
}
function Tm(e, t = {}) {
  const {
    // alias for classNamePrefix, if provided will listen to theme (required for theme.components[name].styleOverrides)
    name: n,
    // Help with debuggability.
    classNamePrefix: r,
    Component: i,
    defaultTheme: s = ia
  } = t, a = q(t, om), l = rm(e), u = n || r || "makeStyles";
  return l.options = {
    index: Qh(),
    name: n,
    meta: u,
    classNamePrefix: u
  }, (d = {}) => {
    const f = Yh() || s, x = b({}, h.useContext(Tn), a), y = h.useRef(), g = h.useRef();
    um(() => {
      const v = {
        name: n,
        state: {},
        stylesCreator: l,
        stylesOptions: x,
        theme: f
      };
      return sm(v, d), g.current = !1, y.current = v, () => {
        lm(v);
      };
    }, [f, l]), h.useEffect(() => {
      g.current && am(y.current, d), g.current = !0;
    });
    const E = im(y.current, d.classes, i);
    return process.env.NODE_ENV !== "production" && h.useDebugValue(E), process.env.NODE_ENV !== "production" && n && ["MuiAvatar", "MuiBadge", "MuiButton", "MuiButtonGroup", "MuiChip", "MuiDivider", "MuiFab", "MuiPaper", "MuiToolbar", "MuiTypography", "MuiAlert", "MuiPagination", "MuiPaginationItem", "MuiSkeleton", "MuiTimelineDot"].indexOf(n) >= 0 && d.variant && !E[d.variant] && console.error([`MUI: You are using a variant value \`${d.variant}\` for which you didn't define styles.`, "Please create a new variant matcher in your theme for this variant. To learn more about matchers visit https://mui.com/r/custom-component-variants."].join(`
`)), E;
  };
}
const wm = Fr(/* @__PURE__ */ B("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), "Search");
export {
  Wi as $,
  Hl as A,
  au as B,
  gm as C,
  Xe as D,
  $e as E,
  ls as F,
  Gd as G,
  en as H,
  Ar as I,
  xn as J,
  wl as K,
  tf as L,
  ym as M,
  ht as N,
  ot as O,
  xm as P,
  pn as Q,
  vm as R,
  Yh as S,
  bm as T,
  mm as U,
  ir as V,
  It as W,
  Nt as X,
  Qe as Y,
  st as Z,
  gd as _,
  Se as a,
  Em as a0,
  Ps as a1,
  Rs as a2,
  Gr as a3,
  Kr as a4,
  Pm as a5,
  Ye as a6,
  ef as a7,
  qd as a8,
  zf as a9,
  wm as aa,
  Sm as ab,
  Yt as ac,
  Io as ad,
  Xr as ae,
  wf as af,
  vf as ag,
  wd as ah,
  Bd as ai,
  Ed as aj,
  Li as ak,
  pt as al,
  Ge as am,
  ts as an,
  mo as ao,
  kn as b,
  ae as c,
  go as d,
  Sa as e,
  St as f,
  Ee as g,
  ka as h,
  Ce as i,
  xu as j,
  Cn as k,
  xl as l,
  Rl as m,
  Nn as n,
  Zi as o,
  hm as p,
  Hi as q,
  vt as r,
  G as s,
  Tm as t,
  Pe as u,
  Rm as v,
  es as w,
  Mr as x,
  bn as y,
  Fr as z
};
//# sourceMappingURL=Search-4d6031ad.js.map
